/* Editor
* + init()
* + elementFactory(htmlObj)
* + select(Element)
* + unselect()
* + duplicate()
*
* Sidebar
* + load
* + renderAttribute
*
*/

import { i18n } from "dateformat";
import {
    base64Encode,
    base64Decode,
    getVendorAndEmailFromCookies,
    getEmailFromVendorCookies,
    checkJwtTokenCookieExists,
    isUserLoggedIn,
    getEmailPrefixWithVendorFromCookies,
    getVendorFromCookies,
    getInitialFromCookies,
    getFolderIdFromCookies
} from '../lib/custom/js/utilfunctions.js';

// import paymentDialog from "../lib/custom/js/paymentdialog";
// Load the Web Worker

const generateResumeVerificationSuccess = "generateResumeVerificationSuccess";
const generateCoverLetterVerificationSuccess = "generateCoverLetterVerificationSuccess";
const pdfExportVerificationSuccess = "pdfExportVerificationSuccess";
const userTemplateAccessSuccess = "userTemplateAccessSuccess";
const saveVerificationSuccess = "saveVerificationSuccess";
const saveVerificationSuccessGoBack = "saveVerificationSuccessGoBack";
const generateFromTemplateVerificationSuccess = "generateFromTemplateVerificationSuccess";
const saveAsVerificationSuccess = "saveAsVerificationSuccess";
const renameVerificationSuccess = "renameVerificationSuccess";
const pdfPreviewVerificationSuccess = "pdfPreviewVerificationSuccess";
const checkoutPreviewDirectSuccess = "checkoutPreviewDirectSuccess";
const openBrowseVerificationSuccess = "openBrowseVerificationSuccess";
const openFileUploadVerificationSuccess = "openFileUploadVerificationSuccess";
const openLinkedInVerificationSuccess = "openLinkedInVerificationSuccess";
const defaultFunctionsAccessSuccess = "defaultFunctionsAccessSuccess";
const fangCompanies = ["Facebook", "Apple", "Amazon", "Netflix", "Google", "Meta", "Alphabet", "Microsoft"];
const FILE_UPLOAD_KEY = "fileData";
const EXISTING_FILES_KEY = "browse_files"; // Correct definition
let desktop = window.innerWidth > 1260;
let actionInProgress = null;
let secondsElapsed = 0;
let timerInterval;
let initHistoryState = null;
let caretListeners = []; // Array to store event listener references
let caretMarker = null;
let orientationChangeListener;
let customCaretImplementation = null;
let cachedCaretPosition = { x: 0, y: 0 };
let selectedMainElement;
const minimumMobileCtxBarScale = 0.5;
const isHoverable = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
const mobileUndoRedoListeners = [];
const ctxbarListeners = [];
let defaultContextMenuListener = [];
let initialCaretPosition = null;
let currentFileName = null;
let saveIntervalID;
let themeChanged = false;
let resizeTimeout;
let fang = false;
const signedCookiesLocks = new Map();


const errorMessagesForUrlProcessing = {
    "Failed to read the url": {
        title: () => getI18n('urlReadError'),
        html: () => getI18n('unableToReadUrl') +
            '<br><br>' +
            getI18n('copyPasteJobDescription') +
            '<br><br><span id="show-more-examples" class="link-style">' +
            getI18n('whereToFindJobPosting') + '</span>',
    },
    "No job description ErrCode:22134587": {
        title: () => getI18n('noJobDescription'),
        html: () => getI18n('unableToRetrieveJobDescription') +
            '<br><br>' +
            getI18n('copyPasteJobDescription') +
            '<br><br><span id="show-more-examples" class="link-style">' +
            getI18n('whereToFindJobPosting') + '</span>',
    },
    "Invalid job listing URL": {
        title: () => getI18n('invalidJobListing'),
        html: () => getI18n('invalidJobListingMessage'),
    },
};





let onLoadTriggered = false; // Shared flag to prevent double execution




let isDrawing = false;

let longPressTimer = null;
let touchStartX = 0;
let touchStartY = 0;
let isScrolling = false;


let iframeDoc = null;


const vp = window.visualViewport;
var gscale = 1.0;
var mainContentScrollTop = 0;
var mainContentScrollLeft = 0;
var loginPopup;
const googleVendor = 'google';
const directVendor = 'direct';
const appleVendor = 'apple';

let initialScrollPosition = window.scrollY;
let lastScrollPosition = null;
let previousWidth = window.innerWidth;
let lastBreakpoint = null; // Track the last breakpoint state (<1260 or >=1260)

let initialScale = 1.0;
let lastState = ''; // Variable to store the last state
let defaultScaleFactor = 1;
let adjustedScaleFactor = 1;
let lastZoomLevel = window.visualViewport.scale; // Store the last zoom level
//const zoomThreshold = 0.005; // Set a threshold for zoom changes
const zoomThreshold = 0; // Set a threshold for zoom changes
let currentScale = window.visualViewport?.scale;

let touchX = 0;
let touchY = 0;

let ctxIsCollapsed = false;
let lastPosition = { left: 0, top: 0 }; // Track last position

// Context Bar Functionality
const X_OFFSET = 0; // Horizontal offset
const Y_OFFSET_TOP = 35; // Vertical offset when the bar is above the cursor
const Y_OFFSET_BOTTOM = 35; // Vertical offset when the bar is below the cursor




function getFileData(fileName) {
    const data = createUpdateFilesEvents.getData(); // Retrieve JSON data from localStorage
    if (!Array.isArray(data)) {
        console.error("Data is not an array.");
        return null;
    }

    // Remove .html from fileName if present
    const cleanFileName = fileName.replace(/\.html$/, "");

    // Find the object with the matching cleaned fileName
    const fileData = data.find(item => item.fileName === cleanFileName);

    if (fileData) {
        return fileData;
    } else {
        console.log("File not found:", cleanFileName);
        return null;
    }
}


function initializeOrientationChangeListener() {
    orientationChangeListener = () => {
        setCustomTimeout(() => {
            thisEditor.scaleEditorToFit();
        }, 300); // Delay to ensure dimensions are updated
    };
    window.addEventListener('orientationchange', orientationChangeListener);
}
function cleanupOrientationChangeListener() {
    if (orientationChangeListener) {
        window.removeEventListener('orientationchange', orientationChangeListener);
        orientationChangeListener = null;
    }
}


function loadCSS(url) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = url;

    // Optional: Add an onload or onerror listener
    link.onload = () => console.log(`CSS loaded: ${url}`);
    link.onerror = () => console.error(`Failed to load CSS: ${url}`);

    document.head.appendChild(link);
}

function startTimer() {
    // Reset the timer
    secondsElapsed = 0;
    if ($('#timerText'))
        $('#timerText').text(`${secondsElapsed} ${getI18n('secondsabbr')}`);
    // Clear any existing interval to prevent duplicate intervals
    clearInterval(timerInterval);

    // Update the timer every second
    timerInterval = setInterval(() => {
        secondsElapsed++;
        if ($('#timerText'))
            $('#timerText').text(`${secondsElapsed} ${getI18n('secondsabbr')}`);
    }, 1000);
}

function unmakeAndRestoreSubmitButton() {
    $('#generateresume-arrowimage').show(); // Hide the arrow
    $('#generateresume-circlespinner').hide(); // Show the spinner
    $('.chatgptbox-submit').prop('disabled', false); // Disable the button
    thisEditor.unmask();
}

function stopTimer() {
    clearInterval(timerInterval);
}


// Function to deflate and encode the content
function deflateAndEncode(content) {
    // Use pako to deflate the string content
    const deflatedContent = pako.deflate(content, { to: 'string' });

    // Encode the deflated content with btoa
    return btoa(deflatedContent);
}

// Function to safely decode Base64 and inflate using Pako
function decodeAndInflate(encodedContent) {
    try {
        if (!encodedContent || typeof encodedContent !== "string") {
            throw new Error("Invalid Base64 input: Empty or non-string value.");
        }

        // Normalize Base64 padding
        const normalizedBase64 = encodedContent.replace(/-/g, "+").replace(/_/g, "/");

        // Decode Base64 (Works for both browser & Node.js)
        const binaryData = typeof window !== "undefined"
            ? Uint8Array.from(atob(normalizedBase64), c => c.charCodeAt(0))
            : Uint8Array.from(Buffer.from(normalizedBase64, "base64"));

        // Inflate using Pako
        const inflatedContent = new TextDecoder().decode(pako.inflate(binaryData));

        return inflatedContent;
    } catch (error) {
        console.error("❌ Error decoding and inflating content:", error);
        throw new Error("Failed to decode and inflate content.");
    }
}




function cleanupContextBarListeners() {
    // Ensure ctxbarListeners is an array before proceeding
    if (!Array.isArray(window.ctxbarListeners) || window.ctxbarListeners.length === 0) {
        return;
    }

    let totalRemoved = 0;

    // Iterate through all stored listeners and remove them safely
    for (let i = 0; i < window.ctxbarListeners.length; i++) {
        const listener = window.ctxbarListeners[i];

        // Ensure listener is valid before accessing properties
        if (!listener || typeof listener !== "object") {
            continue;
        }

        const { target, event, handler } = listener;

        // Ensure target, event, and handler exist before attempting removal
        if (!target || !event || !handler) {
            continue;
        }

        try {
            target.removeEventListener(event, handler);
            totalRemoved++;
        } catch (e) {
            // Fail silently to prevent script errors
        }
    }

    // Clear the ctxbarListeners array
    window.ctxbarListeners.length = 0;

    // Log once after cleanup
    console.log(`✅ All context bar listeners cleaned up. Total removed: ${totalRemoved}`);
}


function cleanupMobileUndoRedoListeners() {
    // Ensure mobileUndoRedoListeners is an array before proceeding
    if (!Array.isArray(mobileUndoRedoListeners) || mobileUndoRedoListeners.length === 0) {
        return;
    }

    // Iterate over the stored listeners and remove them
    for (let i = 0; i < mobileUndoRedoListeners.length; i++) {
        const listener = mobileUndoRedoListeners[i];

        // Ensure listener is valid before accessing properties
        if (!listener || typeof listener !== "object") {
            continue;
        }

        const { target, selector, event, handler } = listener;

        // Ensure target and event exist before attempting removal
        if (!target || !event || !handler) {
            continue;
        }

        try {
            if (target === editor) {
                // Remove TinyMCE-specific event listeners
                editor.off(event, handler);
            } else if (selector) {
                // Remove jQuery delegated event listeners
                const $target = $(target);
                if ($target.length > 0) {
                    $target.contents().find("body").off(event, selector, handler);
                }
            }
        } catch (e) {
            // Fail silently to prevent script errors
        }
    }

    // Clear the listeners array
    mobileUndoRedoListeners.length = 0;
}



function calculateScaleFromZoom(zoomLevel) {
    const MIN_ZOOM = 1;     // Minimum zoom levelßßß
    const MAX_ZOOM = 1.5;     // Maximum zoom level
    const MIN_SCALE = defaultScaleFactor;   // Minimum scale
    const MAX_SCALE = 1;     // Maximum scale

    // Calculate the scale based on the zoom level
    const scale = MIN_SCALE + ((zoomLevel - MIN_ZOOM) * (MAX_SCALE - MIN_SCALE)) / (MAX_ZOOM - MIN_ZOOM);

    // console.log ("Scale now is: ", scale);
    return scale;
}


// Function to return the correct writing constant based on the locale
function getWritingConstant(language) {
    switch (language) {
        case 'en-US':
            return englishWriting;
        case 'de-DE':
            return germanWriting;
        case 'fr-FR':
            return frenchWriting;
        case 'es-419':
            return espanolWriting;
        case 'en-GB':
            return ukWriting;
        case 'zh-CN':
            return chineseWriting;
        case 'pt-BR':
            return portugueseWriting;
        case 'ja-JP':
            return japaneseWriting;
        case 'it-IT':
            return italianWriting;
        default:
            return englishWriting; // Default to English if locale is not matched
    }
}


//When changing this make sure to change the containsValidUrl function
function getUrlFromText(text) {
    const urlPattern = /https?:\/\/[\w.-]+\.[a-z]{2,6}([\/\w.-]*)*\/?/i;
    const words = text.split(/\s+/);

    // List of paths to ignore (only if they don't have query parameters)
    const ignoredPaths = [
        "/jobs",
        "/careers",
        "/employment",
        "/join-us",
        "/work-with-us",
        "/opportunities",
        "/vacancies",
        "/recruitment"
    ];

    for (const word of words) {
        try {
            // Create a URL object to handle parsing
            const url = new URL(word);

            // Normalize the hostname to ASCII using Punycode
            const normalizedHostname = punycode.toASCII(url.hostname);
            url.hostname = normalizedHostname;

            // Get the full URL path including trailing slashes if any
            let fullPath = url.pathname;
            let hasQueryParams = url.search.length > 0; // Checks if query parameters exist

            // Ignore only if the URL ends with an ignored path **without query parameters**
            if (ignoredPaths.some(ignoredPath => fullPath.endsWith(ignoredPath)) && !hasQueryParams) {
                continue; // Skip this URL
            }

            // Allow URLs with either a valid path OR query parameters
            if (urlPattern.test(url.href) && (fullPath !== '/' || hasQueryParams)) {
                return word;  // Return the original input form
            }
        } catch (e) {
            // Ignore invalid URLs and continue
        }
    }
    return null;
}




// Function to fetch data at login and store it in localStorage - syncS3WithRedis set this to true to syncS3 with Redis
async function fetchAndStoreDataOnLogin(folderUUID, vendorName, force, syncS3WithRedis = false) {
    console.log('Fetching and storing data fetchAndStoreDataOnLogin');
    const storageKey = 'browse_files';
    const text_data = 'text_data';

    if (!force && getLocalStorageItem(storageKey)) {
        console.log("Data already exists in localStorage. Skipping fetch.");
        return;
    }


    const apiUrl = syncS3WithRedis ? getApiUrl('syncAndListFilesWithDescription', 'loginapi') : getApiUrl('listFilesWithDescription', 'loginapi');

    try {
        const response = await $.ajax({
            url: apiUrl,
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({ folderUUID, vendor: vendorName })
        });

        let useThisFileFlag = false;
        let linkedInUseThisFlag = false;
        // Filter and separate files based on file.type
        const linkedinFile = response.filter(file => file.type === 'linkedin');
        const uploadFiles = response.filter(file => file.type === 'upload');
        const otherFiles = response.filter(file => file.type !== 'upload' && file.type !== 'linkedin');

        // Handle LinkedIn text files
        if (linkedinFile.length > 0) {
            const processedLinkedIn = linkedinFile.map(({ filePath, fileName, lastUpdated, useThisFile, type }) => {
                if (useThisFile === "true") {
                    linkedInUseThisFlag = true;
                }
                return { filePath, fileName, lastUpdated, useThisFile, type };
            });
            setLocalStorageItem(text_data, JSON.stringify(processedLinkedIn));
        } else {
            localStorage.removeItem(text_data);
        }


        // Handle files of type 'upload'
        if (uploadFiles.length > 0) {
            const filteredFileList = uploadFiles.map(({ filePath, fileName, lastUpdated, useThisFile, type }) => {
                if (useThisFile === "true") {
                    useThisFileFlag = true;
                }
                return { filePath, fileName, lastUpdated, useThisFile, type };
            });

            // Store in localStorage as 'fileData'
            setLocalStorageItem('fileData', JSON.stringify(filteredFileList));
        } else {
            localStorage.removeItem('fileData');
        }


        // Handle other files
        if (otherFiles.length > 0) {
            const processedData = otherFiles.map(file => {
                let inflatedDescription = '';
                let decodedShortDescription = '';

                // Inflate description
                if (file.description) {
                    try {
                        const encodedDescription = file.description;
                        inflatedDescription = pako.inflate(atob(encodedDescription), { to: 'string' });
                    } catch (e) {
                        console.error("Error inflating description:", e);
                        inflatedDescription = ''; // Default to empty string if there's an error
                    }
                }

                // Decode and inflate shortDescription
                if (file.shortDescription) {
                    try {
                        const encodedShortDescription = atob(file.shortDescription);
                        decodedShortDescription = pako.inflate(encodedShortDescription, { to: 'string' });
                    } catch (e) {
                        console.error("Error decoding or inflating shortDescription:", e);
                        decodedShortDescription = ''; // Default to empty string if there's an error
                    }
                }

                // Return the file with inflatedDescription and decodedShortDescription
                const { description, shortDescription, ...fileWithoutDescription } = file;

                if (file.useThisFile === "true") {
                    useThisFileFlag = true;
                }

                return {
                    ...fileWithoutDescription,
                    inflatedDescription,
                    shortDescription: decodedShortDescription
                };
            });

            // Store in localStorage as 'browse_files'
            setLocalStorageItem(storageKey, JSON.stringify(processedData));


            // Update recent resume if applicable
            if (processedData.length > 0) {
                const path = processedData[0].filePath;
                const resumeName = processedData[0].fileName;
                thisEditor.updateRecentResumeLabel(resumeName);
                setLocalStorageItem(`resumeUrl-${folderUUID}`, path);
            }
        } else {
            localStorage.removeItem(`resumeUrl-${folderUUID}`);
            localStorage.removeItem(storageKey);
        }

        window.fileUploadEvents.updateBadgeIcons(useThisFileFlag, linkedInUseThisFlag, true);


        // Initialize the left sidebar
        leftsidebarpopulate.init();

    } catch (error) {
        console.error("Failed to fetch data on login.", error);
    }
}




// function navigate(path) {
//     console.log ("this Editor navigate Called");
//     window.history.pushState({}, path, window.location.origin + path);
// }

function debounce(func, delay) {
    let debounceTimer;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setCustomTimeout(() => func.apply(context, args), delay);
    };
}

// function updateTooltipsBasedOnWidth() {
//     const windowWidth = window.innerWidth;

//     const homeTooltip = $('#home-tooltip');
//     const contactTooltip = $('#contact-tooltip');
//     const fromJobPostingTooltip = $('#fromjobposting-tooltip');
//     const fromCustom = $('#fromcustom-tooltip');
//     const readyMade = $('#readymade-tooltip');
//     const setDarkMode = $('#resume-dark-mode');


//     //Only when the icons are showing enable the tooltip
//     if (windowWidth > 1850) {
//         if (homeTooltip) homeTooltip.tooltip('disable');
//         contactTooltip.tooltip('disable');
//         fromJobPostingTooltip.tooltip('disable');
//         fromCustom.tooltip('disable');
//         readyMade.tooltip('disable');
//         setDarkMode.tooltip('disable');
//     }
//     else {
//         if (homeTooltip) homeTooltip.tooltip('enable');
//         contactTooltip.tooltip('enable');
//         fromJobPostingTooltip.tooltip('enable');
//         fromCustom.tooltip('enable');
//         readyMade.tooltip('enable');
//         setDarkMode.tooltip('enable');
//     }
// }

function validateInput(input) {
    const errorSpan = document.getElementById(input.id + '-error');
    const invalidSpan = document.getElementById('login-Invalid-error');

    // Position the label when input is not empty


    // Only validate if the input has been interacted with
    if (input.dataset.interacted === 'true') {
        invalidSpan.style.display = 'none';
        if (!input.checkValidity()) {
            input.classList.add('invalid');
            input.classList.remove('valid');
            errorSpan.style.display = 'block';
        } else {
            input.classList.remove('invalid');
            input.classList.add('valid');
            errorSpan.style.display = 'none';
        }
    }
}

function closeRightDrawer() {
    if ($('#rightdrawer').hasClass('open')) {
        $('#rightdrawer').css('right', '-320px'); // Hide the drawer completely
        $('#rightdrawer').removeClass('open');
        console.log('Builder hidding modal backdrop 2');
        hideModalBackDrop();
        const spinner = document.getElementById('rightDrawerSpinner');
        spinner.style.display = 'none';
        subscriptionMiscModule.unload();
    }
}

function closeDrawer(event) {
    if (event) {
        var $rightDrawer = $("#rightdrawer");
        var $rightDrawerButton = $("#rightdrawercloseButton");
        if ($rightDrawerButton.has(event.target).length) closeRightDrawer();
        if (!$rightDrawer.has(event.target).length) {
            closeRightDrawer();
        }
    } else {
        closeRightDrawer();
    }
}

async function openDrawer() {
    const spinner = document.getElementById('rightDrawerSpinner');
    if (spinner) {
        spinner.style.display = 'none';
    }
    $('#rightdrawer').css('right', '0'); // Show the drawer
    $('#rightdrawer').addClass('open');
    showModalBackDrop();
    subscriptionMiscModule.init();
    await subscriptionMiscModule.fetchStripeSubscription();
}

function toggleDrawer() {
    if ($('#rightdrawer').hasClass('open')) {
        closeDrawer();
    } else {
        openDrawer();
    }
}


function adjustDarkLightModeButton() {
    let isDarkMode = $('html').hasClass('dark-theme');
    let tooltiptext = isDarkMode ? getI18n('home.setLightkMode') : getI18n('home.setDarkMode');
    $("#resume-dark-mode").attr("data-original-title", tooltiptext).tooltip('dispose').tooltip();
    let buttontext = isDarkMode ? getI18n('home.sidebar.lightmode') : getI18n('home.sidebar.darkmode');
    $('#dark-mode-text').text(buttontext);
}

function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

function supportsPDFsOnMobile() {
    // If it's iOS, return false because it may have issues with inline PDFs
    var isIOSDevice = isIOS();
    return !isIOSDevice; // False if iOS, true otherwise
}

async function getSignedCookies(folderUUID, vendor, hostName) {
    // If already in progress for this folderUUID, wait for it to complete
    if (signedCookiesLocks.has(folderUUID)) {
        console.log(`[Lock Waiting] Another call is already setting cookies for folderUUID: ${folderUUID}`);
        await signedCookiesLocks.get(folderUUID);
        return true; // Assume cookies are now available
    }

    let resolveLock;
    const lockPromise = new Promise(resolve => { resolveLock = resolve; });
    signedCookiesLocks.set(folderUUID, lockPromise);

    try {
        // Check existing cookies
        const cloudFrontPolicy = getCookie('CloudFront-Policy');
        const cloudFrontSignature = getCookie('CloudFront-Signature');
        const cloudFrontKeyPairId = getCookie('CloudFront-Key-Pair-Id');
        const cloudFrontExpires = getCookie('CloudFront-Expires');
        const cloudFrontFolderId = getCookie('CloudFront-FolderId');
        const currentTime = Math.floor(Date.now() / 1000);

        if (
            cloudFrontPolicy &&
            cloudFrontSignature &&
            cloudFrontKeyPairId &&
            cloudFrontExpires &&
            cloudFrontFolderId === folderUUID &&
            parseInt(cloudFrontExpires, 10) > currentTime
        ) {
            return true; // Valid, no need to regenerate
        } else {
            console.log('Signed cookies are expired, missing, or folder ID mismatch; regenerating for folderUUID...', folderUUID);
        }

        // Prepare payload
        const payload = { folderUUID, vendor, hostName };

        const response = await fetch(getApiUrl('generateSignedCookies', 'loginapi'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            throw new Error('Failed to get signed cookies');
        }

        const cookies = await response.json();
        const maxAge = 6 * 24 * 60 * 60; // 6 days

        // Set cookies
        setCookie('CloudFront-Policy', cookies['CloudFront-Policy'], maxAge);
        setCookie('CloudFront-Signature', cookies['CloudFront-Signature'], maxAge);
        setCookie('CloudFront-Key-Pair-Id', cookies['CloudFront-Key-Pair-Id'], maxAge);
        setCookie('CloudFront-Expires', cookies['CloudFront-Expires'], maxAge);
        setCookie('CloudFront-FolderId', folderUUID, maxAge);

        //adding a delay of 1000msec after setting the cookies so that subsequent call succeeds when accessing url.
        console.log('[getSignedCookies] waiting 500 msec after setting the cloudfront cookies');
        await new Promise(resolve => setCustomTimeout(resolve, 500));


        return false;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    } finally {
        // Release the lock
        signedCookiesLocks.delete(folderUUID);
        resolveLock();
    }
}




function removeDomainFromCompositeEmail(compositeEmail) {
    if (typeof compositeEmail !== 'string') return compositeEmail;
    const pipeIndex = compositeEmail.indexOf('|');
    return pipeIndex !== -1 ? compositeEmail.substring(0, pipeIndex) : compositeEmail;
}




// Function to set JWT and userAuth cookies
function setAuthCookies(bundledToken, vendor, firstname, lastname, initial, folderId) {
    // Set the max age to 400 days in seconds
    const maxAge = 400 * 24 * 60 * 60; // 400 days in seconds

    const token = removeBearerPrefix(bundledToken);

    // Store the token as a cookie
    setCookie('jwtToken', token, maxAge);

    const responsePayload = parseJwt(token);

    // Determine the email to use based on the vendor
    const compositeEmail = vendor === 'direct' ? responsePayload.sub : responsePayload.email;

    const email = removeDomainFromCompositeEmail(compositeEmail);

    const obfuscatedEmail = base64Encode(email);

    const obfuscatedFirstname = base64Encode(firstname);

    const obfuscatedLastname = base64Encode(lastname);

    // Store the obfuscated email and vendor as a cookie with an ambiguous name
    const userAuthValue = `${obfuscatedEmail}:${vendor}:${obfuscatedFirstname}:${obfuscatedLastname}:${initial}:${folderId}`;
    console.log('Setting folderId In Auth Cookie:', folderId);
    setCookie('userAuth', userAuthValue, maxAge);
    setCookie('folderId', folderId, maxAge);
    if (vendor === googleVendor)
        setCookie('vendorAuth', obfuscatedEmail, maxAge);
}




function deleteCookie(name) {
    const pastDate = 'Thu, 01 Jan 1970 00:00:00 GMT';
    document.cookie = name + '=; expires=' + pastDate + '; path=/';
}


// Function to delete JWT and userAuth cookies
function deleteAuthCookies() {
    // Delete the jwtToken and userAuth cookies
    deleteCookie('jwtToken');
    deleteCookie('userAuth');
    deleteCookie('CloudFront-Policy');
    deleteCookie('CloudFront-Signature');
    deleteCookie('CloudFront-Key-Pair-Id');
    deleteCookie('CloudFront-Expires');
    deleteCookie('CloudFront-FolderId');
    const file_storage = 'browse_files'
    deleteLocalStorageItem(file_storage);
    const file_data = 'fileData';
    deleteLocalStorageItem(file_data);
    const LINKED_IN_KEY = 'linkdInTxt';
    deleteLocalStorageItem(LINKED_IN_KEY);
    const TEXT_DATA = 'text_data';
    deleteLocalStorageItem(TEXT_DATA);
    const RECAPTCHA_PASSED = 'xflag';
    deleteLocalStorageItem(RECAPTCHA_PASSED);
    const folderUUID = getFolderIdFromCookies();
    deleteLocalStorageItem('dark-mode');
    deleteLocalStorageItem('iframe_base_path');
    deleteLocalStorageItem('selectedLanguage');
    deleteLocalStorageItem('useThisFile');
    deleteLocalStorageItem('linkedInUseThis');
    deleteLocalStorageItem(`resumeUrl-${folderUUID}`);
    try {
        Object.keys(localStorage).forEach((key) => {
            if (key.startsWith('chatgptbox_value_')) {
                localStorage.removeItem(key);
            }
        });
    } catch (error) {
        console.error("Error occured while removing chatgptbox_value_:", error);
    }
    window.fileUploadEvents.updateBadgeIcons(false, false, false);
    const chatgptbox = document.getElementById('chatgptbox');
    if (chatgptbox) {
        chatgptbox.value = "";
    }

}



// Function to update the expiration of the auth cookies
function updateAuthCookiesExpiration() {
    // Get the current values of the cookies
    const jwtToken = getCookie('jwtToken');
    const userAuth = getCookie('userAuth');
    const vendorAuth = getCookie('vendorAuth');

    if (jwtToken && userAuth) {
        // Set the max age to another 400 days in seconds
        const maxAge = 400 * 24 * 60 * 60; // 400 days in seconds

        // Update the cookies with the same values but new max-age
        setCookie('jwtToken', jwtToken, maxAge);
        setCookie('userAuth', userAuth, maxAge);
    }

    if (vendorAuth)
        setCookie('vendorAuth', vendorAuth, maxAge);
}

// Function to read the JWT token from cookies
function getJwtTokenFromCookies() {
    return getCookie('jwtToken');
}



function geBackgroundtHintText() {
    return window.innerWidth < 720
        ? `${getI18n('mobile_hint_click_any_where_to_edit')}`
        : `${getI18n('hint_click_any_where_to_edit')}`;
}


function showResumeStyleToolTips() {
    // Create the tooltip dynamically
    const tooltipHtml = `
            <div class="change-theme-tooltip" id="change-theme-tooltip">
                <button class="change-theme-close-tooltip">&times;</button>
                <p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="40" fill="currentColor" class="bi bi-lightbulb" viewBox="0 0 16 16">
                        <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13a.5.5 0 0 1 0 1 .5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1 0-1 .5.5 0 0 1 0-1 .5.5 0 0 1-.46-.302l-.761-1.77a2 2 0 0 0-.453-.618A5.98 5.98 0 0 1 2 6m6-5a5 5 0 0 0-3.479 8.592c.263.254.514.564.676.941L5.83 12h4.342l.632-1.467c.162-.377.413-.687.676-.941A5 5 0 0 0 8 1"/>
                    </svg>
                    ${getI18n('hint_choose_different_style_resume')}.
                </p>
            </div>
        `;

    // Append the tooltip to the body
    $('body').append(tooltipHtml);

    // Position the tooltip relative to the changethemeclass element
    const $themeButton = $('#changethemeclass');
    const offset = $themeButton.offset();
    const buttonHeight = $themeButton.outerHeight();
    const buttonWidth = $themeButton.outerWidth();

    // Set the tooltip's position below the theme button
    $('#change-theme-tooltip').css({
        top: offset.top + buttonHeight + 10 + 'px', // 10px space below the button
        left: offset.left - buttonWidth / 2 + 'px',
        display: 'block' // Show the tooltip
    });

    // Handle closing of the tooltip
    $('.change-theme-close-tooltip').on('click', function () {
        if ($('#change-theme-tooltip').is(':visible')) {
            $('#change-theme-tooltip').remove(); // Remove the tooltip
        }
    });

}

function showZoomSliderToolTip() {
    // Check if the tooltip has already been closed
    const tooltipClosed = getLocalStorageItem('zoomTooltipClosed');

    const moreTipsLink = window.innerWidth < 720 ? `<a href="#" id="show-more-tooltips">${getI18n('hint_more_tips')}</a>` : '';

    if (!tooltipClosed) {
        // Create the tooltip dynamically
        const tooltipHtml = `
                <div class="zoom-tooltip" id="zoom-tooltip">
        <div class="zoom-content">
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-lightbulb" viewBox="0 0 16 16">
                            <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13a.5.5 0 0 1 0 1 .5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1 0-1 .5.5 0 0 1 0-1 .5.5 0 0 1-.46-.302l-.761-1.77a2 2 0 0 0-.453-.618A5.98 5.98 0 0 1 2 6m6-5a5 5 0 0 0-3.479 8.592c.263.254.514.564.676.941L5.83 12h4.342l.632-1.467c.162-.377.413-.687.676-.941A5 5 0 0 0 8 1"/>
                        </svg>
            <span>${getI18n('hint_zoom_control')}</span>
            <button class="zoom-close-tooltip" aria-label="Close tooltip">&times;</button>
        </div>

        </div>
        `;



        // Append the tooltip to the zoom-container
        $('#zoom-container').append(tooltipHtml);

        // Position the tooltip relative to the zoom-container
        const $zoomContainer = $('#zoom-container');
        const containerHeight = $zoomContainer.outerHeight();
        const containerWidth = $zoomContainer.outerWidth();

        // Add onclick event for "More tips" link
        $('#show-more-tooltips').on('click', function (e) {
            e.preventDefault();
            $('#zoom-tooltip').remove(); // Remove the tooltip
            if (window.innerWidth < 720) {
                showResumeStyleToolTips();
            }
        });


        // Set the tooltip's position above the zoom-container
        $('#zoom-tooltip').css({
            position: 'absolute', // Ensure the tooltip is positioned within the zoom-container
            top: -$('#zoom-tooltip').outerHeight() - 5 + 'px', // 10px space above the container
            left: 20 + 'px', // Center the tooltip horizontally
            display: 'block' // Show the tooltip
        });

        // Handle closing of the tooltip
        $('.zoom-close-tooltip').on('click', function () {
            if ($('#zoom-tooltip').is(':visible')) {
                $('#zoom-tooltip').remove(); // Remove the tooltip
                setLocalStorageItem('zoomTooltipClosed', 'true'); // Set the flag in localStorage
            }
        });
    }
}



function createElementFromHTML(htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();

    // Change this to div.childNodes to support multiple top-level nodes
    return div.childNodes;
}

function initializeGoogleSignIn() {
    const siteName = getSiteNameForStripe();
    // Set client_id based on site
    const clientId = (siteName === 'cvinminutes.com')
        ? "727291629597-kv289755p2qcpopiqh7hc7bbrgjqirpp.apps.googleusercontent.com"
        : "975673506020-flag9ehkcp60c55t14636d0kg827766c.apps.googleusercontent.com"; // Default


    google.accounts.id.initialize({
        client_id: clientId,
        callback: handleCredentialResponse,
        select_by: "user_1tap",
        login_hint: getEmailFromVendorCookies(),

    });
    const googleButtonTheme = $('html').hasClass('dark-theme') ? 'filled_black' : 'outline';

    const googleLoginButtons = document.querySelectorAll('.google-login-button');

    // Render the Google sign-in button for each element
    googleLoginButtons.forEach(button => {
        google.accounts.id.renderButton(
            button,
            { theme: googleButtonTheme, size: 'large', shape: "pill", logo_alignment: "center", width: "365px" }
        );
    });

    //google.accounts.id.prompt(); // Display the One Tap dialog
    // Attempt silent sign-in

}


function waitForGoogleSignIn(callback, retries = 10, delay = 200) {
    if (window.google && window.google.accounts && window.google.accounts.id) {
        callback();
    } else if (retries > 0) {
        setTimeout(() => {
            waitForGoogleSignIn(callback, retries - 1, delay);
        }, delay);
    } else {
        console.error('Google Sign-In client not available.');
    }
}


function initializeAppleSignIn() {
    AppleID.auth.init({
        clientId: 'com.resumebuildergpt.resume',
        scope: 'name email',
        redirectURI: 'https://www.sqlldap.com/login/oauth2/code/apple',
        state: 'initial',
        usePopup: true
    });

    // Listen for authorization success, the name is only shared the first time - need to use the id
    document.addEventListener('AppleIDSignInOnSuccess', (event) => {
        console.log('Received Apple Sign In success event', event);
        if (event.detail.user) {
            var responsePayload = parseJwt(event.detail.authorization.id_token);
            console.log("ID: " + responsePayload.sub);
            console.log('Given Name: ' + event.detail.user.name.firstName);
            console.log('Family Name: ' + event.detail.user.name.lastName);
            console.log("Email: " + event.detail.user.email);
        }
        else if (event.detail) {
            var responsePayload = parseJwt(event.detail.authorization.id_token);
            console.log("ID: " + responsePayload.sub);
            console.log("Email: " + responsePayload.email);
        }
    });


    // Listen for authorization failures.
    document.addEventListener('AppleIDSignInOnFailure', (event) => {
        // Handle error.
        console.log('failure');
        console.log(event.detail.error);
    });

}

function removeBearerPrefix(token) {
    return token.replace(/^Bearer\s+/i, '');
}

function isTokenExpired(token) {
    var responsePayload = parseJwt(token);
    var currentTime = Date.now() / 1000; // Current time in seconds
    var expirationTime = responsePayload.exp;
    // Logging the expired time - Convert expiration time to a human-readable format
    var expirationDate = new Date(expirationTime * 1000).toLocaleString();
    console.log("Token will expire at: " + expirationDate);
    // End of logging
    return expirationTime < currentTime;
}

// This is where we are handling google token
async function handleCredentialResponse(response) {
    //console.log("Encoded JWT ID token: " + response.credential);

    // Decode the JWT token to get the access token
    var responsePayload = parseJwt(response.credential);
    console.log("ID: " + responsePayload.sub);
    console.log('Full Name: ' + responsePayload.name);
    console.log('Given Name: ' + responsePayload.given_name);
    console.log('Family Name: ' + responsePayload.family_name);
    console.log("Image URL: " + responsePayload.picture);
    console.log("Email: " + responsePayload.email);

    // Check if the token is expired
    var currentTime = Date.now() / 1000; // Current time in seconds
    var expirationTime = responsePayload.exp;
    var isExpired = expirationTime < currentTime;

    // Convert expiration time to a human-readable format
    var expirationDate = new Date(expirationTime * 1000).toLocaleString();

    var initial = "A";

    const userData = await thisEditor.registerGoogleUser(responsePayload.given_name, responsePayload.family_name, responsePayload.email, responsePayload.picture, responsePayload.sub);

    if (!userData) return;
    if (userData) {
        if (responsePayload.given_name)
            initial = responsePayload.given_name.charAt(0).toUpperCase();
        setAuthCookies(response.credential, googleVendor, responsePayload.given_name, responsePayload.family_name, initial, responsePayload.sub);
    }
    else {
        // fallback if userData is null – treat as error
        Swal.fire({
            title: getI18n('google_error_title'),
            text: getI18n('google_signup_unknown_error'),
            icon: "error",
        });
        return;
    }

    showLoggedInSvg(initial);


    if (loginPopup) {
        loginPopup.hide();
        loginPopup = null;
        scrollToTopWhenWindowScrolls();
    }
    console.log("Token is expired: " + isExpired);
    console.log("Token will expire at: " + expirationDate);

    //Setting the initial multiple when the recaptcha will show for google user to 10, make it 3 later untill paid user.
    //Using it for differentiation b/w users for the time being until the paid logic is developed
    window.recaptchaVerification.setInitialMultiple(10);

    const vendor = getVendorFromCookies();
    const folderUUID = getFolderIdFromCookies();
    const hostname = window.location.hostname;

    await fetchAndStoreDataOnLogin(folderUUID, vendor, true, true);


    try {
        if (actionInProgress) { //This is message to generate the current functions
            await getSignedCookies(folderUUID, vendor, hostname);
            actionInProgress();
            console.log ('Setting action in progress to null in handleCredentialResponse');
            actionInProgress = null;
        } else {
            await getSignedCookies(folderUUID, vendor, hostname);
        }

    } catch (error) {
        console.error("Error in getting Permissions:", error);
        Swal.fire({
            title: getI18n('error_job'),
            text: getI18n('permissions_error'),
            icon: "error",
        });
    }
}

function parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
};


function setSliderValue() {
    const sliders = $("#builder_iframe").contents().find('.tick-slider-input');
    for (let slider of sliders) {
        if (slider && slider.parentNode && slider.parentNode.querySelector('#weightValue .slidervalue')) {
            slider.setAttribute('value', slider.parentNode.querySelector('#weightValue .slidervalue').textContent);
        }
    }
}



function simulateClick(x, y) {
    var ev = document.createEvent("MouseEvent");
    var el = document.elementFromPoint(x, y);
    ev.initMouseEvent(
        "click",
        true /* bubble */, true /* cancelable */,
        window, null,
        x, y, 0, 0, /* coordinates */
        false, false, false, false, /* modifier keys */
        0 /*left*/, null
    );
    el.dispatchEvent(ev);
}

function makeid() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

var Editor = function (options) {

    var thisEditor = this;

    /** @type {Editor} */
    window.currentEditor = thisEditor;


    window.getVendorAndEmailFromCookies = async function getVendorAndEmailFromCookies() {
        const userAuth = getCookie('userAuth');
        if (userAuth) {
            const [obfuscatedEmail, vendor, obfuscatedFirstname, obfuscatedLastname, initial, folderId] = userAuth.split(':');
            const email = base64Decode(obfuscatedEmail);
            const firstname = base64Decode(obfuscatedFirstname);
            const lastname = base64Decode(obfuscatedLastname);
            return { email, vendor, firstname, lastname, initial, folderId };
        }
        return null;
    }

    // Define the listener directly
    this.generateResumeListener = async function (event) {
        if (event.detail.message === 'verificationCompleted')
            thisEditor.doGenerateResume();
    };

    // Define the listener directly
    this.generateTemplateListener = async function (event) {
        console.log('Generate Template Listener called');
        if (event.detail.message === 'verificationCompleted')
            thisEditor.doGenerateFromTemplate();
    };

    this.generateCoverLetterListener = async function (event) {
        if (event.detail.message === 'verificationCompleted')
            thisEditor.doGenerateCoverLetter();
    };

    //this is the listener for all events where the login is required must pass the callback to execute -- check leftsidebarpopulate how it is done
    this.defaultFunctionsListener = async function (event) {
        if (event.detail.message === 'verificationCompleted') {
            if (event.detail.callback && typeof event.detail.callback === 'function') {
                if (isUserLoggedIn())
                    event.detail.callback();
                else {
                    thisEditor.showLoginPopup(
                        false,
                        false,
                        false,
                        false,
                        false,
                        defaultFunctionsAccessSuccess,
                        event.detail.callback
                    );
                }
            }
        }
    };






    this.openBrowseListener = async function (event) {
        if (event.detail.message === 'verificationCompleted') {
            const folderUUID = getFolderIdFromCookies();
            const vendor = getVendorFromCookies();
            await fetchAndStoreDataOnLogin(folderUUID, vendor, false, false);
            window.browseFileEvents.init(folderUUID, vendor);  // Initialize the module
        }
    };




    this.openFileUploadListener = async function (event) {
        if (event.detail.message === 'verificationCompleted') {
            const folderUUID = getFolderIdFromCookies();
            const vendor = getVendorFromCookies();
            await fetchAndStoreDataOnLogin(folderUUID, vendor, false, false);
            window.fileUploadEvents.init(folderUUID, vendor, fetchAndStoreDataOnLogin);  // Initialize the module
        }
    };

    this.openLinkedInListener = async function (event) {
        if (event.detail.message === 'verificationCompleted') {
            const folderUUID = getFolderIdFromCookies();
            const vendor = getVendorFromCookies();
            await fetchAndStoreDataOnLogin(folderUUID, vendor, false, false);
            window.fileUploadEvents.init(folderUUID, vendor, fetchAndStoreDataOnLogin, true);  // Initialize the module
        }
    };

    // Define the listener directly
    this.previewPdfListener = async function (event) {
        if (event.detail.message === 'verificationCompleted')
            thisEditor.generatePdfPreview();
    };

    // Define the listener directly
    this.exportPdfListener = async function (event) {
        if (event.detail.message === 'verificationCompleted')
            thisEditor.doExportPdf();
    };

    // Define the listener directly
    this.saveListener = async function (event) {
        if (event.detail.message === 'verificationCompleted')
            thisEditor.saveLocalAndCloud(true);
    };


    this.saveListenerGoBack = async function (event) {
        if (event.detail.message === 'verificationCompleted') {
            thisEditor.saveLocalAndCloud(false, () => history.back());
        }
    };



    // Define the listener directly
    this.saveAsListener = async function (event) {
        if (event.detail.message === 'verificationCompleted')
            thisEditor.doSaveAsToCloud();
    };

    // Define the listener directly
    this.renameFileListener = async function (event) {
        if (event.detail.message === 'verificationCompleted')
            thisEditor.renameFileToCloud();
    };


    // ifram contents
    thisEditor.getIframeContent = function () {
        return $("#builder_iframe").contents();
    };

    // default strict
    thisEditor.strict = true;

    // default help button
    thisEditor.showHelp = true;

    // before save events
    thisEditor.beforeSaveEvents = [];


    // fix root path
    thisEditor.root = '/dist/';
    thisEditor.root = thisEditor.root.trim();
    if (thisEditor.root.slice(-1) !== '/') {
        thisEditor.root = thisEditor.root + '/';
    }

    if (typeof (window.CSRF_TOKEN) == 'undefined') {
        window.CSRF_TOKEN = '';
    }

    this.language = getLanguage(); //from index.html
    this.uses12HourClock = ['en-US', 'en-GB', 'ph-PH', 'ca-CA'].includes(this.language);
    //console.log('uses12HourClock is: ', this.uses12HourClock);


    // check header
    if (typeof (this.header) == 'undefined') {
        this.header = {};
    }

    // save check anchor
    this.saveAchor = 0;

    this.saveToServer = true;

    this.runCustom = false;

    // set default template url if url not exist
    this.setDefaultTemplateUrlIfNotExist();


};

Editor.prototype = {

    tinymceEventListeners: [], // Store event listeners for TinyMCE
    editorListeners: [],       // General event listeners
    resizeHandler: null,

    // Add event listeners (supports DOM and jQuery)
    addEventListener: function (target, event, handler) {
        if (target && typeof target.addEventListener === 'function') {
            // DOM Event Listener
            target.addEventListener(event, handler);
            this.editorListeners.push({ target, event, handler });
        } else if (target && typeof target.on === 'function') {
            // jQuery Event Listener
            target.on(event, handler);
            this.editorListeners.push({ target, event, handler, isJquery: true });
        } else {
            console.warn("Target does not support event listeners.");
        }
    },


    unmakeAndRestoreSubmitButtonEditor: async function () {
        const $spinner = $("#generateresume-circlespinner");
        if ($spinner.length) {
            const isDisplayed = $spinner.css("display") !== "none";
            if (isDisplayed) {
                $('#generateresume-arrowimage').show(); // Hide the arrow
                $('#generateresume-circlespinner').hide(); // Show the spinner
                $('.chatgptbox-submit').prop('disabled', false); // Disable the button
                thisEditor.unmask();
            }
        }

    },


    // Remove all registered event listeners
    removeAllEditorEventListeners: function () {
        this.editorListeners.forEach(({ target, event, handler, isJquery }) => {
            if (isJquery && target && typeof target.off === 'function') {
                target.off(event, handler);
            } else if (target && typeof target.removeEventListener === 'function') {
                target.removeEventListener(event, handler);
            }
        });
        this.editorListeners = []; // Clear the array
    },

    // Remove a specific listener manually
    removeSpecificEventListener: function (target, event, handler) {
        if (target && typeof target.off === 'function') {
            target.off(event, handler); // jQuery-specific removal
        } else if (target && typeof target.removeEventListener === 'function') {
            target.removeEventListener(event, handler); // Native DOM removal
        }
        // Remove the specific listener from the tracking array
        this.editorListeners = this.editorListeners.filter(
            (listener) => !(listener.target === target && listener.event === event && listener.handler === handler)
        );
    },

    addTinymceEventListener: function (target, event, handler) {
        if (target && typeof target.on === 'function') {
            // For TinyMCE editor
            target.on(event, handler);
            this.tinymceEventListeners.push({ target, event, handler });
        } else if (target && typeof target.addEventListener === 'function') {
            // For DOM elements
            target.addEventListener(event, handler);
            this.tinymceEventListeners.push({ target, event, handler });
        } else {
            console.warn("Target does not support event listeners.");
        }
    },

    removeAllTinymceEventListeners: function () {
        this.tinymceEventListeners.forEach(({ target, event, handler }) => {
            if (typeof target.off === 'function') {
                // For TinyMCE editor
                target.off(event, handler);
            } else if (typeof target.removeEventListener === 'function') {
                // For DOM elements
                target.removeEventListener(event, handler);
            }
        });
        this.tinymceEventListeners = [];
    },

    removeCanvasEventListeners: function () {
        this.tinymceEventListeners = this.tinymceEventListeners.filter(({ target, event, handler }) => {
            if (target && target.tagName === 'CANVAS') {
                if (typeof target.off === 'function') {
                    target.off(event, handler);
                } else if (typeof target.removeEventListener === 'function') {
                    target.removeEventListener(event, handler);
                }
                return false; // remove from the list
            }
            return true; // keep other listeners
        });
    },




    setIframeHeight: function (iframe) {
        if (iframe) {
            iframe.height = (window.innerHeight - 38) + 'px';
        }
    },

    unloadTinyMceEditor: function () {
        let tinymceEditor = null;

        // Check and handle TinyMCE instances
        if (Array.isArray(thisEditor.tinymce) && thisEditor.tinymce.length > 0) {
            const editorInstance = thisEditor.tinymce[0];
            tinymceEditor = editorInstance;

            // Remove TinyMCE event listeners
            this.removeAllTinymceEventListeners(editorInstance);

            const bodyhtml = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html')[0];
            if (bodyhtml) {
                const canvas = bodyhtml.querySelector('#signature-canvas');
                if (canvas) {
                    const ctx = canvas.getContext('2d');
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    if (canvas.parentNode) {
                        canvas.parentNode.removeChild(canvas);

                    }
                    canvas.width = 0;
                    canvas.height = 0;
                    canvas.remove();
                }
            }

            // Remove all TinyMCE-specific styles and containers inside the iframe
            const iframeContents = $("#builder_iframe")[0];
            removeAllChildrenAndStyles(iframeContents);
            // const editorContainers = iframeContents.find('#maincontent-body-html').find('.tox-editor-container');
            // console.log ('editorContainers length', editorContainers.length);

            // if (editorContainers.length > 0) {
            //     editorContainers.each(function () {
            //         const container = $(this);
            //         removeAllChildrenAndStyles(container);
            //     });
            // }

            // Properly remove the TinyMCE editor instance
            if (editorInstance && editorInstance.remove) {
                // console.log("Remvoing all tinymce editor Instance by calling .remove");
                editorInstance.off(); // Remove all event listeners
                editorInstance.remove(); // Remove the instance
                tinymceEditor = null;
            }
        }



        thisEditor.tinymce = null;
    },

    hideCustomCaret: async function () {
        if (/iPhone/i.test(navigator.userAgent)) {
            setCustomTimeout(() => {
                console.log('Hiding custom Caret');
                if (caretMarker) caretMarker.style.display = 'none';
            }, 200);
        }
    },



    setDefaultTemplateUrlIfNotExist: function () {
        if (typeof (this.url) == 'undefined' && typeof (this.html) == 'undefined') {
            this.url = this.root + 'templates/default/';
        }
    },

    addBeforeSaveEvent: function (event) {
        this.beforeSaveEvents.push(event);
    },

    runBeforeSaveEvents: function (event) {
        this.beforeSaveEvents.forEach(function (event) {
            event();
        });

        $("#builder_iframe")[0].contentWindow.tinymce.triggerSave();
    },

    // change loading message
    loadingSetMessage: function (data) {
        $('.loading-page-overlay label').html(data);
    },

    // hide loading effect when done
    done: function () {
        var thisEditor = this;

        $('.loading-page-overlay').remove();

        // loaded callback
        if (thisEditor.loaded) {
            thisEditor.loaded();
        }

        // flag when builder done loaded
        thisEditor.isInitialized = true;
    },

    formatDate: function (date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;
        var strTime = hours + ':' + minutes + ':' + seconds + ' ' + ampm;
        return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + " - " + strTime;
    },

    mask: function (text) {
        stopTimer();
        startTimer();
        if (text) document.getElementById('spinningmessage').textContent = text;
        $('div.loadding-indicator').show();
    },

    unmask: function () {
        stopTimer();
        $('div.loadding-indicator').hide();
    },

    closePreview: function () {
        $('div.showPreview').hide();
        $('.click-active-preview').removeClass('active-preview');

        const pdfViewer = document.getElementById('pdfViewer'); // Target the container
        let iframe = pdfViewer ? pdfViewer.querySelector('iframe') : null;


        if (iframe) {
            const blobURL = iframe.src;


            // Revoke the blob URL to release memory
            if (blobURL && blobURL.startsWith('blob:')) {
                window.URL.revokeObjectURL(blobURL);
            }

            // Remove the window resize event listener (added during iframe creation)
            if (thisEditor.resizeHandler) {
                window.removeEventListener('resize', thisEditor.resizeHandler);
                thisEditor.resizeHandler = null; // Clean up reference
            }

            removeAllChildrenAndStyles(pdfViewer);
            $(iframe).attr('src', 'about:blank');
            iframe.remove();
            iframe = null;

        }
    },
    cleanUpContent: function (saving = false) {
        // unselect
        if (!saving) this.unselect();

        if (typeof window.getDragAndDropIsEnabled === "function") {
            if (window.getDragAndDropIsEnabled())
                window.externalCleanupDragState();
        }

        // remove additional classes
        $("#builder_iframe").contents().find("*").removeClass(function (index, className) {
            return (className.match(/builder-class[a-zA-Z0-9\_\-]+/g) || []).join(' ');
        });

        $("#builder_iframe").contents().find("*").removeClass(function (index, className) {
            return (className.match(/\b(p[tyb]-[^\s]+)/g) || []).join(' ');
        });


        // remove builder-tool
        if (!saving) $("#builder_iframe").contents().find('.builder-tool').remove();

        $("#builder_iframe").contents().find(".drag-indicator, .drop-indicator, .cancel-button").remove();


        // remove notebook editor
        $("#builder_iframe").contents().find("[id^=jquery-notebook-content-]").remove();

    },

    getContent: function () {
        return new Promise((resolve, reject) => {
            const rawContent = $("#builder_iframe").contents().find("html")[0].outerHTML;
            const encodedContent = encodeContent(rawContent);  // Assume this returns an ArrayBuffer
            const currentMessageId = getMessageId();

            workerInitializationEvents.getPendingRequests()[currentMessageId] = { resolve, reject };

            workerInitializationEvents.getContentWorker().postMessage({
                id: currentMessageId,
                action: 'processContent',
                data: { content: encodedContent }  // Include encodedContent in data
            }, [encodedContent]);  // Transfer buffer ownership

            // Timeout after 5 seconds if the worker doesn't respond
            setCustomTimeout(() => {
                if (workerInitializationEvents.getPendingRequests()[currentMessageId]) {
                    reject('Worker timed out.');
                    delete workerInitializationEvents.getPendingRequests()[currentMessageId];
                }
            }, 3000);
        });
    },

    getContentForSave: function () {
        return new Promise((resolve, reject) => {
            const rawContent = $("#builder_iframe").contents().find("html")[0].outerHTML;
            const encodedContent = encodeContent(rawContent);  // Assume this returns an ArrayBuffer
            const currentMessageId = getMessageId();

            workerInitializationEvents.getPendingRequests()[currentMessageId] = { resolve, reject };

            workerInitializationEvents.getContentWorker().postMessage({
                id: currentMessageId,
                action: 'processContentSave',
                data: { content: encodedContent }  // Include encodedContent in data
            }, [encodedContent]);  // Transfer buffer ownership

            // Timeout after 5 seconds if the worker doesn't respond
            setCustomTimeout(() => {
                if (workerInitializationEvents.getPendingRequests()[currentMessageId]) {
                    reject('Worker timed out.');
                    delete workerInitializationEvents.getPendingRequests()[currentMessageId];
                }
            }, 3000);
        });
    },


    saveContent: function (filename) {
        return new Promise((resolve, reject) => {
            const rawContent = $("#builder_iframe").contents().find("html")[0].outerHTML;
            const encodedContent = encodeContent(rawContent);  // Assuming this returns an ArrayBuffer
            const currentMessageId = getMessageId();

            // Store the promise handlers
            workerInitializationEvents.getPendingRequests()[currentMessageId] = { resolve, reject };

            //console.log(`Sending saveContent request to worker for filename: ${filename}, messageId: ${currentMessageId}`);

            // Ensure 'content' is part of the data object
            workerInitializationEvents.getContentWorker().postMessage({
                id: currentMessageId,
                action: 'saveContent',
                data: { content: encodedContent, filename }  // Add 'content' here
            }, [encodedContent]);  // Transfer buffer ownership

            // Timeout if worker doesn't respond in 10 seconds
            setCustomTimeout(() => {
                if (workerInitializationEvents.getPendingRequests()[currentMessageId]) {
                    console.error(`Worker timed out for saveContent request (ID: ${currentMessageId})`);
                    reject('Worker timed out.');
                    delete workerInitializationEvents.getPendingRequests()[currentMessageId];
                }
            }, 3000);
        });
    },

    initContentForSave: function (filename) {
        return new Promise((resolve, reject) => {
            const rawContent = $("#builder_iframe").contents().find("html")[0].outerHTML;
            const encodedContent = encodeContent(rawContent);  // Assuming this returns an ArrayBuffer
            const currentMessageId = getMessageId();

            // Store the promise handlers
            workerInitializationEvents.getPendingRequests()[currentMessageId] = { resolve, reject };

            console.log(`Sending initEditor request to worker for filename: ${filename}, messageId: ${currentMessageId}`);

            // Send content to the worker for initialization
            workerInitializationEvents.getContentWorker().postMessage({
                id: currentMessageId,
                action: 'initEditor',
                data: { content: encodedContent, filename }
            }, [encodedContent]);  // Transfer buffer ownership

            // Timeout if worker doesn't respond in 10 seconds
            setCustomTimeout(() => {
                if (workerInitializationEvents.getPendingRequests()[currentMessageId]) {
                    console.error(`Worker timed out for initEditor request (ID: ${currentMessageId})`);
                    reject('Worker timed out.');
                    delete workerInitializationEvents.getPendingRequests()[currentMessageId];
                }
            }, 3000);
        });
    },


    retrieveContent: function (filename) {
        return new Promise((resolve, reject) => {
            const currentMessageId = getMessageId();

            workerInitializationEvents.getPendingRequests()[currentMessageId] = { resolve, reject };

            workerInitializationEvents.getContentWorker().postMessage({
                id: currentMessageId,
                action: 'getContent',  // Retrieve content from IndexedDB
                data: { filename }
            });

            // Timeout after 5 seconds if the worker doesn't respond
            setCustomTimeout(() => {
                if (workerInitializationEvents.getPendingRequests()[currentMessageId]) {
                    reject('Worker timed out.');
                    delete workerInitializationEvents.getPendingRequests()[currentMessageId];
                }
            }, 3000);
        });
    },

    renameFile: function (oldFileName, newFileName) {
        return new Promise((resolve, reject) => {
            const currentMessageId = getMessageId();

            workerInitializationEvents.getPendingRequests()[currentMessageId] = { resolve, reject };

            workerInitializationEvents.getContentWorker().postMessage({
                id: currentMessageId,
                action: 'renameFile',  // Retrieve content from IndexedDB
                data: { oldFileName, newFileName }
            });

            // Timeout after 5 seconds if the worker doesn't respond
            setCustomTimeout(() => {
                if (workerInitializationEvents.getPendingRequests()[currentMessageId]) {
                    reject('Worker timed out.');
                    delete workerInitializationEvents.getPendingRequests()[currentMessageId];
                }
            }, 3000);
        });
    },

    deleteContent: function (filename) {
        return new Promise((resolve, reject) => {
            const currentMessageId = getMessageId();

            workerInitializationEvents.getPendingRequests()[currentMessageId] = { resolve, reject };

            workerInitializationEvents.getContentWorker().postMessage({
                id: currentMessageId,
                action: 'deleteContent',  // Delete content from IndexedDB
                data: { filename }
            });

            // Timeout after 5 seconds if the worker doesn't respond
            setCustomTimeout(() => {
                if (workerInitializationEvents.getPendingRequests()[currentMessageId]) {
                    reject('Worker timed out.');
                    delete workerInitializationEvents.getPendingRequests()[currentMessageId];
                }
            }, 3000);
        });
    },




    logout: function (fromurl) {
        if (checkJwtTokenCookieExists()) {
            deleteAuthCookies();
            hideLoggedInSvg();
            leftsidebarpopulate.unload();
            thisEditor.clearRecentResumeLabel();
            if (fromurl) navigate(getBasePath(window.location.href));
        }
    },
    login: async function (callback) {
        const email = document.getElementById('login-email').value;
        const password = document.getElementById('login-password').value;

        const loginRequest = {
            email: email,
            password: password,
            domain: getSiteNameForStripe()
        };

        // Disable login button and show loader
        const loginButton = document.getElementById('loginform-button');
        loginButton.setAttribute("disabled", 'disabled');
        loginButton.innerHTML = '<div class="loader-register"></div>';

        try {
            const response = await fetch(getApiUrl('login', 'loginapi'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(loginRequest)
            });

            loginButton.removeAttribute("disabled");


            if (!response.ok) {
                const text = await response.text();
                let errorData = {};
                try {
                    errorData = JSON.parse(text);
                } catch (err) {
                    console.error("Error parsing JSON:", err);
                }

                let errorMessage = `Error ${response.status}: ${errorData.message || response.statusText}`;
                if (response.status === 401) { // Unauthorized
                    errorMessage = "401";
                } else if (response.status === 404) { // Not found
                    errorMessage = "404";
                } else if (response.status >= 500) {
                    errorMessage = "500";
                } else if (response.status >= 400) {
                    errorMessage = "400";
                }

                throw new Error(errorMessage);
            }

            const data = await response.json();
            // console.log('Success:', data.token);
            var initial = "A";
            if (data.firstname)
                initial = data.firstname.charAt(0).toUpperCase();
            showLoggedInSvg(initial);

            data.email = email;

            setAuthCookies(data.token, directVendor, data.firstname, data.lastname, initial, data.folderId);//This will set the token, email and vendor in cookies - use functions
            const vendor = getVendorFromCookies();
            const folderUUID = getFolderIdFromCookies();
            const hostname = window.location.hostname;


            await fetchAndStoreDataOnLogin(folderUUID, vendor, true, true);

            if (actionInProgress) { //This is message to generate the current functions
                await getSignedCookies(folderUUID, vendor, hostname);
            } else {
                await getSignedCookies(folderUUID, vendor, hostname);
            }

            //getJwtTokenFromCookies(), getEmailFromCookies() and getVendorFromCookies()
            window.recaptchaVerification.setInitialMultiple(3);

            $('#login-Invalid-error-401').css('display', 'none');
            $('#login-Invalid-error-404').css('display', 'none');
            $('#login-Invalid-error-500').css('display', 'none');
            $('#login-Invalid-error-400').css('display', 'none');
            $('#login-email, #login-password').addClass('valid');
            $('#login-email, #login-password').removeClass('invalid');
            $('#login-email, #login-password').css('-webkit-animation-name', 'autofillvalid');

            // Callback after successful login
            if (typeof callback !== 'undefined') {
                console.log('callback', callback);
                callback(data);
            }

            console.log ('actionInProgress', actionInProgress);

             if (actionInProgress) { //This is message to generate the current functions
                actionInProgress(data);
                console.log ('Setting action in progress to null in login');
                actionInProgress = null;
            }

            loginButton.innerHTML = getI18n('menubar.items.login'); // Update button text appropriately

            this.hideLoginPopup();
            scrollToTopWhenWindowScrolls();





        } catch (error) {
            console.error('Error Message:', error);
            loginButton.removeAttribute("disabled");
            loginButton.innerHTML = getI18n('menubar.items.login'); // Update button text appropriately

            if (error.name === 'TypeError' || error.message === '500') {
                $('#login-Invalid-error-401').css('display', 'none');
                $('#login-Invalid-error-404').css('display', 'none');
                $('#login-Invalid-error-500').css('display', 'block');
                $('#login-Invalid-error-400').css('display', 'none');
                $('#login-email, #login-password').addClass('invalid');
                $('#login-email, #login-password').removeClass('valid');
                $('#login-email, #login-password').css('-webkit-animation-name', 'autofillinvalid');
            } else if (error.message === '401') {
                deleteAuthCookies();
                $('#login-Invalid-error-401').css('display', 'block');
                $('#login-Invalid-error-404').css('display', 'none');
                $('#login-Invalid-error-500').css('display', 'none');
                $('#login-Invalid-error-400').css('display', 'none');
                $('#login-email, #login-password').addClass('invalid');
                $('#login-email, #login-password').removeClass('valid');
                $('#login-email, #login-password').css('-webkit-animation-name', 'autofillinvalid');
            } else if (error.message === '404') {
                deleteAuthCookies();
                $('#login-Invalid-error-401').css('display', 'none');
                $('#login-Invalid-error-404').css('display', 'block');
                $('#login-Invalid-error-500').css('display', 'none');
                $('#login-Invalid-error-400').css('display', 'none');
                $('#login-email, #login-password').addClass('invalid');
                $('#login-email, #login-password').removeClass('valid');
                $('#login-email, #login-password').css('-webkit-animation-name', 'autofillinvalid');
            } else if (error.message === '400') {
                deleteAuthCookies();
                $('#login-Invalid-error-401').css('display', 'none');
                $('#login-Invalid-error-404').css('display', 'none');
                $('#login-Invalid-error-500').css('display', 'none');
                $('#login-Invalid-error-400').css('display', 'block');
                $('#login-email, #login-password').addClass('invalid');
                $('#login-email, #login-password').removeClass('valid');
                $('#login-email, #login-password').css('-webkit-animation-name', 'autofillinvalid');
            }
            loginButton.innerHTML = getI18n('menubar.items.login'); // Update button text appropriately
        }
    },
    loginafterregistrationorpasswordreset: async function (callback) {
        $('#logging-in-svg').css('display', 'block');
        const email = document.getElementById('passwordresetcomplete-email').value;
        const password = document.getElementById('passwordresetcomplete-password').value;

        // console.log('pasword: ' + password);

        const loginRequest = {
            email: email,
            password: password,
            domain: getSiteNameForStripe(),
        };

        try {
            const response = await fetch(getApiUrl('login', 'loginapi'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(loginRequest)
            });


            if (!response.ok) {
                const text = await response.text();
                let errorData = {};
                try {
                    errorData = JSON.parse(text);
                } catch (err) {
                    console.error("Error parsing JSON:", err);
                }

                let errorMessage = `Error ${response.status}: ${errorData.message || response.statusText}`;
                if (response.status === 401) { // Unauthorized
                    errorMessage = "401";
                } else if (response.status === 404) { // Not found
                    errorMessage = "404";
                } else if (response.status >= 500) {
                    errorMessage = "500";
                } else if (response.status >= 400) {
                    errorMessage = "400";
                }

                throw new Error(errorMessage);
            }

            const data = await response.json();
            //console.log('Success:', data);
            var initial = "A";
            if (data.firstname)
                initial = data.firstname.charAt(0).toUpperCase();
            showLoggedInSvg(initial);

            setAuthCookies(data.token, directVendor, data.firstname, data.lastname, initial, data.folderId);//This will set the token, email and vendor in cookies - use functions
            console.log("FolderId After registration complete Login: ", getFolderIdFromCookies());

            const vendor = getVendorFromCookies();
            const folderUUID = getFolderIdFromCookies();
            const hostname = window.location.hostname;

            await fetchAndStoreDataOnLogin(folderUUID, vendor, false, false);

            if (actionInProgress) { //This is message to generate the current functions
                await getSignedCookies(folderUUID, vendor, hostname);
            } else {
                await getSignedCookies(folderUUID, vendor, hostname);
            }

            window.recaptchaVerification.setInitialMultiple(3);

            //getJwtTokenFromCookies(), getEmailFromCookies() and getVendorFromCookies()

            $('#login-Invalid-error-401').css('display', 'none');
            $('#login-Invalid-error-404').css('display', 'none');
            $('#login-Invalid-error-500').css('display', 'none');
            $('#login-Invalid-error-400').css('display', 'none');
            $('#login-email, #login-password').addClass('valid');
            $('#login-email, #login-password').removeClass('invalid');
            $('#login-email, #login-password').css('-webkit-animation-name', 'autofillvalid');
            $('#logging-in-svg').css('display', 'none');

            // Callback after successful login
            if (typeof callback !== 'undefined') {
                callback(data);
            }
            this.hideLoginPopup();

            if (actionInProgress) { //This is message to generate the current functions
                console.log ('Setting action in progress to null in loginafterregistration');
                actionInProgress();
                actionInProgress = null;
            }

        } catch (error) {
            deleteAuthCookies(); //delete the auth cookies
            console.error('Error Message:', error);
            if (error.name === 'TypeError' || error.message === '500') {
                $('#logging-in-svg').css('display', 'none');
                $('#login-Invalid-error-401').css('display', 'none');
                $('#login-Invalid-error-404').css('display', 'none');
                $('#login-Invalid-error-500').css('display', 'block');
                $('#login-Invalid-error-400').css('display', 'none');
                $('#login-email, #login-password').addClass('invalid');
                $('#login-email, #login-password').removeClass('valid');
                $('#login-email, #login-password').css('-webkit-animation-name', 'autofillinvalid');
            } else if (error.message === '401') {
                deleteAuthCookies(); //delete the auth cookies
                $('#logging-in-svg').css('display', 'none');
                $('#login-Invalid-error-401').css('display', 'block');
                $('#login-Invalid-error-404').css('display', 'none');
                $('#login-Invalid-error-500').css('display', 'none');
                $('#login-Invalid-error-400').css('display', 'none');
                $('#login-email, #login-password').addClass('invalid');
                $('#login-email, #login-password').removeClass('valid');
                $('#login-email, #login-password').css('-webkit-animation-name', 'autofillinvalid');
            } else if (error.message === '404') {
                deleteAuthCookies(); //delete the auth cookies
                $('#logging-in-svg').css('display', 'none');
                $('#login-Invalid-error-401').css('display', 'none');
                $('#login-Invalid-error-404').css('display', 'block');
                $('#login-Invalid-error-500').css('display', 'none');
                $('#login-Invalid-error-400').css('display', 'none');
                $('#login-email, #login-password').addClass('invalid');
                $('#login-email, #login-password').removeClass('valid');
                $('#login-email, #login-password').css('-webkit-animation-name', 'autofillinvalid');
            } else if (error.message === '400') {
                deleteAuthCookies(); //delete the auth cookies
                $('#logging-in-svg').css('display', 'none');
                $('#login-Invalid-error-401').css('display', 'none');
                $('#login-Invalid-error-404').css('display', 'none');
                $('#login-Invalid-error-500').css('display', 'none');
                $('#login-Invalid-error-400').css('display', 'block');
                $('#login-email, #login-password').addClass('invalid');
                $('#login-email, #login-password').removeClass('valid');
                $('#login-email, #login-password').css('-webkit-animation-name', 'autofillinvalid');
            }

            // Callback in case of error
            if (typeof callback !== 'undefined') {
                callback(null, error);
            }
        }
    },
    register: async function (callback) {
        var firstName = document.getElementById('signup-firstname').value;
        var lastName = document.getElementById('signup-lastname').value;
        var email = document.getElementById('signup-email').value;
        var password = document.getElementById('signup-password').value;

        var registrationRequest = {
            firstName: firstName,
            lastName: lastName,
            email: email,
            password: password,
            domain: getSiteNameForStripe(),
            imageUrl: null // Assuming there's no image URL in the form
        };

        // Disable register button and show loader
        var registerButton = document.getElementById('signupform-button');
        registerButton.setAttribute("disabled", 'disabled');
        registerButton.innerHTML = '<div class="loader-register"></div>';

        try {
            const response = await fetch(getApiUrl('register', 'loginapi'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(registrationRequest)
            });

            registerButton.removeAttribute("disabled");
            registerButton.innerHTML = getI18n('wpanel.widgets.button.submit'); // Update button text appropriately

            if (!response.ok) {
                let errorData = {};
                let text = '';
                try {
                    text = await response.text();
                    if (text && text.trim().startsWith('{')) {
                        errorData = JSON.parse(text);
                    }
                } catch (err) {
                    console.error("Error parsing JSON:", err);
                }


                let errorMessage = `Error ${response.status}: ${errorData.message || response.statusText}`;
                switch (response.status) {
                    case 409:
                    case 422:
                    case 417:
                        errorMessage = `${response.status}`;
                        break;
                    case 500:
                        errorMessage = '500';
                        break;
                    default:
                        if (response.status >= 400) {
                            errorMessage = '400';
                        }
                        break;
                }

                console.log('Throwing error Message:', errorMessage);
                throw new Error(errorMessage);
            }

            const data = await response.text();
            //  console.log('Success:', data);

            $('#signup-Invalid-error-409').css('display', 'none');
            $('#signup-Invalid-error-500').css('display', 'none');
            $('#signup-Invalid-error-400').css('display', 'none');
            $('#signup-Invalid-error-422').css('display', 'none');
            $('#signup-Invalid-error-417').css('display', 'none');
            $('#signup-firstname, #signup-lastname, #signup-email, #signup-password').addClass('valid');
            $('#signup-firstname, #signup-lastname, #signup-email, #signup-password').removeClass('invalid');
            $('#signup-firstname, #signup-lastname, #signup-email, #signup-password').css('-webkit-animation-name', 'autofillvalid');

            // Callback after successful registration
            // Callback after successful password reset request
            if (typeof callback !== 'undefined') {
                callback(data ? JSON.parse(data) : null); // Handle empty response text
            }

            const message = getI18n('registration_complete');
            const submessage = getI18n('registration_complete_submessage');

            const credentials = [
                { type: "email", value: email },
                { type: "password", value: password },
                { type: "message", value: message },
                { type: "submessage", value: submessage },
            ];
            thisEditor.logginginregistrationorpasswordresetcomplete(false, credentials);

        } catch (error) {
            console.error('Error Message:', error.message);
            registerButton.removeAttribute("disabled");
            registerButton.innerHTML = getI18n('wpanel.widgets.button.submit'); // Update button text appropriately

            if (error.name === 'TypeError' || error.message === '500') {
                $('#signup-Invalid-error-500').css('display', 'block');
                $('#signup-Invalid-error-400').css('display', 'none');
                $('#signup-Invalid-error-409').css('display', 'none');
                $('#signup-Invalid-error-422').css('display', 'none');
                $('#signup-Invalid-error-417').css('display', 'none');
                $('#signup-firstname, #signup-lastname, #signup-email, #signup-password').addClass('invalid');
                $('#signup-firstname, #signup-lastname, #signup-email, #signup-password').removeClass('valid');
                $('#signup-firstname, #signup-lastname, #signup-email, #signup-password').css('-webkit-animation-name', 'autofillinvalid');
            } else if (error.message === '409') {
                $('#signup-Invalid-error-409').css('display', 'block');
                $('#signup-Invalid-error-500').css('display', 'none');
                $('#signup-Invalid-error-400').css('display', 'none');
                $('#signup-Invalid-error-422').css('display', 'none');
                $('#signup-Invalid-error-417').css('display', 'none');
                $('#signup-firstname, #signup-lastname, #signup-email, #signup-password').addClass('invalid');
                $('#signup-firstname, #signup-lastname, #signup-email, #signup-password').removeClass('valid');
                $('#signup-firstname, #signup-lastname, #signup-email, #signup-password').css('-webkit-animation-name', 'autofillinvalid');
            } else if (error.message === '400') {
                $('#signup-Invalid-error-400').css('display', 'block');
                $('#signup-Invalid-error-409').css('display', 'none');
                $('#signup-Invalid-error-500').css('display', 'none');
                $('#signup-Invalid-error-422').css('display', 'none');
                $('#signup-Invalid-error-417').css('display', 'none');
                $('#signup-firstname, #signup-lastname, #signup-email, #signup-password').addClass('invalid');
                $('#signup-firstname, #signup-lastname, #signup-email, #signup-password').removeClass('valid');
                $('#signup-firstname, #signup-lastname, #signup-email, #signup-password').css('-webkit-animation-name', 'autofillinvalid');
            } else if (error.message === '422') {
                $('#signup-Invalid-error-400').css('display', 'none');
                $('#signup-Invalid-error-409').css('display', 'none');
                $('#signup-Invalid-error-500').css('display', 'none');
                $('#signup-Invalid-error-422').css('display', 'block');
                $('#signup-Invalid-error-417').css('display', 'none');
                $('#signup-firstname, #signup-lastname, #signup-email, #signup-password').addClass('invalid');
                $('#signup-firstname, #signup-lastname, #signup-email, #signup-password').removeClass('valid');
                $('#signup-firstname, #signup-lastname, #signup-email, #signup-password').css('-webkit-animation-name', 'autofillinvalid');
            } else if (error.message === '417') {
                $('#signup-Invalid-error-400').css('display', 'none');
                $('#signup-Invalid-error-409').css('display', 'none');
                $('#signup-Invalid-error-500').css('display', 'none');
                $('#signup-Invalid-error-422').css('display', 'none');
                $('#signup-Invalid-error-417').css('display', 'block');
                $('#signup-firstname, #signup-lastname, #signup-email, #signup-password').addClass('invalid');
                $('#signup-firstname, #signup-lastname, #signup-email, #signup-password').removeClass('valid');
                $('#signup-firstname, #signup-lastname, #signup-email, #signup-password').css('-webkit-animation-name', 'autofillinvalid');
            }

            // Callback in case of error
            if (typeof callback !== 'undefined') {
                callback(null, error);
            }


        }
    },
    requestPasswordReset: async function (callback) {
        const email = document.getElementById('forgot-password-email').value;
        var locale = getLanguage();
        console.log("Locale is: " + locale);

        // Disable reset password button and show loader
        const resetPasswordButton = document.getElementById('resetpassword-button');
        resetPasswordButton.setAttribute("disabled", 'disabled');
        resetPasswordButton.innerHTML = '<div class="loader-register"></div>';



        try {
            //request-password-reset
            const response = await fetch(getApiUrl('request-password-reset', 'loginapi'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email: email, locale: locale, domain: getSiteNameForStripe() })
            });

            resetPasswordButton.removeAttribute("disabled");
            resetPasswordButton.innerHTML = getI18n('resetpassword');

            if (!response.ok) {
                const text = await response.text();
                let errorData = {};
                try {
                    errorData = text ? JSON.parse(text) : {};
                } catch (err) {
                    console.error("Error parsing JSON:", err);
                }
                let errorMessage = `Error ${response.status}: ${errorData.message || response.statusText}`;
                if (response.status === 404) {
                    errorMessage = "404";
                } else {
                    errorMessage = "500";
                }

                throw new Error(errorMessage);
            }

            const data = await response.text();
            //console.log('Success:', data);
            $('#forgot-password-error').css('display', 'none');

            // Callback after successful password reset request
            if (typeof callback !== 'undefined') {
                callback(data ? JSON.parse(data) : null); // Handle empty response text
            }

            thisEditor.showLoginPopup(false, false, true);

        } catch (error) {
            console.error('Error Message:', error.message);
            resetPasswordButton.removeAttribute("disabled");
            resetPasswordButton.innerHTML = getI18n('resetpassword');

            if (error.name === 'TypeError' || error.message === '500') {
                $('#resetPassword-Invalid-error-404').css('display', 'none');
                $('#resetPassword-Invalid-error-500').css('display', 'block');
                $('#forgot-password-email').addClass('invalid');
                $('#forgot-password-email').removeClass('valid');
                $('#forgot-password-email').css('-webkit-animation-name', 'autofillinvalid');
            } else if (error.message === '404') {
                thisEditor.showLoginPopup(false, false, true);
            }

            // Callback in case of error
            if (typeof callback !== 'undefined') {
                callback(null, error);
            }
        }
    },
    resetPassword: async function (callback) {//This is Recreate Password or reset password where you have the new and confirm password fields
        //console.log("Inside reset Password");


        const email = document.getElementById('recreate-password-email').value;
        const newPassword = document.getElementById('recreate-password-new').value;
        const token = document.getElementById('recreate-password-token').value;

        //console.log('New Password is: ' + newPassword);

        // Disable recreate password button and show loader
        const recreatePasswordButton = document.getElementById('recreatepasswordform-button');
        recreatePasswordButton.setAttribute("disabled", 'disabled');
        recreatePasswordButton.innerHTML = '<div class="loader-register"></div>';

        try {
            //resetPassword
            const response = await fetch(getApiUrl('reset-password', 'loginapi'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ token, newPassword, domain: getSiteNameForStripe() })
            });

            recreatePasswordButton.removeAttribute("disabled");
            recreatePasswordButton.innerHTML = getI18n('resetpassword');


            if (!response.ok) {
                const text = await response.text();
                let errorData = {};
                try {
                    errorData = text ? JSON.parse(text) : {};
                } catch (err) {
                    console.error("Error parsing JSON:", err);
                }
                let errorMessage = `Error ${response.status}: ${errorData.message || response.statusText}`;
                if (response.status === 406) { // Assuming 409 Conflict for already existing email
                    errorMessage = "406";
                } else if (response.status === 404) { // Assuming 409 Conflict for already existing email
                    errorMessage = "404";
                } else if (response.status >= 500) {
                    errorMessage = "500";
                } else if (response.status >= 400) {
                    errorMessage = "400";
                }

                throw new Error(errorMessage);
            }

            const data = await response.text();
            console.log('response data', data);
            // console.log('Success:', data);
            $('#recreate-password-error-406').css('display', 'none');
            $('#recreate-password-error-500').css('display', 'none');
            $('#recreate-password-error-400').css('display', 'none');
            $('#recreate-password-error-404').css('display', 'none');
            $('#recreate-password-new, #recreate-password-confirm').addClass('valid');
            $('#recreate-password-new, #recreate-password-confirm').removeClass('invalid');
            $('#recreate-password-new, #recreate-password-confirm').css('-webkit-animation-name', 'autofillvalid');


            // Callback after successful password reset request
            if (typeof callback !== 'undefined') {
                callback(data ? JSON.parse(data) : null); // Handle empty response text
            }

            const message = getI18n('passwordresetcomplete');
            const submessage = getI18n('passwordresetcommpletelogginginnow');

            const credentials = [
                { type: "email", value: email },
                { type: "password", value: newPassword },
                { type: "message", value: message },
                { type: "submessage", value: submessage }
            ];
            thisEditor.logginginregistrationorpasswordresetcomplete(false, credentials);

        } catch (error) {
            console.error('Error Message:', error.message);
            recreatePasswordButton.removeAttribute("disabled");
            recreatePasswordButton.innerHTML = getI18n('resetpassword');
            if (error.name === 'TypeError' || error.message === '500') {
                $('#recreate-password-error-500').css('display', 'block');
                $('#recreate-password-new, #recreate-password-confirm').addClass('invalid');
                $('#recreate-password-new, #recreate-password-confirm').removeClass('valid');
                $('#recreate-password-new, #recreate-password-confirm').css('-webkit-animation-name', 'autofillinvalid');
            } else if (error.message === '406') {
                $('#recreate-password-error-406').css('display', 'block');
                $('#recreate-password-new, #recreate-password-confirm').addClass('invalid');
                $('#recreate-password-new, #recreate-password-confirm').removeClass('valid');
                $('#recreate-password-new, #recreate-password-confirm').css('-webkit-animation-name', 'autofillinvalid');
            } else if (error.message === '400') {
                $('#recreate-password-error-400').css('display', 'block');
                $('#recreate-password-new, #recreate-password-confirm').addClass('invalid');
                $('#recreate-password-new, #recreate-password-confirm').removeClass('valid');
                $('#recreate-password-new, #recreate-password-confirm').css('-webkit-animation-name', 'autofillinvalid');
            } else if (error.message === '404') {
                $('#recreate-password-error-404').css('display', 'block');
                $('#recreate-password-new, #recreate-password-confirm').addClass('invalid');
                $('#recreate-password-new, #recreate-password-confirm').removeClass('valid');
                $('#recreate-password-new, #recreate-password-confirm').css('-webkit-animation-name', 'autofillinvalid');
            }

            // Callback in case of error
            if (typeof callback !== 'undefined') {
                callback(null, error);
            }
        }
    },
    scrollToTopRecursively: async function (element) {
        try {
            //console.log ('Scrolling recursively to the top of window');
            if (element.length) {
                // Scroll to the top of the current element
                element[0].scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'auto'  // This makes the scrolling instant
                });

                // Recursively scroll to the top of its parent element
                var parentElement = element.parent();
                if (parentElement.length && parentElement[0] !== document) {
                    thisEditor.scrollToTopRecursively(parentElement);
                }
            } else {
                console.warn('Target element not found.');
            }
        } catch (error) {
            console.error('Error in Scrolling to the top:', error);
        }
    },

    registerGoogleUser: async function (given_name, family_name, email, picture, folderId) {
        const googleUser = {
            firstName: given_name,
            lastName: family_name,
            email: email,
            imageUrl: picture,
            folderId: folderId,
            domain: getSiteNameForStripe()
        };

        try {
            const response = await fetch(getApiUrl('googleregistration', 'loginapi'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(googleUser)
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => null);
                console.error('Google registration failed:', response.statusText, errorData);

                if (response.status === 417) {
                    Swal.fire({
                        title: getI18n('google_error_title'),
                        text: getI18n('google_signup_to_existing_email_error'),
                        icon: "error",
                    });
                } else {
                    Swal.fire({
                        title: getI18n('google_error_title'),
                        text: getI18n('google_signup_unknown_error'),
                        icon: "error",
                    });
                }

                return null;
            }

            const responseData = await response.json();
            return responseData; // UnifiedUserResponse object

        } catch (error) {
            //if error code is 417 the text should be google_signup_to_existing_email_error
            Swal.fire({
                title: getI18n('google_error_title'),
                text: getI18n('google_signup_unknown_error'),
                icon: "error",
            });
            return null;
            console.error('Error during Google registration:', error);

        }
    },

    changeTemplate: function (url) {
        var thisEditor = this;

        // checl if has callback for changing template
        if (typeof (thisEditor.changeTemplateCallback) != 'undefined') {
            Swal.fire({
                title: getI18n('are_you_sure'),
                text: getI18n('text_are_you'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: getI18n('confirm_apply')
            }).then((result) => {
                if (result.value) {
                    Swal.fire({
                        title: getI18n('good_job'),
                        text: getI18n('success_aplly'),
                        icon: "success",
                    }).then((result) => {
                        thisEditor.changeTemplateCallback(url);
                    });
                }
            });
            return;
        }

        var data = {
            _token: CSRF_TOKEN
        }

        if (thisEditor.data !== null) {
            data = $.extend({}, data, thisEditor.data);
        }

        $.ajax({
            url: url,
            type: 'GET',
            headers: thisEditor.header,
            data: {
                _token: CSRF_TOKEN
            },
        }).done(function (data, textStatus, jqXHR) { // jqXHR.status == 200
            if (jqXHR.status == 200) {
                // Okie, done, redirect to index
                Swal.fire({
                    title: getI18n('good_job'),
                    text: getI18n('success_aplly'),
                    icon: "success",
                }).then((result) => {
                    location.reload();
                });
            } else {
                alert('Failed choose');
                // Tr ve form voi error messaqge ==> thanh cong 200!
            }
        }).fail(function (jqXHR, textStatus, errorThrown) { // jqXHR.status = 5xx hoac 4xx
            alert(getI18n('error_save') + errorThrown);
        });
    },

    back: async function () {
        console.log('Back is called');
        if (isUserLoggedIn())
            window.recaptchaVerification.recaptchaVerificationInit(saveVerificationSuccessGoBack, getEmailPrefixWithVendorFromCookies());
        else {
            thisEditor.showLoginPopup(false, false, false, false, false, saveVerificationSuccessGoBack,
                function (data) { window.recaptchaVerification.recaptchaVerificationInit(saveVerificationSuccessGoBack, getEmailPrefixWithVendorFromCookies()); }
            );
        }
    },

    synchronization: function (data) {
        var sync = $(data).attr('data-sync');
        $('button.btn-sync').find('i').removeClass('fab fa-google');
        $('button.btn-sync').find('i').removeClass('fab fa-dropbox');
        $('button.btn-sync').find('i').removeClass('fab fa-google-drive');

        if (sync == 'google-driver') {
            $('button.btn-sync').find('i').addClass('fab fa-google');
        } else if (sync == 'dropbox') {
            $('button.btn-sync').find('i').addClass('fab fa-dropbox');
        } else if (sync == 'one-driver') {
            $('button.btn-sync').find('i').addClass('fab fa-google-drive');
        }
        $('ul.action-sync').removeClass('show-action');
    },

    settingSync: function () {
        $('ul.action-sync').removeClass('show-action');
        Swal.fire({
            title: getI18n('setting_title'),
            text: getI18n('setting_text'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: getI18n('ok')
        }).then((result) => {
            if (result.value) {

            }
        });
    },


    checkEmpty() {
        var thisEditor = this;

        $("#builder_iframe").contents().find("[builder-element='PageElement']").each(function () {
            if ($(this).html().trim() == '') {
                $(this).addClass('container-_blank');
                $(this).html('');
            } else {
                $(this).removeClass('container-_blank');
            }
        });

        // remove all space inside cells to make sure :empty css works
        $("#builder_iframe").contents().find("[builder-element='CellElement']").each(function () {
            if ($(this).html().trim() == '') {
                $(this).html('');
            }
        });


        // js auto height iframe
        thisEditor.adjustIframeSize();
    },



    // find mouse over element
    findMouseOverElement: function (e) {
        var elem = $($("#builder_iframe")[0].contentWindow.document.elementFromPoint(
            e.pageX + $("#builder_iframe").offset().left - $("#builder_iframe").contents().find("body").scrollLeft(),
            e.pageY + $("#builder_iframe").offset().top - $("#builder_iframe").contents().find("html").scrollTop()
        ));
        return elem.closest('[class*="col-"]');
    },


    scaleEditorToFit: function (force = false) {
        if (window.innerWidth <= 1000 || force) {
            const baseScaleFactor = window.innerWidth / 1021;
            thisEditor.scaleToSize(baseScaleFactor);
        } else {
            thisEditor.scaleToSize(1);
        }
    },



    inlineEdit: async function (container) {
        var thisEditor = this;

        if (thisEditor.inlineEditor == 'tinymce') {

            var tinyconfig = {
                skin: 'tinymce-5',
                theme: 'silver',
                mobile: {
                    toolbar_sticky: true,
                    toolbar: false,
                },
                valid_elements: '*[*]',
                extended_valid_elements: 'h6[class|contenteditable|style],p[class|contenteditable|style]',
                valid_children: '+p[ol],+p[ul],+h1[div],+h2[div],+h3[div],+h4[div],+h5[div],+h6[div],+h6[p],+div[h6|p],+a[div],*[*]',
                allow_html_in_named_anchor: true,
                // resize: false,
                inline: false,
                menubar: false,
                nowrap: false,
                force_br_newlines: false,
                force_p_newlines: false,
                forced_root_block: '',
                relative_urls: false,
                convert_urls: false,
                remove_script_host: false,
                inline_boundaries: true,
                inline_styles: true,
                toolbar_sticky: true,
                automatic_uploads: false,
                plugins: 'autoresize paste link lists autolink lineheight fontawesomepicker hrcustom mycareer cropimage pagebreak case topspacing',
                autoresize_bottom_margin: 200,
                //paste_as_text: true,
                //  plugins: 'print preview lineheight fontawesomepicker searchreplace autolink codesample code directionality visualblocks visualchars fullscreen image link media template codesample charmap hr pagebreak nonbreaking anchor toc insertdatetime lists textcolor wordcount imagetools contextmenu colorpicker textpattern help',
                images_file_types: 'jpeg,jpg,jpe,png,gif,webp,svg',
                browser_spellcheck: true,
                pagebreak_separator: '<div class="page-break"></div>',
                contextmenu: ' ',
                deprecation_warnings: false,
                fontsize_formats: "8pt 9pt 10pt 11pt 12pt 13pt 14pt 16pt 18pt 20pt 22pt 24pt 28pt 32pt 36pt 48pt 60pt 72pt 96pt",
                // v6 // font_size_formats: "8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt",
                //font_formats: "Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago;  Oswald=oswald; Symbol=symbol; Lato Black=lato; Roboto=roboto; Roboto Condensed=roboto condensed; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
                //v6 format // font_family_formats: "Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Rubik=Rubik,sans-serif;Roboto=Roboto,sans-serif;  Oswald=oswald; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",

                toolbar: 'undo redo | bold italic underline | fontselect | fontsizeselect | lineheightselect topspacing| case | forecolor backcolor | numlist bullist outdent indent | fontawesomepicker html-save| downloadpdf pagesetup| previewpdf| pagebreak toggleTextMenu',
                //toolbar: 'undo redo | bold italic underline | styleselect | fontselect | fontsizeselect lineheightselect| forecolor backcolor | alignleft aligncenter alignright alignfull | downloadpdf downloadword | numlist bullist outdent indent | hrcustom  | fontawesomepicker html-save| mycareer cropimage',

                //v6 toolbar: 'undo redo | bold italic underline | fontfamily fontsize | forecolor backcolor | alignleft aligncenter alignright alignfull | numlist bullist outdent indent | image',
                //fixed_toolbar_container: '#builder_sidebar-left',
                //pagebreak_separator: '<!------------------------- my page break ------------------------------->',

                content_css: [window.location.origin + constants.GREEN_LEFT_TEMPLATE_CSS, window.location.origin + constants.BUILDER_IFRAME_CSS, window.location.origin + constants.JQUERY_UI_CSS],
                font_formats: 'Arial=arial,helvetica,sans-serif;Courier New=courier,new,courier,monospace; Lato Black=Lato; Montserrat=Montserrat,sans-serif;Open Sans=Open Sans, sans-serif;Roboto=Roboto, sans-serif;Oswald=Oswald, sans-serif;Raleway=Raleway, sans-serif; Rubik=Rubik,sans-serif; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva;',
                object_resizing: false,
                content_style: '@media screen { html { background-color:  transparent;}} ' +
                    'img.left { float: left; } ' +
                    'table.left { float: left; } ' +
                    '.right { text-align: right; } ' +
                    'img.right { float: right; } ' +
                    'table.right { float: right; } ' +
                    '.center { text-align: center; } ' +
                    'img.center { display: block; margin: 0 auto; } ' +
                    'table.center { display: block; margin: 0 auto; } ' +
                    '.full { text-align: justify; } ' +
                    'img.full { display: block; margin: 0 auto; } ' +
                    'table.full { display: block; margin: 0 auto; } ' +
                    '.bold { font-weight: bold; } ' +
                    '.italic { font-style: italic; } ' +
                    '.underline { text-decoration: underline; } ' +
                    '.example1 {} ' +
                    '.tablerow1 { background-color: #D3D3D3; }',
                formats: {
                    alignleft: { inline: 'span', classes: 'left' },
                    aligncenter: { inline: 'span', classes: 'center' },
                    alignright: { inline: 'span', classes: 'right' },
                    alignjustify: { inline: 'span', classes: 'full' },
                    bold: { inline: 'span', classes: 'bold' },
                    italic: { inline: 'span', classes: 'italic' },
                    underline: { inline: 'span', classes: 'underline', exact: true },
                    strikethrough: { inline: 'del' },
                    customformat: { inline: 'span', styles: { color: '#00ff00', fontSize: '20px' }, attributes: { title: 'My custom format' }, classes: 'example1' },
                },
                lineheight_formats: "1 1.1 1.2 1.3 1.4 1.5 1.75 2 3 4 5",
                autosave_restore_when_empty: true,
                autosave_retention: '60m',
                autosave_interval: '20s',
                fontawesomeUrl: constants.FONT_AWESOME_CSS,
                fontawesomePro: false, //default: false, enable or disable Pro vs Free font
                paste_data_images: true,
                images_upload_handler: function (blobInfo, success, failure) {
                    // no upload, just return the blobInfo.blob() as base64 data
                    success("data:" + blobInfo.blob().type + ";base64," + blobInfo.base64());
                },
                setup: function (editor) {
                    /* Menu button that has a simple "insert date" menu item, and a submenu containing other formats. */
                    /* Clicking the first menu item or one of the submenu items inserts the date in the selected format. */

                    let lastSavedHash = ""; // Store last cleaned content hash
                    let isManuallyDirty = false; // Flag to track manual changes

                    initTinyMCEWithDragAndDrop(editor);

                    editor.ui.registry.addMenuButton('menuDateButton', {
                        text: getI18n('editor.insert_tag'),
                        fetch: function (callback) {
                            var items = [];

                            thisEditor.tags.forEach(function (tag) {
                                if (tag.type == 'label') {
                                    items.push({
                                        type: 'menuitem',
                                        text: tag.tag.replace("{", "").replace("}", ""),
                                        onAction: function (_) {
                                            if (tag.text) {
                                                editor.insertContent(tag.text);
                                            } else {
                                                editor.insertContent(tag.tag);
                                            }
                                        }
                                    });
                                }
                            });

                            callback(items);
                        }
                    });
                    editor.ui.registry.addIcon('pdf-download', '<svg xmlns="http://www.w3.org/2000/svg" height="24" width="20" viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.--><path opacity="1" fill="#1E3050" d="M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1 .1-.2 .1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"/></svg>');

                    editor.ui.registry.addIcon('html-save', '<svg xmlns="http://www.w3.org/2000/svg" height="24" width="20" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.--><path opacity="1" fill="#1E3050" d="M433.9 129.9l-83.9-83.9A48 48 0 0 0 316.1 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V163.9a48 48 0 0 0 -14.1-33.9zM224 416c-35.3 0-64-28.7-64-64 0-35.3 28.7-64 64-64s64 28.7 64 64c0 35.3-28.7 64-64 64zm96-304.5V212c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12V108c0-6.6 5.4-12 12-12h228.5c3.2 0 6.2 1.3 8.5 3.5l3.5 3.5A12 12 0 0 1 320 111.5z"/></svg>');

                    editor.ui.registry.addIcon('preview-pdf', '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">  <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"/>  <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"/></svg>');

                    editor.ui.registry.addIcon('page-setup', '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z"/> <g transform="translate(3.4, 3.5) scale(0.46)"> <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"/> </g> </svg>');

                    editor.ui.registry.addIcon('hide-text-menu', '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-menu-app-fill" viewBox="0 0 16 16"> <path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h2A1.5 1.5 0 0 1 5 1.5v2A1.5 1.5 0 0 1 3.5 5h-2A1.5 1.5 0 0 1 0 3.5zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"/> <!-- Add the slash --> <line x1="1" y1="15" x2="15" y2="1" stroke="currentColor" stroke-width="1.5" /> </svg>');

                    editor.ui.registry.addIcon(
                        'top-spacing',
                        `
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M160-760v-80h640v80H160Zm280 640v-408L336-424l-56-56 200-200 200 200-56 56-104-104v408h-80Z"/></svg>
                        `
                    );

                    editor.ui.registry.addToggleButton('toggleTextMenu', {
                        icon: 'hide-text-menu',
                        tooltip: 'hide-text-menu', // Initial tooltip
                        onAction: (buttonApi) => {
                            // Get the current value from sessionStorage, default to 'false' (menu is visible initially)
                            const currentValue = sessionStorage.getItem('hideTextMenu') || 'false';

                            // Toggle the value: if currently 'false', set to 'true'; otherwise, set to 'false'
                            const newValue = currentValue === 'false' ? 'true' : 'false';
                            sessionStorage.setItem('hideTextMenu', newValue);

                            // Call thisEditor.unselect() if the menu is being hidden (newValue is 'true')
                            if (newValue === 'true') {
                                thisEditor.unselect();
                            }

                            // Update the button's active state
                            const isActive = newValue === 'true'; // Active when the text menu is hidden
                            buttonApi.setActive(isActive); // Reflect active state for the toggle button
                        },
                        onSetup: (buttonApi) => {
                            // Initialize the button state based on sessionStorage, default to 'false' (menu visible)
                            const currentValue = sessionStorage.getItem('hideTextMenu') || 'false';
                            const isActive = currentValue === 'true'; // Active when the text menu is hidden
                            buttonApi.setActive(isActive);
                        },
                    });


                    editor.addShortcut('meta+s', 'Save content', function (t) {
                        if (editor.isDirty() || themeChanged || thisEditor.saveToServer) {
                            thisEditor.saveToServer = true;
                            if (isUserLoggedIn())
                                window.recaptchaVerification.recaptchaVerificationInit(saveVerificationSuccess, getEmailPrefixWithVendorFromCookies());
                            else {
                                thisEditor.showLoginPopup(false, false, false, false, false, saveVerificationSuccess,
                                    function (data) { window.recaptchaVerification.recaptchaVerificationInit(saveVerificationSuccess, getEmailPrefixWithVendorFromCookies()); }
                                );
                            }
                        } else {
                            thisEditor.notificationArea(getI18n('nothing_to_save'), 'info');
                        }

                    });






                    editor.ui.registry.addButton('downloadpdf', {
                        icon: 'pdf-download',
                        tooltip: 'pdf-download',
                        onAction: doExportPdf
                    });















                    function doExportPdf() {
                        if (isUserLoggedIn())
                            window.recaptchaVerification.recaptchaVerificationInit(pdfExportVerificationSuccess, getEmailPrefixWithVendorFromCookies());
                        else {
                            thisEditor.showLoginPopup(
                                false,
                                false,
                                false,
                                false,
                                false,
                                pdfExportVerificationSuccess,
                                function (data) {
                                    window.recaptchaVerification.recaptchaVerificationInit(
                                        pdfExportVerificationSuccess,
                                        getEmailPrefixWithVendorFromCookies() // Use data from the login response as needed
                                    );
                                }
                            );
                        }
                    }

                    editor.ui.registry.addButton('previewpdf', {
                        icon: 'preview-pdf',
                        tooltip: 'preview-pdf',
                        onAction: previewPdf
                    });

                    function previewPdf() {
                        if (isUserLoggedIn())
                            window.recaptchaVerification.recaptchaVerificationInit(pdfPreviewVerificationSuccess, getEmailPrefixWithVendorFromCookies());
                        else {
                            thisEditor.showLoginPopup(
                                false,
                                false,
                                false,
                                false,
                                false,
                                pdfPreviewVerificationSuccess,
                                function (data) {
                                    window.recaptchaVerification.recaptchaVerificationInit(
                                        pdfPreviewVerificationSuccess,
                                        getEmailPrefixWithVendorFromCookies() // Use data from the login response as needed
                                    );
                                }
                            );
                        }
                    }

                    editor.ui.registry.addButton('pagesetup', {
                        icon: 'page-setup',
                        tooltip: 'page-setup',
                        onAction: doPageSetup
                    });

                    function doPageSetup() {
                        window.PDFConfigModule.init();  // Initialize the module
                        window.PDFConfigModule.openModal();  // Open the modal
                    }

                    editor.ui.registry.addButton('html-save', {
                        icon: 'html-save',
                        tooltip: 'save',
                        onAction: doSave
                    });

                    function doSave() {
                        if (isUserLoggedIn())
                            window.recaptchaVerification.recaptchaVerificationInit(saveVerificationSuccess, getEmailPrefixWithVendorFromCookies());
                        else {
                            thisEditor.showLoginPopup(false, false, false, false, false, saveVerificationSuccess,
                                function (data) { window.recaptchaVerification.recaptchaVerificationInit(saveVerificationSuccess, getEmailPrefixWithVendorFromCookies()); }
                            );
                        }
                    }



                    function onSliderInput(event) {
                        updateSliderValue(event.target);
                        updateSliderLabels(event.target);
                        updateSliderProgress(event.target);
                    }

                    function updateSliderValue(slider) {
                        let value = slider.parentNode.querySelector('#' + slider.dataset.valueId);
                        value.innerHTML = "<div style='display:none;' class='slidervalue'>" + slider.value + "</div>";


                    }

                    function updateSliderLabels(slider) {
                        const maxLabel = slider.parentNode.querySelector('#' + slider.dataset.maxLabelId);

                        switch (slider.value) {
                            case "10":
                                maxLabel.innerHTML = getI18n('progress_beginner');
                                break;
                            case "20":
                                maxLabel.innerHTML = getI18n('progress_intermediate');
                                break;
                            case "30":
                                maxLabel.innerHTML = getI18n('progress_proficient');
                                break;
                            case "40":
                                maxLabel.innerHTML = getI18n('progress_native');
                                break;
                            default:
                                maxLabel.innerHTML = getI18n('progress_beginner');
                        }
                    }





                    function updateSliderProgress(slider) {
                        let progress = slider.parentNode.querySelector('#' + slider.dataset.progressId);
                        const percent = getSliderPercent(slider);

                        progress.style.width = percent * 100 + "%";
                    }

                    function getSliderPercent(slider) {
                        const range = slider.max - slider.min;
                        const absValue = slider.value - slider.min;

                        return absValue / range;
                    }

                    function setSliderTicks(slider) {
                        let container = slider.parentNode.querySelector('#' + slider.dataset.tickId);
                        const spacing = parseFloat(slider.dataset.tickStep);
                        const sliderRange = slider.max - slider.min;
                        const tickCount = sliderRange / spacing + 1; // +1 to account for 0

                        for (let ii = 0; ii < tickCount; ii++) {
                            let tick = document.createElement("span");

                            tick.className = "tick-slider-tick";

                            container.appendChild(tick);
                        }
                    }




                    function setSliderValue() {
                        const sliders = $("#builder_iframe").contents().find('.tick-slider-input');
                        for (let slider of sliders) {
                            if (slider && slider.parentNode && slider.parentNode.querySelector('#weightValue .slidervalue')) {
                                slider.setAttribute('value', slider.parentNode.querySelector('#weightValue .slidervalue').textContent);
                            }
                        }
                    }



                    function updateUndoRedoButtons() {
                        const undoManager = editor.undoManager;
                        window.canUndo = undoManager.hasUndo();
                        window.canRedo = undoManager.hasRedo();

                        // Update Undo button state
                        if (window.ctxUndoBtn) {
                            if (canUndo) {
                                $(window.ctxUndoBtn).removeClass('disabled');
                            } else {
                                $(window.ctxUndoBtn).addClass('disabled');
                            }
                        }

                        // Update Redo button state
                        if (window.ctxRedoBtn) {
                            if (canRedo) {
                                $(window.ctxRedoBtn).removeClass('disabled');
                            } else {
                                $(window.ctxRedoBtn).addClass('disabled');
                            }
                        }
                    }


                    // Function to handle viewport changes
                    function handleViewportChange() {
                        const isMobile = !isHoverable;

                        if (isMobile) {
                            cleanupMobileUndoRedoListeners();
                            // Attach event listeners if not already attached
                            if (mobileUndoRedoListeners.length === 0) {
                                // Attach TinyMCE editor events
                                editor.on('Undo Redo AddUndo TypingInput', updateUndoRedoButtons);

                                // Attach click handlers to undo/redo buttons
                                $('#builder_iframe').contents().find("body").on('mouseup', '.mobile-undo-btn', mobileUndoHandler);
                                $('#builder_iframe').contents().find("body").on('mouseup', '.mobile-redo-btn', mobileRedoHandler);


                                // Store listeners for cleanup
                                mobileUndoRedoListeners.push(
                                    { target: editor, event: 'Undo Redo AddUndo TypingInput', handler: updateUndoRedoButtons },
                                    { target: '#builder_iframe', selector: '.mobile-undo-btn', event: 'mouseup', handler: mobileUndoHandler },
                                    { target: '#builder_iframe', selector: '.mobile-redo-btn', event: 'mouseup', handler: mobileRedoHandler }
                                );

                                // Initial update of buttons
                                updateUndoRedoButtons();
                            }
                        } else {
                            // Remove event listeners if attached
                            if (mobileUndoRedoListeners.length > 0) {
                                // Remove TinyMCE editor events
                                editor.off('Undo Redo AddUndo TypingInput', updateUndoRedoButtons);

                                // Remove click handlers
                                $('#builder_iframe').contents().find("body").off('mouseup', '.mobile-undo-btn', mobileUndoHandler);
                                $('#builder_iframe').contents().find("body").off('mouseup', '.mobile-redo-btn', mobileRedoHandler);


                                // Clear the listeners array
                                mobileUndoRedoListeners.length = 0;

                                console.log('All mobile undo/redo listeners have been removed.');
                            }
                        }
                    }







                    // Handlers for mobile Undo/Redo clicks without using 'this' reference
                    function mobileUndoHandler(event) {
                        var $target = $(event.currentTarget);
                        if (!$target.hasClass('disabled')) {
                            editor.undoManager.undo();

                        }
                    }

                    function mobileRedoHandler(event) {
                        var $target = $(event.currentTarget);
                        if (!$target.hasClass('disabled')) {
                            editor.undoManager.redo();

                        }
                    }

                    // Function to resize canvas dynamically
                    function resizeCanvas(width, height) {
                        const bodyhtml = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html')[0];
                        const canvas = bodyhtml.querySelector('#signature-canvas');
                        canvas.width = width;
                        canvas.height = height;
                        canvas.style.width = `${width}px`;
                        canvas.style.height = `${height}px`;
                        // Adjust the wrapper size
                        const canvasWrapper = canvas.parentElement; // Get the parent wrapper
                        if (canvasWrapper) {
                            canvasWrapper.style.width = `${width}px`;
                            canvasWrapper.style.height = `${height}px`;
                        }
                    }

                    // Debounce function
                    function debounce(func, delay) {
                        let timeout;
                        return (...args) => {
                            clearTimeout(timeout);
                            timeout = setCustomTimeout(() => func(...args), delay);
                        };
                    }





                    function drawFromBase64(base64, canvas, ctx, tooltip) {
                        const img = new Image();
                        img.onload = () => {
                            try {
                                // Resize canvas to match image dimensions
                                resizeCanvas(img.width, img.height);
                                ctx.clearRect(0, 0, canvas.width, canvas.height);
                                ctx.drawImage(img, 0, 0, img.width, img.height);

                                // Position tooltip relative to the image
                                const wrapperRect = canvas.parentElement.getBoundingClientRect();
                                tooltip.style.display = 'block'; // Temporarily show tooltip to calculate dimensions
                                const tooltipWidth = tooltip.offsetWidth;
                                const tooltipHeight = tooltip.offsetHeight;
                                tooltip.style.display = 'none'; // Hide it again

                                // Center the tooltip over the canvas
                                const tooltipLeft = wrapperRect.left + (canvas.width / 2) - (tooltipWidth / 2);
                                const tooltipTop = wrapperRect.top + (canvas.height / 2) - (tooltipHeight / 2);

                                tooltip.style.left = `${tooltipLeft}px`;
                                tooltip.style.top = `${tooltipTop}px`;
                            } catch (error) {
                                console.log('Error: ', error);
                            }
                        };
                        img.src = base64; // Set the image source to the base64 data
                    }




                    function isCanvasEmpty() {
                        const bodyhtml = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html')[0];
                        const canvas = bodyhtml.querySelector('#signature-canvas');
                        const ctx = canvas.getContext('2d', { willReadFrequently: true });
                        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                        const data = imageData.data;

                        for (let i = 0; i < data.length; i += 4) {
                            const [r, g, b, a] = [data[i], data[i + 1], data[i + 2], data[i + 3]];
                            // Check if the pixel is not white or transparent
                            if (!(r === 255 && g === 255 && b === 255 && a === 255) && a !== 0) {
                                return false; // The canvas is not empty
                            }
                        }

                        return true; // The canvas is empty
                    }

                    function generateBlankImage() {
                        const tempCanvas = document.createElement('canvas');
                        tempCanvas.width = 180; // Width of the blank image
                        tempCanvas.height = 80; // Height of the blank image
                        const tempCtx = tempCanvas.getContext('2d', { willReadFrequently: true });
                        tempCtx.fillStyle = "transparent";
                        tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
                        return tempCanvas.toDataURL();
                    }

                    function ensureCanvasWidth(ctx, text, font, padding) {
                        ctx.font = font;
                        const textWidth = ctx.measureText(text).width;
                        const requiredWidth = textWidth + padding * 2; // Add padding on both sides

                        if (ctx.canvas.width < requiredWidth) {
                            ctx.canvas.width = requiredWidth;
                        }
                    }



                    // Function to trim empty space on all sides, add padding, and save the image
                    function trimCanvasAndSave(canvas, ctx, tooltip) {
                        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                        const data = imageData.data;

                        let minX = canvas.width;
                        let minY = canvas.height;
                        let maxX = 0;
                        let maxY = 0;

                        // Find the bounding box of non-empty pixels
                        for (let y = 0; y < canvas.height; y++) {
                            for (let x = 0; x < canvas.width; x++) {
                                const alpha = data[(y * canvas.width + x) * 4 + 3]; // Check alpha value
                                if (alpha > 0) {
                                    minX = Math.min(minX, x);
                                    maxX = Math.max(maxX, x);
                                    minY = Math.min(minY, y);
                                    maxY = Math.max(maxY, y);
                                }
                            }
                        }


                        const croppedWidth = maxX - minX + 1;
                        const croppedHeight = maxY - minY + 1;

                        const padding = 20; // Padding for top and bottom
                        const paddedWidth = croppedWidth;
                        const paddedHeight = croppedHeight + padding * 2;

                        const croppedImageData = ctx.getImageData(minX, minY, croppedWidth, croppedHeight);

                        const tempCanvas = document.createElement('canvas');
                        tempCanvas.width = paddedWidth;
                        tempCanvas.height = paddedHeight;
                        const tempCtx = tempCanvas.getContext('2d', { willReadFrequently: true });
                        tempCtx.fillStyle = "transparent";
                        tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
                        tempCtx.putImageData(croppedImageData, 0, padding); // Apply padding

                        // Update the wrapper size
                        const canvasWrapper = canvas.parentElement; // Get the wrapper element
                        canvasWrapper.style.width = `${paddedWidth}px`;
                        canvasWrapper.style.height = `${paddedHeight}px`;

                        return tempCanvas.toDataURL();
                    }

                    function resizeCanvasToText(ctx, canvas, text, font, padding = 20) {
                        ctx.font = font; // Set the font to measure text size
                        const textWidth = ctx.measureText(text).width;
                        const requiredWidth = textWidth + padding * 2; // Add padding on both sides

                        // Resize the canvas if needed
                        if (canvas.width !== requiredWidth) {
                            canvas.width = requiredWidth;
                            ctx.font = font; // Reset font after resizing the canvas
                        }
                    }


                    async function generateAndSaveDefaultSignature(name, canvas, ctx, tooltip) {
                        try {
                            // console.log('generateAndSaveDefaultSignature');
                            // Access the iframe's document
                            if (!iframeDoc[0]) {
                                console.error('Unable to access document.');
                                return;
                            }

                            // Ensure font is loaded in the iframe
                            await iframeDoc[0].fonts.load('32px "Alex Brush"');

                            // Verify font availability in the iframe
                            if (!iframeDoc[0].fonts.check('32px "Alex Brush"')) {
                                console.error('Font Alex Brush not available in canvas context.');
                                return;
                            }

                            resizeCanvasToText(ctx, canvas, name, '32px "Alex Brush", cursive');

                            const maintable = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table')[0];

                            // Clear and redraw
                            ctx.clearRect(0, 0, canvas.width, canvas.height);
                            ctx.font = '32px "Alex Brush", cursive';
                            ctx.textAlign = 'left';
                            ctx.textBaseline = 'middle';

                            ctx.fillStyle = getComputedStyle(maintable).getPropertyValue('--righttdcolor');
                            //  console.log('ctx.fillStyle', ctx.fillStyle);

                            ctx.fillText(name, 10, canvas.height / 2);

                            // Trim and save the signature
                            const trimmedSignature = trimCanvasAndSave(canvas, ctx, tooltip);
                            drawFromBase64(trimmedSignature, canvas, ctx, tooltip);
                            addSignatureImageToDocument(trimmedSignature);

                            // console.log('Signature generated successfully.');
                        } catch (error) {
                            console.error('Error generating signature:', error);
                        }
                    }

                    // Function to add the signature as an image element
                    function addSignatureImageToDocument(base64Image) {
                        const bodyhtml = $("#builder_iframe")
                            .contents()
                            .find("body")
                            .find('.tox-edit-area')
                            .find('#PageElement_ifr')
                            .contents()
                            .find('html')[0];

                        const signatureImageContainer = bodyhtml.querySelector('#signature-image');
                        if (!signatureImageContainer) {
                            console.error('Signature image container not found.');
                            return;
                        }

                        // Check if an image already exists; if so, remove it
                        let signatureImg = signatureImageContainer.querySelector('img');
                        if (signatureImg) {
                            signatureImageContainer.removeChild(signatureImg); // Remove the existing image
                        }

                        // Create a new image element
                        signatureImg = document.createElement('img');
                        signatureImg.alt = 'Generated Signature';
                        signatureImg.style.marginTop = '10px'; // Add some margin
                        signatureImg.src = base64Image; // Set the new image source

                        // Append the new image to the container
                        signatureImageContainer.appendChild(signatureImg);
                    }


                    function startDrawing(e, canvas, ctx) {
                        if (!canvas.classList.contains('editable')) return;
                        isDrawing = true;

                        const maintable = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table')[0];
                        ctx.strokeStyle = getComputedStyle(maintable).getPropertyValue('--righttdcolor');

                        // Normalize touch and mouse events
                        const pos = getEventPos(e, canvas);
                        ctx.beginPath();
                        ctx.moveTo(pos.x, pos.y);
                    }

                    function draw(e, canvas, ctx, clearButton) {
                        if (!isDrawing) return;

                        const pos = getEventPos(e, canvas);
                        ctx.lineTo(pos.x, pos.y);
                        ctx.stroke();
                        clearButton.disabled = false; // Enable Clear button
                    }

                    function stopDrawing(canvas, ctx) {
                        isDrawing = false;
                        ctx.closePath();
                    }

                    // Utility function to get correct x and y position for both touch and mouse events
                    function getEventPos(e, canvas) {
                        const rect = canvas.getBoundingClientRect(); // Get canvas position and dimensions
                        const scaleX = canvas.width / rect.width;  // Scale factor for width
                        const scaleY = canvas.height / rect.height; // Scale factor for height

                        let x, y;
                        if (e.touches) {
                            // Touch event (mobile)
                            x = (e.touches[0].clientX - rect.left) * scaleX;
                            y = (e.touches[0].clientY - rect.top) * scaleY;
                        } else {
                            // Mouse event (desktop)
                            x = (e.clientX - rect.left) * scaleX;
                            y = (e.clientY - rect.top) * scaleY;
                        }

                        return { x, y };
                    }

                    editor.saveLocallyIndexedDB = async function () {//override true means I am saving manually

                        if (!currentFileName) return;
                        if (editor.isDirty() || themeChanged) {
                            thisEditor.saveToServer = true;
                            document.getElementById("save-design").classList.remove("disabled");

                            const statusElement = document.getElementById('last-saved-locally');
                            if (statusElement) {
                                statusElement.textContent = getI18n('savingdots');
                            }
                            //   console.log('editor is dirty, saving localy IndexedDB to:', 'editor-' + currentFileName);

                            thisEditor.runBeforeSaveEvents();

                            // cleanup content before save
                            thisEditor.cleanUpContent(true);

                            thisEditor.saveAchor = thisEditor.currentRecordAchor;

                            thisEditor.saveContent(currentFileName).then((message) => {
                                editor.setDirty(false); // Reset dirty state after saving
                                themeChanged = false;
                                console.log(message);
                                if (message.includes("No changes detected")) {
                                    console.log("skipping timestamp update - content unchanged.");
                                    return; // Do not update the last saved time
                                }
                                const now = new Date();
                                const formattedTime = now.toLocaleTimeString([], {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: thisEditor.uses12HourClock
                                });
                                statusElement.textContent = getI18nExt("savedlocally", { time: formattedTime });
                            }).catch((error) => {
                                console.error('Error saving content:', error);
                            });
                        } else {
                            console.log("Editor not dirty");
                        }
                    }

                    if (!thisEditor.readOnlyMode) {
                        saveIntervalID = setInterval(() => {
                            editor.saveLocallyIndexedDB();
                        }, 12000);
                    }

                    // Clear the interval when the editor is removed
                    editor.on('remove', () => {
                        clearInterval(saveIntervalID);
                    });

                    editor.on('BeforeExecCommand', function (e) {
                        if (e.command === 'InsertUnorderedList' || e.command === 'InsertOrderedList') {
                            const selection = editor.selection;
                            const rng = selection.getRng();
                            const container = selection.getStart();
                            const block = editor.dom.getParent(container, editor.dom.isBlock);

                            const afterRange = rng.cloneRange();
                            try {
                                afterRange.setEndAfter(block);
                            } catch (err) {
                                // Fallback if range fails (e.g., malformed block)
                            }

                            const textAfterCursor = afterRange.cloneContents().textContent.trim();
                            const shouldInsertNewList = textAfterCursor === '';

                            if (shouldInsertNewList) {
                                e.preventDefault();
                                e.stopImmediatePropagation();

                                const listType = e.command === 'InsertUnorderedList' ? 'ul' : 'ol';
                                editor.insertContent(`<${listType}><li><br></li></${listType}>`);
                            }
                        }
                    });







                    // editor.on('blur', saveLocally);





                    async function initSignaturePad() {
                        try {
                            const bodyhtml = $("#builder_iframe")
                                .contents()
                                .find("body")
                                .find('.tox-edit-area')
                                .find('#PageElement_ifr')
                                .contents()
                                .find('html')[0];

                            const wrapper = bodyhtml.querySelector('.signature-canvas-wrapper');

                            // Ensure wrapper exists
                            if (!wrapper) return;

                            // Always remove old canvas if it exists
                            const oldCanvas = wrapper.querySelector('#signature-canvas');
                            if (oldCanvas) {

                                thisEditor.removeCanvasEventListeners();
                                const ctx = oldCanvas.getContext('2d');
                                if (ctx) {
                                    ctx.clearRect(0, 0, oldCanvas.width, oldCanvas.height);
                                }

                                // Optional: remove custom event listeners if you attached any
                                // oldCanvas.removeEventListener('someEvent', someHandler);

                                oldCanvas.width = 0; // helps in some browsers
                                oldCanvas.height = 0;

                                oldCanvas.remove();
                            }

                            // Create a fresh canvas
                            const canvas = document.createElement('canvas');
                            canvas.id = 'signature-canvas';
                            canvas.className = 'signature-canvas';
                            canvas.width = 176;
                            canvas.height = 71;
                            canvas.style.width = '176px';
                            canvas.style.height = '71px';

                            // Prepend new canvas to wrapper
                            wrapper.prepend(canvas);

                            const ctx = canvas.getContext('2d', { willReadFrequently: true });
                            ctx.font = '32px "Alex Brush", cursive';
                            const generateButton = bodyhtml.querySelector('#signature-generate-button');
                            const saveButton = bodyhtml.querySelector('#signature-save-button');

                            const cancelButton = bodyhtml.querySelector('#cancelSignatureButton');
                            const clearButton = bodyhtml.querySelector('#signature-clear-button');
                            const tooltip = bodyhtml.querySelector('#signature-tooltip');
                            const nameInput = bodyhtml.querySelector('#signature-name-input');
                            const inputContainer = bodyhtml.querySelector('#signature-input-container');
                            const signatureName = bodyhtml.querySelector('#signature-name-display');
                            const drawLabel = bodyhtml.querySelector('#signature-draw-label');


                            const nameFromDiv = signatureName?.textContent?.trim() || "";
                            const userAuth = getVendorAndEmailFromCookies();
                            const firstname = userAuth?.firstname?.trim() || "";
                            const lastname = userAuth?.lastname?.trim() || "";

                            const fullName = `${firstname} ${lastname}`.trim();

                            const defaultName = (nameFromDiv !== "")
                                ? nameFromDiv
                                : (fullName || getI18n('resume_name'));



                            const existingImage = bodyhtml.querySelector('.signature-container img');
                            // existingImage.style.display = 'none'; // Show the image


                            // Initialize with the saved signature or default
                            if (existingImage) {
                                const base64 = existingImage.src;
                                // Delay to ensure DOM is fully ready
                                requestAnimationFrame(() => {
                                    drawFromBase64(base64, canvas, ctx, tooltip);
                                });
                            } else {
                                generateAndSaveDefaultSignature(defaultName, canvas, ctx, tooltip);
                            }


                            // Tooltip behavior with debounce
                            const showTooltip = debounce(() => {
                                tooltip.style.display = 'block';
                            }, 50);

                            const hideTooltip = debounce(() => {
                                tooltip.style.display = 'none';
                            }, 50);

                            thisEditor.addTinymceEventListener(canvas, 'mousedown', (e) => startDrawing(e, canvas, ctx));
                            thisEditor.addTinymceEventListener(canvas, 'mousemove', (e) => draw(e, canvas, ctx, clearButton));
                            thisEditor.addTinymceEventListener(canvas, 'mouseup', () => stopDrawing(canvas, ctx));
                            thisEditor.addTinymceEventListener(canvas, 'mouseleave', () => stopDrawing(canvas, ctx));

                            // Touch event listeners
                            thisEditor.addTinymceEventListener(canvas, 'touchstart', (e) => startDrawing(e, canvas, ctx));
                            thisEditor.addTinymceEventListener(canvas, 'touchmove', (e) => draw(e, canvas, ctx, clearButton));
                            thisEditor.addTinymceEventListener(canvas, 'touchend', () => stopDrawing(canvas, ctx));


                            thisEditor.addTinymceEventListener(canvas, 'mouseout', function (e) {
                                hideTooltip();
                            });

                            thisEditor.addTinymceEventListener(canvas, 'touchmove', function (e) {
                                e.preventDefault();
                            }, { passive: false });



                            thisEditor.addTinymceEventListener(canvas, 'click', function (e) {
                                console.log('canvas clicked');
                                hideTooltip();
                                if (!canvas.classList.contains('editable')) {
                                    resizeCanvas(500, 130); // Default canvas size
                                    canvas.classList.add('editable');
                                    inputContainer.classList.add('visible');
                                    nameInput.value = defaultName;
                                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                                    clearButton.style.display = 'inline-block'; // Show Clear button on click
                                    drawLabel.style.display = 'inline-block';
                                    clearButton.disabled = true; // Keep Clear button disabled until drawing or generating
                                }
                            });

                            thisEditor.addTinymceEventListener(tooltip, 'click', function (e) {
                                hideTooltip();
                                if (!canvas.classList.contains('editable')) {
                                    resizeCanvas(500, 130); // Reset canvas size to default
                                    canvas.classList.add('editable'); // Make canvas editable
                                    inputContainer.classList.add('visible'); // Show input and buttons
                                    nameInput.value = defaultName;
                                    ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas for new input
                                    clearButton.style.display = 'inline-block'; // Show Clear button
                                    drawLabel.style.display = 'inline-block';
                                    clearButton.disabled = true; // Keep Clear button disabled until drawing or generating
                                }
                            });




                            // Generate new signature
                            // Generate new signature
                            thisEditor.addTinymceEventListener(generateButton, 'click', async function (e) {
                                const name = nameInput.value.trim();
                                if (!name) {
                                    alert('Please enter your name to generate a signature.');
                                    return;
                                }

                                if (!iframeDoc[0]) {
                                    console.error('Unable to access document.');
                                    return;
                                }

                                try {
                                    // Ensure font is loaded in the iframe
                                    await iframeDoc[0].fonts.load('32px "Alex Brush"');

                                    const maintable = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table')[0];


                                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                                    ctx.font = '32px "Alex Brush", cursive';
                                    ctx.textAlign = 'left';
                                    ctx.textBaseline = 'middle';
                                    ctx.fillStyle = getComputedStyle(maintable).getPropertyValue('--righttdcolor');
                                    ctx.fillText(name, 10, canvas.height / 2);

                                    signatureName.textContent = name;
                                    clearButton.disabled = false; // Enable Clear button

                                    // console.log('Signature generated successfully.');
                                } catch (error) {
                                    console.error('Error loading font or generating signature:', error);
                                }
                            });


                            // Save and finalize the signature
                            thisEditor.addTinymceEventListener(saveButton, 'click', async function (e) {
                                console.log("Save button clicked");
                                if (isCanvasEmpty()) {
                                    const blankImage = generateBlankImage();
                                    drawFromBase64(blankImage, canvas, ctx, tooltip); // Display the blank image
                                    addSignatureImageToDocument(blankImage); // Add or update the image in the document
                                } else {
                                    const trimmedImage = trimCanvasAndSave(canvas, ctx, tooltip);
                                    drawFromBase64(trimmedImage, canvas, ctx, tooltip); // Display the trimmed image
                                    addSignatureImageToDocument(trimmedImage); // Add or update the image in the document
                                }
                                inputContainer.classList.remove('visible');
                                canvas.classList.remove('editable');
                                clearButton.style.display = 'none'; // Hide Clear button after saving
                                drawLabel.style.display = 'none';
                            });



                            // Cancel editing and restore the saved signature
                            thisEditor.addTinymceEventListener(cancelButton, 'click', async function (e) {
                                const existingImage = bodyhtml.querySelector('.signature-container img');
                                if (existingImage && existingImage.src) {
                                    drawFromBase64(existingImage.src, canvas, ctx, tooltip); // Restore the existing signature
                                } else {
                                    ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas
                                }
                                inputContainer.classList.remove('visible');
                                canvas.classList.remove('editable');
                                clearButton.style.display = 'none'; // Hide Clear button after cancel
                                drawLabel.style.display = 'none';
                            });

                            // Clear the signature canvas
                            thisEditor.addTinymceEventListener(clearButton, 'click', async function (e) {
                                ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas
                                clearButton.disabled = true; // Disable Clear button after clearing
                            });

                        } catch (error) {
                            console.error('Error displaying tooltip:', error);
                        }
                    }






                    // editor.addCommand('triggerCut', function () {
                    //     console.log("Triggering cut");

                    //     const contentEditableNode = editor.selection.getNode();
                    //     if (contentEditableNode) {
                    //         console.log("Inside content editable node");

                    //         const textContent = contentEditableNode.textContent;

                    //         // Attempt to write the content to the clipboard
                    //         navigator.clipboard.writeText(textContent).catch((err) => {
                    //             // Log the error but proceed with the remaining logic
                    //             console.error('Failed to write to clipboard:', err);
                    //         }).finally(() => {
                    //             // Always execute the following steps, regardless of clipboard success

                    //             // Clear the content of the node
                    //             contentEditableNode.textContent = "\u00A0"; // Non-breaking space to keep the node intact

                    //             // Place the cursor at the start of the cleared node
                    //             editor.selection.setCursorLocation(contentEditableNode, 0);

                    //             // Add the operation to the TinyMCE undo stack
                    //             editor.undoManager.add();

                    //             console.log('Cut operation completed');
                    //         });
                    //     }
                    // });

                    editor.addCommand('triggerCut', function () {
                        console.log("Triggering cut");

                        const contentEditableNode = editor.selection.getNode();
                        if (contentEditableNode) {
                            // Get the text content of the node for debugging purposes (if needed)
                            const textContent = contentEditableNode.textContent;
                            // Clear the content of the node
                            contentEditableNode.textContent = "\u00A0"; // Non-breaking space to keep the node intact

                            // Place the cursor at the start of the cleared node
                            editor.selection.setCursorLocation(contentEditableNode, 0);

                            // Add the operation to the TinyMCE undo stack
                            editor.undoManager.add();
                        }
                    });




                    //tinymce init
                    editor.on("init", function (e) {




                        const domains = [
                            "cmVzdW1lYnVpbGRlcmdwdC5jb20=", // resumebuildergpt.com
                            "cmVzdW1lYnVpbGRlcmdwdC5haQ==", // resumebuildergpt.ai
                            "cmVzdW1laW5taW51dGVzLmNvbQ==", // resumeinminutes.com
                            "c3FsbGRhcC5jb20=",              // sqlldap.com
                            "dGV4dHRvcmVzdW1lLmNvbQ==",      //texttoresume.com
                            "Y3Zpbm1pbnV0ZXMuY29t"           // cvinminutes.com
                        ];


                        if (domains.some(encodedDomain => window.location.hostname.includes(atob(encodedDomain)))) {

                            iframeDoc = $("#builder_iframe")
                                .contents()
                                .find("body")
                                .find('.tox-edit-area')
                                .find('#PageElement_ifr')
                                .contents();

                            const sliders = $("#builder_iframe").contents().find('.tick-slider-input');

                            //setting up the css main class from the dataset








                            for (let slider of sliders) {
                                updateSliderLabels(slider);
                                updateSliderProgress(slider);
                                setSliderTicks(slider);
                            }

                            if ((window.innerWidth >= 987) && !($("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table').hasClass('main-table-border'))) {
                                $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table').addClass('main-table-border');
                            } else if ($("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table').hasClass('main-table-border')) {
                                $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table').removeClass('main-table-border');
                            }

                            const mainTableDiv = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table')[0];
                            const bodyhtml = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html')[0];

                            $(mainTableDiv).attr('data', '1'); //setting the scale to 1 as the scale is stored when save
                            mainTableDiv.classList.remove('margintablemarginscale'); //also removing class as this is stored as well when saved and not needed on refresh
                            bodyhtml.classList.remove('disable-pan-x'); // same as above



                            setLightDarkModeForEditor();

                            //  if (window.innerWidth >= 720) {
                            //thisEditor.showContentBackgroundToolTip(); //notshowing content background tootip
                            //  }



                            //const viewportscale = window.visualViewport ? window.visualViewport.scale : 1;
                            const viewportscale = 1;
                            defaultScaleFactor = window.innerWidth / 1021 * viewportscale;

                            if (window.location.href.includes("coverletter")) {

                                initSignaturePad();
                            }






                            //console.log('Calling Scale To fit again in editor init');
                            thisEditor.scaleEditorToFit();
                            // if (/iPhone|iPad|iPod/i.test(navigator.userAgent) && (window.innerWidth <= 768 || window.innerHeight <= 768)) {
                            if (/iPhone/i.test(navigator.userAgent) && !thisEditor.readOnlyMode) {
                                customCaretImplementation = integrateCustomCaret();
                            } else {
                                initializeOrientationChangeListener();
                            }



                            // Check if the device is hover-capable

                            if (isHoverable) {
                                // Remove class from the non-hover context bar
                                document.getElementById("non-hover-ctxbar").classList.remove("builder-outline-selected-controls");
                            } else {
                                // Remove class from the hover-enabled context bar
                                document.getElementById("hover-enable-ctxbar").classList.remove("builder-outline-selected-controls");
                                listenForDefaultContextMenu();
                            }

                            window.minimumMobileCtxBarScale = minimumMobileCtxBarScale;
                            window.ctxbarListeners = ctxbarListeners;

                            handleViewportChange();

                            if (thisEditor.readOnlyMode) {
                                editor.mode.set('readonly');
                                document.getElementById("save-design").classList.add("disabled");
                                document.getElementById("save-as-design").classList.add("disabled");
                                document.getElementById("renamefile-menu").classList.add("disabled");

                                const $mainContentBody = $("#builder_iframe").contents().find('#maincontent-body');
                                const hasDarkTheme = $mainContentBody.hasClass('dark-theme');

                                // Append button inside TinyMCE content
                                const button = document.createElement("button");
                                button.textContent = getI18n('customize_template');
                                button.classList.add("use-template-btn");
                                if (hasDarkTheme) {
                                    button.classList.add("dark-theme");
                                }

                                if (window.innerWidth < 720) {
                                    button.style.fontSize = "24px";
                                }

                                // Insert into TinyMCE content area
                                editor.getBody().appendChild(button);


                                setTimeout(() => {
                                    const editorContent = editor.getBody();
                                    editorContent.style.webkitTextSizeAdjust = "100%"; // Prevent auto-scaling on iPhone
                                }, 100);




                                // Add click event to enable editing
                                button.addEventListener("click", function () {
                                    if (isUserLoggedIn())
                                        window.recaptchaVerification.recaptchaVerificationInit(generateFromTemplateVerificationSuccess, getEmailPrefixWithVendorFromCookies());
                                    else {
                                        thisEditor.showLoginPopup(false, false, false, false, false, generateFromTemplateVerificationSuccess,
                                            function (data) { window.recaptchaVerification.recaptchaVerificationInit(generateFromTemplateVerificationSuccess, getEmailPrefixWithVendorFromCookies()); }
                                        );
                                    }
                                });
                            } else if (!thisEditor.contentSaved) {
                                // Create a link instead of a button
                                const editModeLink = document.createElement("a");
                                editModeLink.textContent = getI18n('clicktoedit');
                                editModeLink.classList.add("use-template-link");
                                editModeLink.href = "#"; // Prevent default behavior

                                // Add dark mode styling if applicable
                                const $mainContentBody = $("#builder_iframe").contents().find('#maincontent-body');
                                if ($mainContentBody.hasClass('dark-theme')) {
                                    editModeLink.classList.add("dark-theme");
                                }

                                // Set font size for mobile
                                if (window.innerWidth < 720) {
                                    editModeLink.style.fontSize = "24px";
                                }

                                // Insert into TinyMCE content area
                                editor.getBody().appendChild(editModeLink);

                                // Remove the link after 10 seconds
                                const removeTimeout = setTimeout(() => {
                                    editModeLink.remove();
                                }, 15000);

                                // Remove the link on click
                                editModeLink.addEventListener("click", function (event) {
                                    event.preventDefault(); // Prevent default anchor behavior
                                    editModeLink.remove(); // Remove the link immediately
                                    clearTimeout(removeTimeout); // Clear the timeout if it was clicked before auto-removal
                                });
                            }

                            thisEditor.updateTheme();

                            const target = $("#builder_iframe").contents().find('#maincontent-body-html')[0];
                            //  console.log ('data values', target.getAttribute('data'));
                            const data = target.getAttribute('data').split("|");
                            const className = data[0];

                            utilsEvents.toggleLayout(className, iframeDoc, editor);
                            utilsEvents.toggleDateAlignment(className, iframeDoc, editor);



                            // This is not going to work for comparision so commenting it out
                            // thisEditor.initContentForSave(currentFileName);


                        }




                        window.PDFConfigModule.getMargins();

                        try {
                            // Get the toolbar buttons inside the iframe safely
                            const iframe = $("#builder_iframe");
                            if (!iframe.length) {
                                console.warn('builder_iframe not found.');
                                return;
                            }

                            const iframeBody = iframe.contents().find("body");
                            if (!iframeBody.length) {
                                console.warn('Iframe body not found.');
                                return;
                            }

                            const toolbarButtons = iframeBody.find('.tox-tbtn');

                            // Check if any toolbar buttons were found
                            if (!toolbarButtons.length) {
                                return;
                            }

                            // Use .each() to iterate over the jQuery collection of toolbar buttons
                            toolbarButtons.each((index, button) => {
                                try {
                                    // Get the original tooltip from the title attribute
                                    const originalTitle = button.getAttribute('title');

                                    // Only proceed if originalTitle is not null or empty
                                    if (originalTitle) {
                                        // Translate the title using the translation function
                                        const translatedTitle = getI18n(originalTitle.toLowerCase()) || originalTitle;

                                        // Set the translated title back to the button for displaying as a tooltip
                                        button.setAttribute('title', translatedTitle);

                                        // Add event listeners for mouseenter and mouseleave
                                        $(button).on('mouseenter', (event) => {
                                            try {
                                                const tooltip = button.getAttribute('title');
                                                if (tooltip) {
                                                    button.setAttribute('data-title', tooltip);
                                                    button.removeAttribute('title');

                                                    // Create and style the custom tooltip element
                                                    const tooltipElement = document.createElement('div');
                                                    tooltipElement.className = 'custom-tinymce-tooltip';
                                                    tooltipElement.innerText = tooltip;
                                                    document.body.appendChild(tooltipElement);

                                                    // Get the button's bounding rectangle for positioning
                                                    const rect = button.getBoundingClientRect();
                                                    const iframeRect = iframe[0].getBoundingClientRect();

                                                    // Check if the tooltipElement was appended successfully
                                                    if (!tooltipElement) {
                                                        console.warn('Failed to create or append the tooltip element.');
                                                        return;
                                                    }

                                                    // Position the tooltip relative to the button
                                                    tooltipElement.style.position = 'absolute';
                                                    tooltipElement.style.left = `${rect.left + iframeRect.left + rect.width / 2}px`;
                                                    tooltipElement.style.top = `${rect.top + iframeRect.top - tooltipElement.offsetHeight - 15}px`;
                                                    tooltipElement.style.transform = 'translateX(-50%)'; // Center horizontally
                                                    tooltipElement.style.zIndex = '1000';
                                                    tooltipElement.style.backgroundColor = '#000000';
                                                    tooltipElement.style.color = '#fff';
                                                    tooltipElement.style.padding = '5px';
                                                    tooltipElement.style.borderRadius = '3px';
                                                    tooltipElement.style.whiteSpace = 'nowrap';
                                                }
                                            } catch (error) {
                                                console.error('Error displaying tooltip:', error);
                                            }
                                        });

                                        $(button).on('mouseleave', () => {
                                            try {
                                                // Remove the custom tooltip when mouse leaves the button
                                                const tooltipElement = document.querySelector('.custom-tinymce-tooltip');
                                                if (tooltipElement) {
                                                    tooltipElement.remove();
                                                }

                                                // Restore the original title
                                                const originalTitle = button.getAttribute('data-title');
                                                if (originalTitle) {
                                                    button.setAttribute('title', originalTitle);
                                                    button.removeAttribute('data-title');
                                                }
                                            } catch (error) {
                                                console.error('Error removing tooltip:', error);
                                            }
                                        });
                                    }
                                } catch (error) {
                                    console.error('Error processing toolbar button:', error);
                                }
                            });
                        } catch (error) {
                            console.error('Error initializing toolbar tooltips:', error);
                        }




                        setCustomTimeout(() => {
                            if (editor.isDirty()) {
                                console.log('editor is dirty on setContent after 500 msecs - setting editor dirty to false');
                                editor.setDirty(false);
                                themeChanged = false;
                            }
                        }, 500);


                    });



                    editor.on('CloseWindow', function (e) {

                        setCustomTimeout(() => {
                            console.log('Close window for dialog');
                            thisEditor.scrollToTopRecursively($("#builder_iframe"));
                            $("#builder_iframe").contents().find('#maincontent-body-html').find('.tox-editor-container').click();

                        }, 50);
                        setCustomTimeout(() => {
                            editor.getBody().blur();
                        }, 100);

                    });


                    thisEditor.addTinymceEventListener(editor, 'change keyup', function (e) {
                        if (typeof thisEditor.inlineEditCallback !== 'undefined') {
                            thisEditor.inlineEditCallback(editor.getContent());
                        }
                    });




                    editor.on("input", function (e) {

                        if ($(e.target).hasClass('tick-slider-input')) {

                            var slider = e.target;
                            updateSliderValue(slider);
                            updateSliderLabels(slider);
                            updateSliderProgress(slider);
                            setSliderTicks(slider);
                            setSliderValue();
                            editor.setDirty(true);

                        }

                    });



                    thisEditor.addTinymceEventListener(editor, 'keydown', function (e) {
                        thisEditor.adjustIframeSize();
                    });







                    thisEditor.addTinymceEventListener(editor, 'paste', function (e) {
                        thisEditor.adjustIframeSize();
                    });




                    //    // Get the current caret position
                    //    function getCaretPosition() {
                    //     const selection = iframeDoc[0].getSelection();
                    //     if (selection.rangeCount > 0) {
                    //         const range = selection.getRangeAt(0);
                    //         return { container: range.startContainer, offset: range.startOffset };
                    //     }
                    //     return null;
                    // }

                    // Detect caret movement or trigger click on touchend



                    thisEditor.addTinymceEventListener(editor, 'click', function (e) {
                        //if ($(e.target) == null || $(e.target).attr('class') == null) return;
                        // else

                        if ($(e.target).closest("#ctxSlider").length > 0 || $(e.target).closest("#non-hover-ctxbar").length > 0) {
                            console.log('#ctxSlider in click listener');
                            e.preventDefault();
                            e.stopImmediatePropagation();
                            e.stopPropagation();
                            setCtxSliderClicked(true);
                            return;

                        }
                        setCtxSliderClicked(false);
                        $('.template-thumbnail').hide();
                        $('ul.action-sync').removeClass('show-action');
                        $('ul.action-lang').removeClass('show-action');
                        //remove preview
                        $('.action-preview').removeClass('add-background-color');
                        $('ul.display').removeClass('hienlen');
                        //remove view source
                        $('.view-mode').removeClass('add-background-color');
                        $('ul.display-view-mode').removeClass('hienlen');
                        //remove design
                        $('.design-menu').removeClass('add-background-design');
                        $('ul.design').removeClass('display-menu');
                        //remove choose
                        $('.action-choose-template').removeClass('add-background-choose');
                        $('ul.display-template').removeClass('display-choose-template');


                        if ($('#resumeSidebar') && $('#resumeSidebar').hasClass('open')) {
                            resumePageEvents.closeSidebar();
                            console.log('Builder hidding modal backdrop 3');
                            hideModalBackDrop();
                        }
                        closeDrawer(e);


                        try {
                            window.localeEvents.handleOutsideClick(e, 1);
                            window.localeEvents.handleOutsideClick(e, 3);
                        } catch (error) {
                            console.error('Error toggling dropdown:', error);
                        }

                        if ($(e.target).attr('class') == 'href-class') {
                            $("#builder_iframe")[0].contentWindow.tinymce.execCommand('mceLink');
                        } else if ($(e.target).attr('class') == 'hr-class') {
                            $("#builder_iframe")[0].contentWindow.tinymce.execCommand('hrEditCommand', false, editor);
                        } else if ($(e.target).hasClass('figure-class')) {
                            $("#builder_iframe")[0].contentWindow.tinymce.execCommand('myCareerEditCommand', false, editor);
                        } else if ($(e.target).hasClass('career-class')) {
                            $("#builder_iframe")[0].contentWindow.tinymce.execCommand('myCareerEditCommand', false, editor);
                        }
                        else if ($(e.target).hasClass('figure-editor')) {
                            if ($(e.target).closest('.career-class').length) {
                                var obj = $(e.target).closest('.career-class');
                                $("#builder_iframe")[0].contentWindow.tinymce.execCommand('mceSelectNode', false, obj[0]);
                                $("#builder_iframe")[0].contentWindow.tinymce.execCommand('myCareerEditCommand', false, editor);
                            }
                        }
                        else if ($(e.target).attr('class') && $(e.target).attr('class').startsWith('mark-fapk')) {
                            $("#builder_iframe")[0].contentWindow.tinymce.execCommand('mceOpenFontawesomepicker', false, editor);
                        }
                        else if ($(e.target).hasClass('profileimage-class')) {
                            e.preventDefault();
                            var obj = $(e.target);

                            $("#builder_iframe")[0].contentWindow.tinymce.execCommand('mceSelectNode', false, obj[0]);
                            $("#builder_iframe")[0].contentWindow.tinymce.execCommand('myProfileImageEditCommand', false, editor);
                            // // Remove selection (clear ranges)
                            // const selection =editor.selection;
                            // selection.collapse();  // Collapses the selection

                            // // Remove focus from the clicked element to prevent the blinking cursor or highlight
                            // obj.blur();  // This removes focus from the selected image


                        }

                        // console.log ($(e.target).attr("class"));

                        // console.log ($(e.target));




                        var obj = $(e.target);

                        var element = thisEditor.elementFactory(obj);

                        selectedMainElement = element;



                        if (element != null) {
                            e.preventDefault();

                            $('a.nav-item').removeClass('active show');
                            $('.tab-pane').removeClass('active show');
                            $('#nav-home-tab').addClass('active show');
                            $('#nav-home').addClass('active show');

                            // select elment
                            var old = thisEditor.selected;

                            // console.log ("Element already selected: " + old);


                            thisEditor.select(element);
                            //  setCustomTimeout(function() {
                            //     thisEditor.unselect();
                            //     thisEditor.hideControls();
                            //    }, 20000);

                        } else if (!thisEditor.isHelperTarget($(e.target))) {
                            thisEditor.unselect();
                            thisEditor.hideControls();
                        }


                    });







                    thisEditor.addTinymceEventListener(editor, 'keyup', function (e) {
                        if (thisEditor.selected != null) {
                            //thisEditor.selected.adjustSelectOutlinePosition();
                            thisEditor.selected.adjustSelectControlsPosition();
                            // thisEditor.selected.adjustSelectMoveButtonPosition();
                        }
                    });


                    thisEditor.addTinymceEventListener(editor, 'keydown', function (e) {
                        if (isHoverable) {
                            thisEditor.unselect();
                        }

                    });




                    thisEditor.addTinymceEventListener(editor, 'Undo', function (e) {
                        const bodyhtml = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html')[0];
                        const canvas = bodyhtml.querySelector('#signature-canvas');
                        if (isHoverable) thisEditor.unselect();
                        if (canvas && canvas.dataset.initialized !== 'true') {
                            initSignaturePad(); // Call your reinitialization logic
                        }
                        if (/iPhone/i.test(navigator.userAgent)) {
                            setCustomTimeout(() => {
                                cleanupCustomCaretListeners();
                                integrateCustomCaret();
                            }, 200);
                        }
                    });

                    thisEditor.addTinymceEventListener(editor, 'Redo', function (e) {
                        const bodyhtml = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html')[0];
                        const canvas = bodyhtml.querySelector('#signature-canvas');
                        if (isHoverable) thisEditor.unselect();
                        if (canvas && canvas.dataset.initialized !== 'true') {
                            initSignaturePad(); // Call your reinitialization logic
                        }
                        if (/iPhone/i.test(navigator.userAgent)) {
                            setCustomTimeout(() => {
                                cleanupCustomCaretListeners();
                                integrateCustomCaret();
                            }, 200);
                        }
                    });






                    if (window.location.href.includes("coverletter")) {
                        thisEditor.addTinymceEventListener(editor, 'PastePostProcess', function () {

                            console.log("Post Process Called");
                            setCustomTimeout(() => {
                                initSignaturePad();
                            }, 300);



                        });




                    }

                },
                formats: {
                    alignleft: { selector: 'span,em,i,b,strong', inline: 'span', block: 'span', styles: { display: 'block', 'text-align': 'left' } },
                    aligncenter: { selector: 'span,em,i,b,strong', inline: 'span', block: 'span', styles: { display: 'block', 'text-align': 'center' } },
                    alignright: { selector: 'span,em,i,b,strong', inline: 'span', block: 'span', styles: { display: 'block', 'text-align': 'right' } },
                    alignfull: { selector: 'span,em,i,b,strong', inline: 'span', block: 'span', styles: { display: 'block', 'text-align': 'full' } },
                    alignjustify: { selector: 'span,em,i,b,strong', inline: 'span', block: 'span', styles: { display: 'block', 'text-align': 'justify' } }
                }
            };

            setLightDarkModeForEditor();



            tinyconfig.selector = '#PageElement';

            //This is setup when there is a new build
            try {
                // Attempt to initialize TinyMCE
                thisEditor.tinymce = await $("#builder_iframe")[0].contentWindow.tinymce.init(tinyconfig);

                // If initialization is successful, clear the reload flag
                sessionStorage.removeItem('reloadFlag');
            } catch (error) {
                console.error('Error initializing TinyMCE:', error);

                // Check if the reload flag is set in sessionStorage
                if (!sessionStorage.getItem('reloadFlag')) {
                    // Set the flag to indicate the page has been reloaded once
                    sessionStorage.setItem('reloadFlag', 'true');

                    // Reload the page
                    location.reload();
                } else {
                    console.error('Page already reloaded. Reload skipped to prevent loop.');
                }
            }


        }
    },

    removeInlineEdit: function (container) {
        // remove tinymce instant
        // $("#builder_iframe")[0].contentWindow.tinymce.remove();
    },

    loadIframeJs: function (jss, callback) {
        var thisEditor = this;

        if (jss.length > 0) {
            var s = document.createElement("script");
            var url = jss.shift();

            // console.log("loading: " + url);

            s.type = "text/javascript";
            s.src = url;
            s.setAttribute('builder-helper', 'true')
            s.onload = function () {
                //
                thisEditor.loadIframeJs(jss, callback);
            };
            $("#builder_iframe")[0].contentWindow.document.head.appendChild(s);
        } else {
            if (typeof (callback) !== 'undefined') {
                callback();
            }
        }
    },

    includeIframeJs: function (jss, callback) {
        var thisEditor = this;

        if (jss.length > 0) {
            var s = document.createElement("script");
            var url = jss.shift();
            // console.log("loading: " + url);
            s.type = "text/javascript";
            s.src = url;
            s.onload = function () {
                if (typeof (callback) !== 'undefined') {
                    callback();
                }

                //
                thisEditor.loadIframeJs(jss, callback);
            };
            $("#builder_iframe")[0].contentWindow.document.head.appendChild(s);
        }
    },

    loadPageJs: async function (jss) {
        var thisEditor = this;

        if (jss.length > 0) {
            const url = jss.shift();
            await thisEditor.loadSingleJs(url); // Wait for the script to load before proceeding
            await thisEditor.loadPageJs(jss);   // Recursively load the remaining scripts
        }
    },

    loadSingleJs: function (url) {
        return new Promise((resolve, reject) => {
            var s = document.createElement("script");

            s.type = "text/javascript";
            s.src = url;
            s.setAttribute('builder-helper', 'true');
            s.onload = resolve;
            s.onerror = reject;

            window.document.head.appendChild(s);
        });
    },

    setupIframe: function (callback) {
        var thisEditor = this;

        // code will run after iframe has finished loading
        $("#builder_iframe").contents().find('head').append('<link builder-helper="true" rel="stylesheet" href="' + constants.IFRAME_BASE_PATH + '/builder-frame.css">');
        if (thisEditor.iconStyle == 'default') {
            $("#builder_iframe").contents().find('head').append('<link builder-helper="true" rel="stylesheet" href="' + constants.IFRAME_BASE_PATH + + '/fontawesome-free/css/fontawesome.min.css">');
        } else if (thisEditor.iconStyle == 'fontawesome') {
            $("#builder_iframe").contents().find('head').append('<link builder-helper="true" rel="stylesheet" href="' + constants.IFRAME_BASE_PATH + '/fontawesome/css/fontawesome.min.css">');
        }
        $("#builder_iframe").contents().find('head').append('<link builder-helper="true" rel="stylesheet" href="' + constants.IFRAME_BASE_PATH + + '/autocomplete.css">');

        // default font face
        /*
        var fonts = [
            {name: 'Rubik', url: thisEditor.root + "font/Rubik-VariableFont_wght.ttf"}
        ];
        fonts.forEach(function(font) {
            if (!$("#builder_iframe").contents().find('[font-name="'+font.name+'"]').length) {
                $("#builder_iframe").contents().find('head').append(`
                    <style font-name="`+font.name+`">
                        @font-face {
                            font-family: "`+font.name+`";
                            src: url(`+font.url+`);
                        }
                    </style>
                `);
            }
        });
        */
        var jss = [constants.IFRAME_BASE_PATH + '/events.js', '/dist/jquery/jquery.min.js'];

        // Editor
        jss.push(constants.IFRAME_BASE_PATH + '/tinymce/tinymce.min.js');



        // load js
        thisEditor.loadIframeJs(jss, function () {
            thisEditor.loadingSetMessage(getI18n('scripts_loaded'));

            if (typeof (callback) !== 'undefined') {
                callback();
            }
        });
    },

    initIframe: function (historyState) {
        var thisEditor = this;

        thisEditor.checkIfLoggedIn();

        // content iframe after loaded listening


        currentFileName = thisEditor.url.split('/').pop();
        console.log("init Iframe with fileName:", currentFileName);

        if (!thisEditor.url) {
            var html = '<!DOCTYPE html><html lang="en"><head>' +
                '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8">' +
                '<meta name="viewport" content="width=device-width, initial-scale=1">' +
                '<meta name="description" content="">' +
                '<title>Resume Builder GPT</title>' +
                '</head>' +
                '<body class="" style="width:auto">' +
                '<div builder-element="PageElement" style="padding-top:50px;padding-bottom:50px;">' +
                '</div>' +
                '</body>' +
                '</html>';
            thisEditor.iframe.attr('srcdoc', html);
        } else {
            thisEditor.loadingSetMessage(getI18n('loading_template'));
            setCustomTimeout(() => {
                thisEditor.loadUrl(thisEditor.url, undefined, historyState);
            }, 200);

        }

    },

    loadHtml: function (html) {
        var thisEditor = this;

        // unselect
        thisEditor.unselect();
        thisEditor.hideControls();

        thisEditor.iframe.contents().find("html").html(html);

        // js auto height iframe
        thisEditor.adjustIframeSize();
    },

    addParameterToURL: function (_url, param) {
        _url += (_url.split('?')[1] ? '&' : '?') + param;
        return _url;
    },

    logClouldFrontCookies: function () {
        //console.log("The SRC in iframe: ", thisEditor.url);
        // console.log("The folderId:", getFolderIdFromCookies());
        // console.log("The Vendor:", getVendorFromCookies());

        // const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
        // // Check if all cookies are set, valid, and the folder ID matches
        // const cloudFrontPolicy = getCookie('CloudFront-Policy');
        // const cloudFrontSignature = getCookie('CloudFront-Signature');
        // const cloudFrontKeyPairId = getCookie('CloudFront-Key-Pair-Id');
        // const cloudFrontExpires = getCookie('CloudFront-Expires');
        // const cloudFrontFolderId = getCookie('CloudFront-FolderId');

        // const currentFolderId = getFolderIdFromCookies();

        // console.log('CloudFront Policy:', cloudFrontPolicy);
        // console.log('CloudFront Signature:', cloudFrontSignature);
        // console.log('CloudFront Key-Pair-Id:', cloudFrontKeyPairId);
        // console.log('CloudFront Expires:', cloudFrontExpires);
        // console.log('CloudFront Folder ID:', cloudFrontFolderId);
        // console.log('Current Folder ID:', currentFolderId);
        // if (
        //     cloudFrontPolicy &&
        //     cloudFrontSignature &&
        //     cloudFrontKeyPairId &&
        //     cloudFrontExpires &&
        //     cloudFrontFolderId === currentFolderId &&
        //     parseInt(cloudFrontExpires, 10) > currentTime
        // ) {
        //     console.log('Signed cookies are valid and folder ID matches');
        // } else {
        //     console.log('Signed cookies are expired, missing, or folder ID mismatch; regenerating for folderUUID...', currentFolderId);
        // }

    },

    loadUrl: function (url, callback, historyState) {
        var thisEditor = this;
        var maxRetries = 1;
        var retryCount = 0;
        var retryInterval = 1000;

        // Add rand cache (uncomment if needed)
        // url = thisEditor.addParameterToURL(url, 'gpt=' + (Math.random() + 1).toString(36).substring(7));
        thisEditor.url = url;

        console.log('thisEditor.url', thisEditor.url);

        if (thisEditor.url.startsWith('/templates/')) {
            thisEditor.readOnlyMode = true;
        } else {
            thisEditor.readOnlyMode = false;
        }



        // Function to attempt loading the URL with retries
        async function attemptLoad() {
            onLoadTriggered = false;
            const onLoadTimeout = 200;   // Timeout in milliseconds to wait before manual trigger
            console.log('In attempt saved');
            let savedContent = null;


            if (!thisEditor.readOnlyMode) {
                try {
                    const savedContentObj = await thisEditor.retrieveContent(currentFileName);
                    savedContent = savedContentObj ? savedContentObj.content : null;
                } catch (error) {
                    console.error(`Error retrieving content from IndexedDB for ${currentFileName}:`, error);
                    savedContent = null;  // Return null if an error occurs
                }
            }

            // Set iframe source
            if (savedContent) {
                thisEditor.contentSaved = true;
                const iframeWindow = thisEditor.iframe[0].contentWindow;
                const iframeDocument = iframeWindow.document;
                iframeDocument.open();
                iframeDocument.write(savedContent);
                iframeDocument.close();
                setCustomTimeout(() => {
                    if (!onLoadTriggered) {
                        console.log('Timeout reached. Manually triggering iframe onload in saved Content.');
                        thisEditor.iframe.trigger('load');
                    } else
                        console.log('On load already triggered Not triggering again in savedContent in timeout');
                }, onLoadTimeout);
            }
            else {
                thisEditor.contentSaved = false;
                thisEditor.iframe.attr('src', thisEditor.url);
            }
            const folderUUID = getFolderIdFromCookies();
            const vendor = getVendorFromCookies();
            const hostname = window.location.hostname;

            if (folderUUID && vendor) {
                await getSignedCookies(folderUUID, vendor, hostname);
            } else {
                console.log("Not getting signed cookie as folderUUID or Vendor is null")
            }


            //logClouldFrontCookies();
            // Check for redirect after the iframe loads
            thisEditor.iframe.on('load', async function () {
                if (onLoadTriggered) {
                    console.log('🔁 onload already triggered, skipping duplicate.');
                    return; // Prevent double execution
                }
                onLoadTriggered = true;
                alreadyRedirectedInFrame = false;
                const iframeElement = thisEditor.iframe[0];
                const iframeDocument = iframeElement.contentDocument || iframeElement.contentWindow.document;
                let fileIsIndexHtml = false;
                try {
                    if (!savedContent) {
                        const filenameMeta = iframeDocument.querySelector("meta[name='filename']");
                        const filename = filenameMeta ? filenameMeta.getAttribute('content') : null;

                        if (filename === 'index.html') {
                            console.log('filename is index.html');
                            const folderUUID = getFolderIdFromCookies();
                            const vendor = getVendorFromCookies();
                            fileIsIndexHtml = true;
                            if ($('#resume-loadingSpinner')) $('#resume-loadingSpinner').show();
                            if (alreadyRedirectedInFrame) {
                                window.history.replaceState({}, '', '/');
                                window.location.reload();
                            }
                            else {
                                await fetchAndStoreDataOnLogin(folderUUID, vendor, true, false);
                                console.log('fetchAndStoreDataOnLogin fetched');
                                // alreadyRedirectedInFrame=true;
                                const newResumeUrl = getResumeUrl();
                                console.log('newResumeUrl', newResumeUrl);
                                const coverletterCheck = '/coverletter' + thisEditor.url;
                                const resumeCheck = '/resume' + thisEditor.url;
                                if (newResumeUrl !== resumeCheck && newResumeUrl !== coverletterCheck) {
                                    // navigate(newResumeUrl);
                                    navigate(newResumeUrl, null, null, false, false, false, true);
                                } else {
                                    //Here it means that we have problem with the redis cache, so we need to get the list of file from the S3 and compare and remove the deleted files or synced file
                                    //Then call again await fetchAndStoreDataOnLogin(folderUUID, vendor, true);
                                    await fetchAndStoreDataOnLogin(folderUUID, vendor, true, true);
                                    console.warn('fetchAndStoreDataOnLogin Calling it 2nd time WITH SYNC (IMPORTANT!)');
                                    // alreadyRedirectedInFrame=true;
                                    const newResumeUrl = getResumeUrl();
                                    console.log('newResumeUrl', newResumeUrl);
                                    const coverletterCheck = '/coverletter' + thisEditor.url;
                                    const resumeCheck = '/resume' + thisEditor.url;
                                    if (newResumeUrl !== resumeCheck && newResumeUrl !== coverletterCheck) {
                                        navigate(newResumeUrl, null, null, false, false, false, true);
                                    } else {
                                        console.log('going to /');
                                        window.history.replaceState({}, '', '/');
                                        window.location.reload();
                                    }
                                }
                            }
                        } else if (callback) {
                            // If filename is valid and doesn't trigger retry, call the callback
                            callback(true);
                            setLoginRedirectIntervalWithTimeout();
                        }
                    }

                    //alreadyRedirectedInFrame=false;
                    if (!fileIsIndexHtml) {

                        thisEditor.setupIframe(function () {
                            thisEditor.loadingSetMessage(getI18n('finalizing'));
                            // after iframe header loaded (all loaded)
                            thisEditor.afterIframeLoaded();

                            // callback
                            if (typeof (thisEditor.iframeLoadedCallback) !== 'undefined') {
                                thisEditor.iframeLoadedCallback();
                            }

                            //
                            thisEditor.adjustIframeSize();

                            // all done

                            setCustomTimeout(function () {
                                thisEditor.done();
                            }, 100);

                        });



                        if (historyState && historyState.slidesfilter) {
                            if (desktop) slidersetup.init(historyState.slidesfilter, thisEditor, null, iframeDocument);
                        }
                        else {
                            if (desktop) slidersetup.init(null, thisEditor, null, iframeDocument);
                            updateHistoryAndReplaceState('slidesfilter', null);
                        }



                        // Store the callback if provided
                        if (typeof callback !== 'undefined') {
                            thisEditor.iframeLoadedCallback = function () {
                                console.log('Calling Iframe loaded callback');
                                callback();
                            };
                        }
                        setLoginRedirect(300);
                    }


                } catch (e) {
                    console.warn('Cross-origin restriction or redirect detected', e);
                    if (callback) callback(false); // Indicate failure due to redirect or error
                }
            });
        }

        const timeout = getLoginRedirect();//this is timeout to fire the iframe

        console.log("frame timeout:", timeout);
        // Start the initial load attempt
        setCustomTimeout(attemptLoad, timeout);


    },

    checkForFang: function () {
        const target = $("#builder_iframe").contents().find('#maincontent-body-html')[0];
        const data = target.getAttribute('data').split("|");
        if (data.length >= 6) { // Ensure there are at least 6 tokens (0-based index)
            const fifthToken = data[5].trim(); // Extract and trim whitespace
            if (fangCompanies.includes(fifthToken)) {
                console.log("FANG Company Detected:", fifthToken);
                return true;
            }
        }
        return false;
    },


    load: function (html) {
        var thisEditor = this;

        thisEditor.iframeLoadedCallback = function () {
            thisEditor.loadHtml(html);
        };
    },

    handleAutocomplete: function () {
        var thisEditor = this;
        var tags = [];

        if (!thisEditor.tags) {
            return false;
        }

        thisEditor.tags.forEach(function (tag) {
            if (tag.type == 'label') {
                tags.push(tag.tag);
            }
        });

        // init autocomplete input
        acpAutocomplete(thisEditor, tags);
    },

    isNotElement: function (obj) {
        if (obj[0].hasAttribute('builder-no-select')) {
            return true;
        } else {
            return false;
        }
    },

    isHelperTarget: function (obj) {
        if (// obj.closest('.mce-content-body').length > 0 ||
            obj.closest('.tox').length > 0 ||
            obj.closest('.tox-tinymce').length > 0 ||
            obj.closest('.builder-outline-move-hook').length > 0 ||
            obj.closest('.builder-outline-selected-controls').length > 0 ||
            obj.closest('[f-role=placeholder]').length > 0 ||
            obj.closest('.tox-editor-container').length > 0 ||
            obj.closest('.bubble').length > 0 ||
            obj.closest('.custom-tooltip').length > 0
        ) {
            return true;
        } else {
            return false;
        }
    },

    checkIfLoggedIn: function () {
        if (checkJwtTokenCookieExists()) {
            try {
                const initial = getInitialFromCookies();
                showLoggedInSvg(initial);
                // console.log ("Email:", getEmailFromCookies());
            } catch (err) {
                console.log(err);
            }
        } else
            showLogInAndSignUpButtons();
    },

    // after iframe and all new js css files embeded loaded
    afterIframeLoaded: function () {
        var thisEditor = this;

        //thisEditor.initDrag();

        // include defualt js/css
        if (typeof ($("#builder_iframe")[0].contentWindow.beeFormLoaded) == 'undefined') {

            setSliderValue(); //setting the values before the tinymce init
            thisEditor.loading += 1;
            this.inlineEdit($("#builder_iframe")[0]);




            thisEditor.mainResizeListener = function () {
                clearTimeout(resizeTimeout); // Clear previous timeout
                resizeTimeout = setCustomTimeout(() => {
                    const currentWidth = window.innerWidth;

                    // Determine the current breakpoint state
                    const isBelowOrEqual1260 = currentWidth <= 1260;
                    desktop = window.innerWidth > 1260;

                    // Handle transitions between breakpoints
                    if (lastBreakpoint === null || (isBelowOrEqual1260 && lastBreakpoint !== 'belowOrEqual1260')) {
                        // Transitioning to <=1260
                        thisEditor.changeNavText("#image-carousel-div", "#changetheme-text");
                        thisEditor.changeNavText("#image-carousel-div", "#changethememl-text");
                        thisEditor.changeNavText("#image-carousel-div", "#changethememl-menu-text");
                        lastBreakpoint = 'belowOrEqual1260'; // Update the breakpoint state
                    } else if (!isBelowOrEqual1260 && lastBreakpoint !== 'above1260') {
                        // Transitioning to >1260
                        thisEditor.changeNavText("#image-carousel-div", "#changethememl-text");
                        thisEditor.changeNavText("#image-carousel-div", "#changethememl-menu-text");
                        lastBreakpoint = 'above1260'; // Update the breakpoint state
                    }


                    // Update the previous width for reference
                    previousWidth = currentWidth;

                    const iframeElement = thisEditor.iframe[0];
                    const iframeDocument = iframeElement.contentDocument || iframeElement.contentWindow.document;

                    if (desktop) slidersetup.init(null, thisEditor, null, iframeDocument);
                    updateHistoryAndReplaceState('slidesfilter', null);
                }, 200); // Delay execution by 200ms
            };

            window.addEventListener('resize', thisEditor.mainResizeListener);


            thisEditor.changeNavText("#image-carousel-div", "#changetheme-text");
            thisEditor.changeNavText("#image-carousel-div", "#changethememl-text");
            thisEditor.changeNavText("#image-carousel-div", "#changethememl-menu-text");
            const target = $("#builder_iframe").contents().find('#maincontent-body-html')[0];


            //check for login

        }

        // click on content (content) // done tinymce
        $("#builder_iframe").contents().click(function (e) {
            // if ($(e.target).hasClass('builder-outline-move-hook') || $(e.target).parents('.builder-outline-move-hook').length) {
            //     return;
            // }


            console.log('Clicked on builder_iframe content');

            // save current click pos
            thisEditor.clickX = e.offsetX;
            thisEditor.clickY = e.offsetY;

            var obj = $(e.target);
            var element = thisEditor.elementFactory(obj);

            while (element != null && !element.canSelect() && obj.parents('[builder-element]').length) {
                obj = obj.parents('[builder-element]').first();
                element = thisEditor.elementFactory(obj);
            }

            if (element != null && !element.canSelect()) {
                return this.elementFactory(element.obj.parents('[builder-element]').first());
            }

            if (element != null) {
                e.preventDefault();

                $('a.nav-item').removeClass('active show');
                $('.tab-pane').removeClass('active show');
                $('#nav-home-tab').addClass('active show');
                $('#nav-home').addClass('active show');

                // select elment
                var old = thisEditor.selected;
                thisEditor.select(element);
                if (old == null || !old.equals(thisEditor.selected)) {
                    thisEditor.handleSelect();
                }
            } else if (!thisEditor.isHelperTarget($(e.target))) {
                thisEditor.unselect();
                thisEditor.hideControls();
            }

            // trigger iframe content click
            clickIframe();
        });

        // Click on duplicate action on left content (khi nhan chuot phai no duplicate)
        $("#builder_iframe").contents().find("body").on('mouseup', '.builder-duplicate-selected-button', function () {
            thisEditor.duplicate();
        });


        // Click on duplicate action on left content (khi nhan chuot phai no duplicate)
        $("#builder_iframe").contents().find("body").on('mouseup', '.mobile-clear-btn', function () {
            thisEditor.triggerCutExternally();
        });


        $("#builder_iframe").contents().find("body").on('mouseup', '.mobile-bold-btn', function () {
            $("#builder_iframe")[0].contentWindow.tinymce.execCommand('mceToggleFormat', false, 'bold');
        });

        $("#builder_iframe").contents().find("body").on('mouseup', '.mobile-italic-btn', function () {
            $("#builder_iframe")[0].contentWindow.tinymce.execCommand('mceToggleFormat', false, 'italic');
        });

        $("#builder_iframe").contents().find("body").on('mouseup', '.mobile-underline-btn', function () {
            $("#builder_iframe")[0].contentWindow.tinymce.execCommand('mceToggleFormat', false, 'underline');
        });

        $("#builder_iframe").contents().find("body").on('mouseup', '.builder-outline-move-hook', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            thisEditor.unselect();
            if (typeof window.externalEnableDragAndDrop === "function") {
                setCustomTimeout(function () {
                    window.externalCleanupDragState();
                    window.externalEnableDragAndDrop();
                }, 100);
            }
        });



        // Click on remove action on left content (khi nhan chuot phai no delete)
        $("#builder_iframe").contents().find("body").on('mouseup', '.builder-remove-selected-button', function () {
            thisEditor.remove();
        });

        $("#builder_iframe").contents().find("body").on('mouseup', '#builder-ai-selected-button', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            thisEditor.showAiBox(e);
        });


        // select parent element
        $("#builder_iframe").contents().find("body").on('mouseup', '.builder-select-parent-button', function () {
            thisEditor.selectParent(thisEditor.selected);
        });

        $("#builder_iframe").contents().find("body").keydown(function (e) {
            if (e.which === 90 && e.ctrlKey) {
                thisEditor.undo();

                return;
            }

            if (e.which === 89 && e.ctrlKey) {
                thisEditor.redo();

                return;
            }
        });

        //done tinymce
        // hover on elements of content
        $("#builder_iframe").contents().find("body").on('mouseover', '*', function (e) {
            if (thisEditor.isDragging) {
                return;
            }

            // find hover element
            var obj = $(e.target);
            var element = thisEditor.elementFactory(obj);

            while (element != null && !element.canHover() && obj.parents('[builder-element]').length) {
                obj = obj.parents('[builder-element]').first();
                element = thisEditor.elementFactory(obj);
            }

            if (element != null) {
                if (element.equals(thisEditor.selected)) {
                    // do not highlight selected element
                    return true;
                }

            }
        });

        //done tinymce
        // this.content.find('*').mouseout(function(e) {
        $("#builder_iframe").contents().find("body").on('mouseout', '*', function (e) {
            var element = thisEditor.elementFactory($(e.target));

            if (element != null) {
                if (element.equals(thisEditor.selected)) {
                    return true;
                }

            }
        });

        //done tinymce
        // this.content.find('*').mouseout(function(e) {
        $("#builder_iframe").contents().find("body").on('keyup', '*', function () {
            if (thisEditor.selected != null) {
                // thisEditor.selected.adjustSelectOutlinePosition(); // Commented this out as this was getting error
                thisEditor.selected.adjustSelectControlsPosition();
                //thisEditor.selected.adjustSelectMoveButtonPosition();
            }
        });

        //done tinymce
        $("#builder_iframe").contents().find("body").on('click', '*', function (e) {
            if ($(e.target).closest("#ctxSlider").length > 0 || $(e.target).closest("#non-hover-ctxbar").length > 0) {
                console.log('ctxslider in iframe click');
                e.preventDefault();
                e.stopImmediatePropagation();
                setCtxSliderClicked(true);
                return;

            }

            if (!thisEditor.isHelperTarget($(e.target))) {
                console.log('Click closing in helpertarget');
                thisEditor.unselect();
                thisEditor.hideControls();
            }

            if (!$(e.target).closest('#mce-content-body').length) {
                // console.log ('Target is: ', e.currentTarget);
                // console.log("Element not clicked inside mce-content-body");
                thisEditor.unselect();
                thisEditor.hideControls();
            }

            setCtxSliderClicked(false);

            $('.template-thumbnail').hide();
            $('ul.action-sync').removeClass('show-action');
            $('ul.action-lang').removeClass('show-action');
            //remove preview
            $('.action-preview').removeClass('add-background-color');
            $('ul.display').removeClass('hienlen');
            //remove view source
            $('.view-mode').removeClass('add-background-color');
            $('ul.display-view-mode').removeClass('hienlen');
            //remove design
            $('.design-menu').removeClass('add-background-design');
            $('ul.design').removeClass('display-menu');
            //remove choose
            $('.action-choose-template').removeClass('add-background-choose');
            $('ul.display-template').removeClass('display-choose-template');

            closeDrawer(e);
            if ($('#resumeSidebar') && $('#resumeSidebar').hasClass('open')) {
                resumePageEvents.closeSidebar();
            }
            console.log('Builder hidding modal backdrop 4');
            hideModalBackDrop();

            try {
                window.localeEvents.handleOutsideClick(e, 1);
                window.localeEvents.handleOutsideClick(e, 3);
            } catch (error) {
                console.error('Error toggling dropdown:', error);
            }

        });

        // js auto height iframe
        thisEditor.adjustIframeSize();

        // handle autocomplete
        thisEditor.handleAutocomplete();

        // check empty
        thisEditor.checkEmpty();

        // prevent form element clickable
        // thisEditor.preventFormElementEvents();

        // iframe resize event
        var iframeWin = document.getElementById('builder_iframe').contentWindow;
        iframeWin.addEventListener('resize', function () {
            if (thisEditor.selected != null) {
                thisEditor.selected.select();
            }
        });

        // disable link
        // hover on elements of content
        $("#builder_iframe").contents().find("body").on('click', 'a', function (e) {
            e.preventDefault();
        });

        // go to home tab
        thisEditor.goToHomeTab();


        $(document.getElementById('builder_iframe').contentWindow.document).ready(function () {
            thisEditor.adjustIframeSize();

            // make sure it works
            setCustomTimeout(function () {
                thisEditor.adjustIframeSize();
            }, 500);
        })
    },

    goToHomeTab: function () {
        var thisEditor = this;
    },

    // preventFormElementEvents: function () {
    //     $("#builder_iframe").contents().find('select,input,textarea').on('mousedown', function (e) {
    //         e.preventDefault();
    //         this.blur();
    //         window.focus();
    //     });
    // },
    adjustIframeSize: function () {

        // if (this.selected != null) {
        //     this.selected.select(this.gscale);;
        // }

        // var iframe = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr')[0];
        // var tinymce = $("#builder_iframe").contents().find("body").find('.tox.tox-tinymce')[0];
        // var maintable = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table')[0];

        // if (maintable && iframe && tinymce) {
        //         maintable.style.height = 'auto'; // Reset to auto height before calculating
        //         var newHeight = (maintable.scrollHeight + 300) + 'px';
        //         tinymce.style.height = newHeight;
        // }
    },

    adjustIframeSizeOld: function () {

        var content_height = $("#builder_iframe").contents().find('html')[0].scrollHeight;
        var my_frame = document.getElementById('builder_iframe');

        // console.log ("Html Height is: ",  $("#builder_iframe").contents().find('html')[0].scrollHeight);
        // console.log ("Html Height non 0 is: ",  $("#builder_iframe").contents().find('html'));
        // console.log ("Body Height is: ",   my_frame.contentWindow.document.body.scrollHeight);

        if ($("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html')[0]) {
            // content_height = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html')[0].scrollHeight;
            //  content_height = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html')[0].offsetHeight;
            //  console.log ("Tiny Scroll height is:" , $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html')[0].scrollHeight);
            //  console.log ("Tiny Offset height is:" , $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html')[0].offsetHeight);



            //$("#builder_iframe").contents().find('html').height=content_height + 'px';

            //  $("#builder_iframe").contents().find('html')[0].css('height', content_height + 'px');
            // console.log ("Html Height is: ",  $("#builder_iframe").contents().find('html')[0].scrollHeight);
            //  console.log ("Html Height is: ",   $("#builder_iframe").contents().find('html').height);
            //  console.log ('main table:', $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table')[0].offsetHeight);


            var htmlHeight = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html')[0].scrollHeight;
            var pageElementHeight = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr')[0].scrollHeight;

            //  console.log("'#HTML height is: ", htmlHeight);

            //    console.log("#PageElement_ifr height is:", pageElementHeight);

            //htmlheight 1200px pagelementHeight 1500 we need to increase the height to 16165758
            //eg htmlheight 2000px pagelementHeight 1700 we need to increase the height to 3316
            //  console.log( $("#builder_iframe").contents().find("body").find('.tox.tox-tinymce'));

            // const pageHeight=1657;

            // const mainTableHeight = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table')[0].offsetHeight;
            // var heightToIncrease=mainTableHeight%pageHeight;
            // const times = Math.floor(mainTableHeight/pageHeight);

            // if(heightToIncrease>0){
            //     console.log ("Increasing height to: ", heightToIncrease);
            //     heightToIncrease = Math.round((1-heightToIncrease/pageHeight)* pageHeight);
            //     heightToIncrease = heightToIncrease - times * 1000;
            //     $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table').css('height', (mainTableHeight + heightToIncrease) + 'px');
            //     console.log ("main table height: ", mainTableHeight);
            // }




            if (pageElementHeight < htmlHeight) {

                // var heightToIncrease=htmlHeight%1657
                // heightToIncrease = Math.round((1-heightToIncrease/1657)* 1657)

                // console.log ("Increasing height to: ", heightToIncrease);

                $("#builder_iframe").contents().find("body").find('.tox.tox-tinymce').css('height', (htmlHeight + 200) + 'px');


                // $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').css('height',  height + 'px');

                //$("#builder_iframe").contents().find("body").find('.tox-edit-area').css('height', height + 'px');

                //  $("#builder_iframe").contents().find('html').css('height', height + 'px');
                //  console.log( $("#builder_iframe").contents().find("body").find('.tox.tox-tinymce'));



            }

            if (this.selected != null) {
                this.selected.select(defaultScaleFactor);
            }

            // console.log("PageElement_ifr height:", $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr')[0].scrollHeight);
        }

        // $("#builder_iframe").contents().find('html').css('scrollTop', content_height + 'px');
        //  $("#builder_iframe").contents().find("body").css('height', content_height + 'px');

        //  $('.content-background').css('height', content_height);



        // var my_frame = document.getElementById('builder_iframe');
        // content_height = my_frame.contentWindow.document.body.scrollHeight;
        // var padding = parseInt($(my_frame.contentWindow.document.documentElement).css('padding-top')) +
        //     parseInt($(my_frame.contentWindow.document.documentElement).css('padding-bottom'));

        // var height = (content_height + padding);
        //  if (height < 600) {
        //      height = 600;
        //  }

        // my_frame.style.height = height + 'px';
        // console.log ("Height is: " , height);

        // adjust selected hover


        // $("#builder_iframe").contents().find('html').css('height', content_height);
    },
    triggerCutExternally: function () {
        console.log('Trigger Cut Externally');
        $("#builder_iframe")[0].contentWindow.tinymce.execCommand('triggerCut');
    },
    adjustPreviewIframeSize: function () {
        var my_frame = document.getElementById('previewIframeDesktop');
        var content_height = my_frame.contentWindow.document.body.scrollHeight;
        var padding = parseInt($(my_frame.contentWindow.document.documentElement).css('padding-top')) +
            parseInt($(my_frame.contentWindow.document.documentElement).css('padding-bottom'));

        var height = (content_height + padding);
        // if (height < 600) {
        //     height = 200;
        // }

        my_frame.style.height = height + 'px';
    },

    selectParent: function (element) {
        var thisEditor = this;

        var obj = element.obj.parent();
        var element = thisEditor.elementFactory(obj);

        while (element != null && !element.canSelect() && obj.parents('[builder-element]').length) {
            obj = obj.parents('[builder-element]').first();
            element = thisEditor.elementFactory(obj);
        }


        if (element != null) {
            thisEditor.select(element);
            thisEditor.handleSelect();
        } else {
            thisEditor.unselect();
            thisEditor.hideControls();
        }
    },

    setChatBoxValueInLocalStorage: async function () {
        if ($('#chatgptbox').length && $('#chatgptbox').val().trim() !== "") {
            const pageKey = `chatgptbox_value_${window.location.pathname}`;
            const textfromchatgptbox = $('#chatgptbox').val().trim();
            setLocalStorageItem(pageKey, textfromchatgptbox);
        }

    },
    updateRecentResumeLabel: async function (resumeName) {
        var recentResume = document.getElementById("recent-resume");
        if (recentResume)
            recentResume.innerHTML = `
                   <svg width="22" height="22" fill="currentColor" class="" style="vertical-align: middle; margin-right: 5px;">
                       <use href="#icon-file"></use>
                   </svg><span class="current-resume-name">
                   ${getI18n('recent')}: ${resumeName}</span>
                   `;


    },
    clearRecentResumeLabel: async function () {
        var recentResume = document.getElementById("recent-resume");
        if (recentResume) {
            recentResume.innerHTML = ''; // Clear the innerHTML
        }
    },
    addCustomCss: function (url) {
        // add custom css
        $("#builder_iframe").contents().find('head').append('<link builder-helper="true" rel="stylesheet" href="' + url + '">');
    },

    // Function to handle file deletion logic
    doDeleteFile: async function (fileToDelete, contentContainer) {
        const messageTemplate = getI18n('confirm_delete_single_file', { filename: fileToDelete.filename });
        const message = messageTemplate.replace('{filename}', fileToDelete.filename);
        const vendor = getVendorFromCookies();
        const folderUUID = getFolderIdFromCookies();

        console.log('Stringify data', JSON.stringify({ vendor: vendor, folderUUID: folderUUID, files: [fileToDelete] }));

        // Confirm deletion for individual mobile file
        Swal.fire({
            title: getI18n('warning'),
            text: message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: getI18n('confirm'),
            cancelButtonText: getI18n('cancel')
        }).then((result) => {
            if (result.isConfirmed) {
                // Call the delete API for the single file
                $.ajax({
                    url: getApiUrl('deleteObjects', 'loginapi'),
                    method: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify({ vendor: vendor, folderUUID: folderUUID, files: [fileToDelete] }),
                    success: function (response) {
                        createUpdateFilesEvents.deleteFile(fileToDelete.filename);
                        workerInitializationEvents.getContentWorker().postMessage({
                            id: getMessageId(),
                            action: 'deleteContent',  // Delete content from IndexedDB
                            data: { filename: fileToDelete.filename }
                        });
                        if (contentContainer) contentContainer.remove();
                    },
                    error: function (error) {
                        // Show error message with Swal
                        Swal.fire({
                            title: getI18n('oops_something_wrong'),
                            text: getI18n('error_while_deleting'),
                            icon: "error",
                        });
                    }
                });
            }
        });
    },
    handleRename: async function (mainButton, buttonContainer, ellipsisButton, originalFileName, openFile, shortDescription, prefix) {
        const span = mainButton.querySelector('span');
        const input = document.createElement('input');
        const originalDescription = span.textContent; // Store the original description
        input.type = 'text';
        input.value = shortDescription;
        input.className = 'rename-input text-sm px-2 w-full';

        // Add renaming class to container to completely disable hover behavior
        buttonContainer.classList.add('renaming');
        ellipsisButton.classList.add('hidden'); // Explicitly hide the ellipsis button

        // Temporarily disable the file opening functionality
        mainButton.removeEventListener('click', openFile);

        const cleanupAfterRename = () => {
            try {
                if (input && input.parentNode) {
                    input.remove();
                }
            } catch (error) {
                //console.warn("Error removing input element:", error);
            }
            if (mainButton) mainButton.appendChild(span);
            if (buttonContainer) buttonContainer.classList.remove('renaming'); // Remove renaming class
            if (mainButton) mainButton.addEventListener('click', openFile); // Re-enable the file opening functionality
        };

        const updateShortDescription = async (folderUUID, vendor, fileName, shortDescription) => {
            const encodedShortDescription = deflateAndEncode(shortDescription); // Encode the short description

            const payload = {
                folderUUID: folderUUID,
                vendor: vendor,
                fileName: fileName,
                shortDescription: encodedShortDescription, // Use encoded description
            };

            return new Promise((resolve, reject) => {
                $.ajax({
                    url: getApiUrl('updateShortDescription', 'loginapi'),
                    method: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify(payload),
                    success: function (response) {
                        resolve(response);
                    },
                    error: function (error) {
                        reject(error);
                    },
                });
            });
        };

        input.addEventListener('keydown', async (event) => {
            if (event.key === 'Enter') {
                const newDescription = input.value.trim();
                if (newDescription && newDescription !== shortDescription) {
                    const vendor = getVendorFromCookies();
                    const folderUUID = getFolderIdFromCookies();
                    try {
                        const response = await updateShortDescription(folderUUID, vendor, originalFileName, newDescription);

                        // Update the file in local storage with the unencoded description
                        const updateResult = await createUpdateFilesEvents.updateFile(originalFileName, { shortDescription: newDescription });
                        if (updateResult) {
                            span.textContent = prefix + newDescription; // Update UI
                        } else {
                            throw new Error('Failed to update file locally');
                        }
                    } catch (error) {
                        console.error('Error updating short description:', error);
                        Swal.fire({
                            title: getI18n('oops_something_wrong'),
                            text: getI18n('error_while_updating'),
                            icon: 'error',
                        });
                        span.textContent = originalDescription; // Restore the original description
                    } finally {
                        cleanupAfterRename();
                    }
                } else {
                    cleanupAfterRename();
                }
            }
        });

        input.addEventListener('blur', () => {
            // Restore the original state if input loses focus
            cleanupAfterRename();
        });

        // Replace span with input and focus
        mainButton.replaceChild(input, span);
        input.focus();
    },
    doGenerateCoverLetter: async function () {

        const proceed = await thisEditor.checkUserPlanAndUsageAndProceed();
        if (!proceed) {
            return;
        }

        console.log("Generating Cover Letter");

        if (isUserLoggedIn()) {
            const { email, vendor, folderId } = getVendorAndEmailFromCookies();
            const folderUUID = folderId;
            const hostname = window.location.hostname;
            let timeoutForCallDueToCloudFrontDelays = 90;
            const userLocale = getLanguage();


            // Compress the prompt using pako.deflate
            // Compress the prompt using pako.deflate
            let textfromchatgptbox = $('#chatgptbox').val().trim();
            let description = textfromchatgptbox;
            let shortDescription = description.length > 40 ? description.substring(0, 40) : description;


            // const coverLetterPathIfExists = createUpdateFilesEvents.searchInflatedDescription(description, userLocale, getI18n('coverletter_prefix'));
            const coverLetterPathIfExists = false;
            if (coverLetterPathIfExists) {
                console.log('CoverLetter Already Exists')
                navigate(coverLetterPathIfExists);
            } else {
                try {
                    await getSignedCookies(folderUUID, vendor, hostname);
                    setCustomTimeout(async function () {
                        const startTime = performance.now();

                        thisEditor.mask(getI18n('creating_coverletter'));

                        let InflationDescriptionText = null;

                        const urlToGenerateFromText = getUrlFromText(textfromchatgptbox);
                        if (urlToGenerateFromText) {
                            const descriptionText = await thisEditor.fetchJobPage(urlToGenerateFromText);
                            if (descriptionText === null) {
                                console.warn('⚠️ No description retrieved, exiting function.');
                                return;
                            }
                            InflationDescriptionText = decodeAndInflate(descriptionText);
                            //here replace the url with the description text in textfromchatgptbox
                            textfromchatgptbox = textfromchatgptbox.replace(urlToGenerateFromText, InflationDescriptionText);
                            description = InflationDescriptionText;
                            console.log('📄 textfromchatgptbox:', textfromchatgptbox);
                            try {
                                // If it's a string, parse it into JSON
                                if (typeof InflationDescriptionText === "string") {
                                    InflationDescriptionText = JSON.parse(InflationDescriptionText);
                                }
                                // Check if JSON contains an error message
                                // Check if there is an error in InflationDescriptionText
                                if (InflationDescriptionText?.Error) {
                                    const errorKey = InflationDescriptionText?.Error || "unknown_error"; // Fallback key if Error is undefined
                                    const errorData = errorMessagesForUrlProcessing[errorKey] || {
                                        title: () => getI18n("error_occurred"), // ✅ Dynamic translation for title
                                        html: () => getI18n("generic_error_message") + "<br><br>" + errorKey // ✅ Fallback: Show generic message + error key
                                    };

                                    Swal.fire({
                                        icon: 'error',
                                        title: errorData.title(), // ✅ Always call as a function
                                        html: errorData.html(),
                                    });

                                    unmakeAndRestoreSubmitButton();
                                    return; // Exit the function early
                                }
                                let { cn, jt, jd } = InflationDescriptionText;
                                // Ensure values are valid
                                cn = cn && cn.trim() !== "" ? cn.trim() : null;
                                jt = jt && jt.trim() !== "" ? jt.trim() : null;
                                jd = jd && jd.trim() !== "" ? jd.trim() : null;

                                // Determine short description priority: cn + jt > jd
                                shortDescription = "";
                                if (cn && jt) {
                                    shortDescription = `${cn} - ${jt}`;
                                } else if (jd) {
                                    shortDescription = jd;
                                } else {
                                    shortDescription = "No description available";
                                }
                                // Ensure the short description is exactly 40 characters
                                shortDescription = shortDescription.length > 40 ? shortDescription.substring(0, 40) : shortDescription.padEnd(40, " ");
                            } catch (error) {
                                console.error('⚠️ Error parsing JSON:', error);
                            }
                        }
                        //console.log('Prompt is:', prompt);

                        // add ddata
                        var data = {};
                        if (thisEditor.data != null) { //This is in setData()
                            for (var key in thisEditor.data) {
                                if (thisEditor.data.hasOwnProperty(key)) {
                                    var value = thisEditor.data[key];
                                    data[key] = value; // Store additional data in an object

                                }
                            }
                        }
                        const coverletter = 'true';
                        const encodedShortDescription = deflateAndEncode(shortDescription);
                        const fileUploadPath = utilsEvents.getUseThisFilePath();
                        const useThisFile = 'false';
                        console.log('Short Description is:', encodedShortDescription);
                        const compressedPrompt = pako.deflate(JSON.stringify({ textfromchatgptbox, description, shortDescription, userLocale, coverletter, fileUploadPath, ...data }), { to: 'uint8array' }); // Use 'uint8array'
                        $.ajax({
                            url: getApiUrl('resume-csrf-token', 'r3'),
                            type: 'POST',
                            timeout: 110000,
                            async: true,
                            success: function (csrfTokenResponse) {
                                const csrfToken = csrfTokenResponse.csrfToken;
                                // console.log('CSRF Token received:', csrfToken);

                                // Store the token in session storage
                                sessionStorage.setItem('csrfToken', csrfToken);
                                // console.log('CSRF Token stored in sessionStorage');

                                // Retrieve CSRF token from sessionStorage
                                const storedCsrfToken = sessionStorage.getItem('csrfToken');
                                // console.log('Retrieved CSRF Token from sessionStorage:', storedCsrfToken);

                                if (!storedCsrfToken) {
                                    console.warn('CSRF token not found in sessionStorage');
                                    thisEditor.unmask();
                                    Swal.fire({
                                        title: getI18n('error_job'),
                                        text: getI18n('csrf_token_not_found'),
                                        icon: "error",
                                    });
                                    return;
                                }

                                // Send the compressed request to generate the resume
                                $.ajax({
                                    url: getApiUrl('generate-resume', 'r3'),
                                    type: 'POST',
                                    timeout: 110000,
                                    headers: {
                                        'X-CSRF-Token': storedCsrfToken,
                                        ...thisEditor.header // Include any additional headers
                                    },
                                    processData: false,
                                    contentType: 'application/octet-stream',
                                    data: compressedPrompt,
                                    success: function (response) {
                                        const compressedResume = response.compressed_resume;
                                        const compressedDescripton = response.compressed_description;
                                        // console.log('Compressed description data:', compressedDescripton);


                                        // Send compressed data to createresume endpoint without decompression
                                        $.ajax({
                                            url: getApiUrl('createcoverletter', 'loginapi'),
                                            type: 'POST',
                                            timeout: 110000,
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'X-CSRF-Token': storedCsrfToken,
                                            },
                                            data: JSON.stringify({
                                                coverLetterData: compressedResume, vendor: vendor, folderUUID: folderUUID, hostname: hostname, description: compressedDescripton, shortDescription: encodedShortDescription,
                                                locale: getLanguage(), type: 'coverletter', useThisFile: useThisFile, email: email
                                            }), // Send compressed data directly
                                            success: function (finalResponse) {
                                                console.log(`AJAX request took ${performance.now() - startTime} milliseconds`); // Log duration
                                                console.log('final response:', finalResponse);
                                                const message = finalResponse.message;
                                                const url = finalResponse.filePath;
                                                if (url) {
                                                    console.log("Adding to the file events: ", finalResponse.filePath);
                                                    setLocalStorageItem(`resumeUrl-${folderUUID}`, url);
                                                    createUpdateFilesEvents.addFile({
                                                        message: finalResponse.message,
                                                        fileName: finalResponse.fileName,
                                                        filePath: finalResponse.filePath,
                                                        lastUpdated: finalResponse.lastUpdated,
                                                        size: finalResponse.size,
                                                        shortDescription: shortDescription,
                                                        inflatedDescription: description,
                                                        locale: userLocale,
                                                        type: finalResponse.type,
                                                        metadatafilelink: finalResponse.metadatafilelink,
                                                        useThisFile: finalResponse.useThisFile,
                                                    });
                                                    setCustomTimeout(() => {
                                                        thisEditor.unmask();
                                                        console.log('Final file path is:', finalResponse.filePath);
                                                        setLoginRedirect(1000);
                                                        navigate(finalResponse.filePath);
                                                        setLoginRedirectIntervalWithTimeout();
                                                    }, 200);

                                                }
                                            },
                                            error: function (error) {
                                                unmakeAndRestoreSubmitButton();
                                                Swal.fire({
                                                    title: getI18n('error_job'),
                                                    html: getI18n('error_occured_completing'),
                                                    icon: "error",
                                                });
                                                console.error('Error in createResume request:', error);
                                            }
                                        });
                                    },
                                    error: function (error) {
                                        unmakeAndRestoreSubmitButton();
                                        Swal.fire({
                                            title: getI18n('error_job'),
                                            html: getI18n('error_occured_completing'),
                                            icon: "error",
                                        });
                                        console.error('Error in generate-resume request:', error);
                                    }
                                });
                            },
                            error: function (error) {
                                unmakeAndRestoreSubmitButton();
                                Swal.fire({
                                    title: getI18n('error_job'),
                                    html: getI18n('error_occured_completing'),
                                    icon: "error",
                                });
                                console.error('Error while fetching CSRF token:', error);
                            }
                        });

                    }, timeoutForCallDueToCloudFrontDelays);
                } catch (error) {
                    unmakeAndRestoreSubmitButton();
                    console.error("Error in getting Permissions:", error);
                    Swal.fire({
                        title: getI18n('error_job'),
                        text: getI18n('permissions_error'),
                        icon: "error",
                    });
                }
            }
        } else {
            setCustomTimeout(() => {
                thisEditor.showLoginPopup(false, false, false, false, false, generateCoverLetterVerificationSuccess);
            }, 50);
        }
    },

    checkUserPlanAndUsageAndProceed: async function () {
        const proceed = await subscriptionMiscModule.checkUserPlanAndUsage();
        if (!proceed) {
            unmakeAndRestoreSubmitButton();
            return false;
        }
        return true;
    },

    doGenerateResume: async function () {

        const proceed = await thisEditor.checkUserPlanAndUsageAndProceed();
        if (!proceed) {
            return;
        }

        console.log("Generating Resume");
        const fileUploadPath = utilsEvents.getUseThisFilePath();
        let generateSummaryAndExperience = 'true';
        if (fileUploadPath) {
            Swal.fire({
                title: "Rephrase Experience?",
                text: "Would you like to rephrase the experience from the attached resume or keep it as is?",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Rephrase",
                cancelButtonText: "Keep As-Is",
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    console.log("User chose to update the existing experience and summary.");
                    generateSummaryAndExperience = 'true';
                    thisEditor.doGenerateResumeExecute(generateSummaryAndExperience);
                    // Add your function to rephrase here
                } else {
                    console.log("User chose to use the existing experience and summary.");
                    generateSummaryAndExperience = 'false';
                    thisEditor.doGenerateResumeExecute(generateSummaryAndExperience);
                    // Add your function to keep as is here
                }
            });
        } else {
            // for (let i = 0; i < 10; i++) {
            //     console.log(`Executing attempt ${i + 1}`);
            //     thisEditor.doGenerateResumeExecute(generateSummaryAndExperience);
            //     await new Promise(resolve => setTimeout(resolve, 2000)); // 1-second delay
            // }
            thisEditor.doGenerateResumeExecute('true');
        }
    },

    fetchJobPage: async function (url) {
        try {
            console.log("🌐 Fetching CSRF Token...");

            // Step 1: Get CSRF Token
            const csrfTokenResponse = await $.ajax({
                url: getApiUrl('generatecsrftoken', 'sqssender'),
                type: 'POST',
                timeout: 30000, // 30 seconds
            });

            console.log("csrfTokenResponse", csrfTokenResponse);

            if (!csrfTokenResponse || !csrfTokenResponse.csrfToken) {
                console.warn("⚠️ CSRF token response invalid or empty.");
                Swal.fire({
                    title: getI18n('error_job'),
                    text: getI18n('csrf_token_not_found'),
                    icon: "error",
                });
                return null;
            }

            const csrfToken = csrfTokenResponse.csrfToken;
            sessionStorage.setItem('csrfToken', csrfToken);
            console.log("✅ CSRF Token:", csrfToken);

            // Step 2: Retrieve CSRF token from sessionStorage
            const storedCsrfToken = sessionStorage.getItem('csrfToken');
            if (!storedCsrfToken) {
                console.warn('⚠️ CSRF token not found in sessionStorage');
                Swal.fire({
                    title: getI18n('error_job'),
                    text: getI18n('csrf_token_not_found'),
                    icon: "error",
                });
                return null;
            }

            console.log("📨 Sending notification to SQS...");
            const messageId = crypto.randomUUID();

            // Step 3: Send Notification to SQS
            const finalResponse = await $.ajax({
                url: getApiUrl('sendNotification', 'sqssender'),
                type: 'POST',
                timeout: 95000,
                headers: {
                    'X-CSRF-Token': storedCsrfToken,
                },
                contentType: 'application/json',
                data: JSON.stringify({ messageId: messageId, content: url }),
            });

            if (finalResponse && finalResponse.text) {
                return finalResponse.text;
            } else {
                console.warn("⚠️ No valid text received.");
                Swal.fire({
                    title: getI18n('error_job'),
                    text: getI18n('error_invalid_response'),
                    icon: "error",
                });
                return null;
            }
        } catch (error) {
            console.error("❌ Error in fetchJobPage:", error);

            if (error.status === 503) {
                Swal.fire({
                    title: getI18n('url_server_busy_title'),
                    html: getI18n('unableToRetrieveJobDescription') +
                        '<br><br>' +
                        getI18n('copyPasteJobDescription') +
                        '<br><br><span id="show-more-examples" class="link-style">' +
                        getI18n('whereToFindJobPosting') + '</span>',
                    icon: "error",
                });
            } else {
                Swal.fire({
                    title: getI18n('error_job'),
                    html: getI18n('unableToRetrieveJobDescription') +
                        '<br><br>' +
                        getI18n('copyPasteJobDescription') +
                        '<br><br><span id="show-more-examples" class="link-style">' +
                        getI18n('whereToFindJobPosting') + '</span>',
                    icon: "error",
                });
            }

            return null;
        }
    },



    doGenerateResumeExecute: async function (generateSummaryAndExperience) { //Yes, if user choose to generate summary and experience instead of getting from the attached resume
        if (isUserLoggedIn()) {

            const proceed = await thisEditor.checkUserPlanAndUsageAndProceed();
            if (!proceed) {
                return;
            }


            const { email, vendor, folderId } = getVendorAndEmailFromCookies();
            const folderUUID = folderId;
            const hostname = window.location.hostname;
            let timeoutForCallDueToCloudFrontDelays = 90;
            const userLocale = getLanguage();

            // Compress the prompt using pako.deflate
            let textfromchatgptbox = $('#chatgptbox').val().trim();
            let description = textfromchatgptbox;
            let shortDescription = description.length > 40 ? description.substring(0, 40) : description;

            // const resumePathIfExists = createUpdateFilesEvents.searchInflatedDescription(description, userLocale, getI18n('resume_prefix'));
            const resumePathIfExists = false;
            if (resumePathIfExists) {
                console.log('Resume Already Exists')
                navigate(resumePathIfExists);
            } else {
                try {
                    await getSignedCookies(folderUUID, vendor, hostname);

                    setCustomTimeout(async function () {
                        const startTime = performance.now();
                        thisEditor.mask(getI18n('creating_resume'));

                        let InflationDescriptionText = null;

                        const urlToGenerateFromText = getUrlFromText(textfromchatgptbox);
                        if (urlToGenerateFromText) {
                            const descriptionText = await thisEditor.fetchJobPage(urlToGenerateFromText);
                            if (descriptionText === null) {
                                unmakeAndRestoreSubmitButton();
                                console.warn('⚠️ No description retrieved, exiting function.');
                                return;
                            }
                            InflationDescriptionText = decodeAndInflate(descriptionText);
                            //here replace the url with the description text in textfromchatgptbox
                            textfromchatgptbox = textfromchatgptbox.replace(urlToGenerateFromText, InflationDescriptionText);
                            description = InflationDescriptionText;
                            console.log('📄 textfromchatgptbox:', textfromchatgptbox);
                            try {
                                // If it's a string, parse it into JSON
                                if (typeof InflationDescriptionText === "string") {
                                    InflationDescriptionText = JSON.parse(InflationDescriptionText);
                                }
                                // Check if JSON contains an error message
                                // Check if there is an error in InflationDescriptionText
                                if (InflationDescriptionText?.Error) {
                                    const errorKey = InflationDescriptionText?.Error || "unknown_error"; // Fallback key if Error is undefined
                                    const errorData = errorMessagesForUrlProcessing[errorKey] || {
                                        title: () => getI18n("error_occurred"), // ✅ Dynamic translation for title
                                        html: () => getI18n("generic_error_message") + "<br><br>" + errorKey // ✅ Fallback: Show generic message + error key
                                    };

                                    Swal.fire({
                                        icon: 'error',
                                        title: errorData.title(), // ✅ Always call as a function
                                        html: errorData.html(),
                                    });

                                    unmakeAndRestoreSubmitButton();
                                    return; // Exit the function early
                                }
                                let { cn, jt, jd } = InflationDescriptionText;
                                // Ensure values are valid
                                cn = cn && cn.trim() !== "" ? cn.trim() : null;
                                jt = jt && jt.trim() !== "" ? jt.trim() : null;
                                jd = jd && jd.trim() !== "" ? jd.trim() : null;

                                // Determine short description priority: cn + jt > jd
                                shortDescription = "";
                                if (cn && jt) {
                                    shortDescription = `${cn} - ${jt}`;
                                } else if (jd) {
                                    shortDescription = jd;
                                } else {
                                    shortDescription = "No description available";
                                }
                                // Ensure the short description is exactly 40 characters
                                shortDescription = shortDescription.length > 40 ? shortDescription.substring(0, 40) : shortDescription.padEnd(40, " ");
                            } catch (error) {
                                console.error('⚠️ Error parsing JSON:', error);
                            }
                        }
                        //console.log('Prompt is:', prompt);

                        // add ddata
                        var data = {};
                        if (thisEditor.data != null) { //This is in setData() test is in the setData()
                            for (var key in thisEditor.data) {
                                if (thisEditor.data.hasOwnProperty(key)) {
                                    var value = thisEditor.data[key];
                                    data[key] = value; // Store additional data in an object

                                }
                            }
                        }
                        const coverletter = 'false';
                        const encodedShortDescription = deflateAndEncode(shortDescription);
                        const fileUploadPath = utilsEvents.getUseThisFilePath();
                        const useThisFile = 'false';
                        let copyExperienceAndOtherFromFilePath = '';
                        console.log('fileUploadPath', fileUploadPath);
                        if (fileUploadPath && fileUploadPath.includes('usertemplates/') && fileUploadPath.endsWith('.html')) {
                            console.log('fileUploadPath', fileUploadPath);
                            console.log('generateSummaryAndExperience', generateSummaryAndExperience);
                            if (generateSummaryAndExperience === 'false')
                                copyExperienceAndOtherFromFilePath = fileUploadPath; //This is to generate all experience and others from the exising resume
                            else
                                copyExperienceAndOtherFromFilePath = '';
                        }

                        const compressedPrompt = pako.deflate(JSON.stringify({ textfromchatgptbox, description, shortDescription, userLocale, coverletter, fileUploadPath, generateSummaryAndExperience, ...data }), { to: 'uint8array' }); // Use 'uint8array'
                        $.ajax({
                            url: getApiUrl('resume-csrf-token', 'r3'),
                            type: 'POST',
                            timeout: 110000,
                            async: true,
                            success: function (csrfTokenResponse) {
                                const csrfToken = csrfTokenResponse.csrfToken;
                                // console.log('CSRF Token received:', csrfToken);

                                // Store the token in session storage
                                sessionStorage.setItem('csrfToken', csrfToken);
                                // console.log('CSRF Token stored in sessionStorage');

                                // Retrieve CSRF token from sessionStorage
                                const storedCsrfToken = sessionStorage.getItem('csrfToken');
                                // console.log('Retrieved CSRF Token from sessionStorage:', storedCsrfToken);

                                if (!storedCsrfToken) {
                                    console.warn('CSRF token not found in sessionStorage');
                                    thisEditor.unmask();
                                    Swal.fire({
                                        title: getI18n('error_job'),
                                        text: getI18n('csrf_token_not_found'),
                                        icon: "error",
                                    });
                                    return;
                                }

                                // Send the compressed request to generate the resume
                                $.ajax({
                                    url: getApiUrl('generate-resume', 'r3'), //this is node.js call
                                    type: 'POST',
                                    timeout: 110000,
                                    headers: {
                                        'X-CSRF-Token': storedCsrfToken,
                                        ...thisEditor.header // Include any additional headers
                                    },
                                    processData: false,
                                    contentType: 'application/octet-stream',
                                    data: compressedPrompt,
                                    success: function (response) {
                                        const compressedResume = response.compressed_resume;
                                        const compressedDescripton = response.compressed_description;
                                        // console.log('Compressed description data:', compressedDescripton);


                                        // Send compressed data to createresume endpoint without decompression
                                        $.ajax({
                                            url: getApiUrl('createresume', 'loginapi'),
                                            type: 'POST',
                                            timeout: 110000,
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'X-CSRF-Token': storedCsrfToken,
                                            },
                                            data: JSON.stringify({
                                                resumeData: compressedResume, vendor: vendor, folderUUID: folderUUID, hostname: hostname, description: compressedDescripton,
                                                shortDescription: encodedShortDescription, locale: userLocale, type: 'resume', useThisFile: useThisFile, copyExperienceAndOtherFromFilePath, email: email
                                            }), // Send compressed data directly
                                            success: function (finalResponse) {
                                                console.log(`AJAX request took ${performance.now() - startTime} milliseconds`); // Log duration
                                                console.log('final response:', finalResponse);
                                                const message = finalResponse.message;
                                                const url = finalResponse.filePath;
                                                if (url) {
                                                    setLocalStorageItem(`resumeUrl-${folderUUID}`, url);
                                                    createUpdateFilesEvents.addFile({
                                                        message: finalResponse.message,
                                                        fileName: finalResponse.fileName,
                                                        filePath: finalResponse.filePath,
                                                        lastUpdated: finalResponse.lastUpdated,
                                                        size: finalResponse.size,
                                                        shortDescription: shortDescription,
                                                        inflatedDescription: description,
                                                        locale: userLocale,
                                                        type: finalResponse.type,
                                                        metadatafilelink: finalResponse.metadatafilelink,
                                                        useThisFile: finalResponse.useThisFile,

                                                    });
                                                    setCustomTimeout(() => {
                                                        thisEditor.unmask();
                                                        setLoginRedirect(1000);
                                                        navigate(finalResponse.filePath);
                                                        setLoginRedirectIntervalWithTimeout();

                                                    }, 200);

                                                }
                                            },
                                            error: function (error) {
                                                unmakeAndRestoreSubmitButton();
                                                Swal.fire({
                                                    title: getI18n('error_job'),
                                                    html: getI18n('error_occured_completing'),
                                                    icon: "error",
                                                });
                                                console.error('Error in createResume request:', error);
                                            }
                                        });
                                    },
                                    error: function (error) {
                                        unmakeAndRestoreSubmitButton();
                                        Swal.fire({
                                            title: getI18n('error_job'),
                                            html: getI18n('error_occured_completing'),
                                            icon: "error",
                                        });
                                        console.error('Error in generate-resume request:', error);
                                    }
                                });
                            },
                            error: function (error) {
                                unmakeAndRestoreSubmitButton();
                                Swal.fire({
                                    title: getI18n('error_job'),
                                    html: getI18n('error_occured_completing'),
                                    icon: "error",
                                });
                                console.error('Error while fetching CSRF token:', error);
                            }
                        });

                    }, timeoutForCallDueToCloudFrontDelays);
                } catch (error) {
                    unmakeAndRestoreSubmitButton();
                    console.error("Error in getting Permissions:", error);
                    Swal.fire({
                        title: getI18n('error_job'),
                        text: getI18n('permissions_error'),
                        icon: "error",
                    });
                }
            }
        } else {
            setCustomTimeout(() => {
                thisEditor.showLoginPopup(false, false, false, false, false, generateResumeVerificationSuccess);
            }, 50);
        }
    },


    renameFileToCloud: async function () {
        if (currentFileName) {
            const folderUUID = getFolderIdFromCookies();
            const vendor = getVendorFromCookies();
            renameAsEvents.init(folderUUID, vendor, currentFileName.replace('.html', ''));
        }

    },
    doSaveAsToCloud: async function () {
        if (currentFileName) {
            thisEditor.saveToServer = false;
            thisEditor.tinymce[0].isDirty(false);
            thisEditor.tinymce[0].saveLocallyIndexedDB(); //override SaveToServer
            const folderUUID = getFolderIdFromCookies();
            const vendor = getVendorFromCookies();
            saveAsEvents.init(folderUUID, vendor, currentFileName.replace('.html', ''), thisEditor.doSaveAsCloudCallback);
        }
    },

    doSaveAsCloudCallback: async function (newFileName, hideAndUnload) {

        const file = getFileData(currentFileName);
        if (!file) return;

        console.log('filename in save is:', currentFileName);

        // before save events
        thisEditor.runBeforeSaveEvents();

        // cleanup content before save
        thisEditor.cleanUpContent();
        //    thisEditor.additionalCleanupBeforeSave(); //remove the stylesheet references before save
        // save saveAchor
        thisEditor.saveAchor = thisEditor.currentRecordAchor;

        // get save content
        var content = await thisEditor.getContentForSave();
        const vendor = getVendorFromCookies();
        const folderUUID = getFolderIdFromCookies();
        const hostname = window.location.hostname;
        const userLocale = getLanguage();

        try {
            thisEditor.mask(getI18n('saving'));

            // add ddata
            var data = {};
            if (thisEditor.data != null) {
                for (var key in thisEditor.data) {
                    if (thisEditor.data.hasOwnProperty(key)) {
                        var value = thisEditor.data[key];
                        data[key] = value; // Store additional data in an object

                    }
                }
            }
            const inflatedDescription = file.inflatedDescription;
            const shortDescription = file.shortDescription;
            const encodedShortDescription = deflateAndEncode(file.shortDescription);
            const compressedDescripton = deflateAndEncode(inflatedDescription);
            const fileType = file.type;
            const useThisFile = file.useThisFile;
            const fileName = newFileName;

            // Send compressed data to createresume endpoint without decompression
            $.ajax({
                url: getApiUrl('saveAsObject', 'loginapi'),
                type: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify({
                    content: deflateAndEncode(content), vendor: vendor, folderUUID: folderUUID, hostname: hostname, description: compressedDescripton,
                    shortDescription: encodedShortDescription, locale: userLocale, type: fileType, fileName: fileName, useThisFile: useThisFile
                }), // Send compressed data directly
                success: function (finalResponse) {
                    console.log("[File] File Saved AS to Cloud:", fileName);
                    const message = finalResponse.message;
                    const url = finalResponse.filePath;
                    if (url) {
                        console.log("Adding to the file events: ", finalResponse.filePath);
                        setLocalStorageItem(`resumeUrl-${folderUUID}`, url);
                        createUpdateFilesEvents.addFile({
                            message: finalResponse.message,
                            fileName: finalResponse.fileName,
                            filePath: finalResponse.filePath,
                            lastUpdated: finalResponse.lastUpdated,
                            size: finalResponse.size,
                            shortDescription: shortDescription,
                            inflatedDescription: inflatedDescription,
                            locale: userLocale,
                            type: finalResponse.type,
                            metadatafilelink: finalResponse.metadatafilelink,
                            useThisFile: finalResponse.useThisFile,
                        });
                        thisEditor.unmask();
                        hideAndUnload();
                        // Show success message
                        Swal.fire({
                            title: getI18n('success'),
                            text: getI18n('file_saveas_successfully'),
                            icon: "success",
                        }).then((result) => {
                            if (result.isConfirmed || result.isDismissed) {  // Ensure it runs after the popup closes
                                //  unloadCallBack();
                                // Navigate to the updated file path
                                navigate(finalResponse.filePath);
                            }
                        });
                    }
                },
                error: function (error) {
                    thisEditor.unmask();
                    hideModalBackDrop();
                    hideAndUnload();
                    Swal.fire({
                        title: getI18n('error_job'),
                        html: getI18n('error_occured_saving'),
                        icon: "error",
                    });
                    console.error('Error in Saving request:', error);
                }
            });

        } catch (error) {
            thisEditor.unmask();
            hideAndUnload();
            console.error("Error in getting Permissions:", error);
        }

    },

    doGenerateFromTemplate: async function () {

        const proceed = await thisEditor.checkUserPlanAndUsageAndProceed();
        if (!proceed) {
            return;
        }

        console.log('Generating from Template');
        // before save events
        thisEditor.runBeforeSaveEvents();

        // cleanup content before save
        thisEditor.cleanUpContent();
        //    thisEditor.additionalCleanupBeforeSave(); //remove the stylesheet references before save
        // save saveAchor
        thisEditor.saveAchor = thisEditor.currentRecordAchor;

        // get save content
        var content = await thisEditor.getContentForSave();
        const vendor = getVendorFromCookies();
        const folderUUID = getFolderIdFromCookies();
        const hostname = window.location.hostname;
        const userLocale = getLanguage();

        try {
            thisEditor.mask(getI18n('generating_editable_version'));

            // add ddata
            var data = {};
            if (thisEditor.data != null) {
                for (var key in thisEditor.data) {
                    if (thisEditor.data.hasOwnProperty(key)) {
                        var value = thisEditor.data[key];
                        data[key] = value; // Store additional data in an object

                    }
                }
            }

            const fileName = thisEditor.url.split('/').pop();
            const inflatedDescription = getI18n('template.desc') + ' ' + fileName;
            const shortDescription = inflatedDescription.length > 40 ? inflatedDescription.substring(0, 40) : inflatedDescription;
            const encodedShortDescription = deflateAndEncode(shortDescription);
            const compressedDescripton = deflateAndEncode(inflatedDescription);
            const type = window.location.href.includes('/resume') ? 'resume' : 'coverletter';
            const fileType = type;
            const useThisFile = 'false';

            // Send compressed data to createresume endpoint without decompression
            $.ajax({
                url: getApiUrl('createResumeOrCoverLetterFromTemplate', 'loginapi'),
                type: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify({
                    content: deflateAndEncode(content), vendor: vendor, folderUUID: folderUUID, hostname: hostname, description: compressedDescripton,
                    shortDescription: encodedShortDescription, locale: userLocale, type: fileType, fileName: fileName, useThisFile: useThisFile
                }), // Send compressed data directly
                success: function (finalResponse) {
                    console.log("[File] File Created from te:", fileName);
                    const message = finalResponse.message;
                    const url = finalResponse.filePath;
                    if (url) {
                        console.log("Adding to the file events: ", finalResponse.filePath);
                        setLocalStorageItem(`resumeUrl-${folderUUID}`, url);
                        createUpdateFilesEvents.addFile({
                            message: finalResponse.message,
                            fileName: finalResponse.fileName,
                            filePath: finalResponse.filePath,
                            lastUpdated: finalResponse.lastUpdated,
                            size: finalResponse.size,
                            shortDescription: shortDescription,
                            inflatedDescription: inflatedDescription,
                            locale: userLocale,
                            type: finalResponse.type,
                            metadatafilelink: finalResponse.metadatafilelink,
                            useThisFile: finalResponse.useThisFile,

                        });
                        thisEditor.unmask();
                        setLoginRedirect(1000);
                        navigate(finalResponse.filePath);
                    }
                },
                error: function (error) {
                    thisEditor.unmask();
                    hideModalBackDrop();
                    Swal.fire({
                        title: getI18n('error_job'),
                        html: getI18n('error_generating_file'),
                        icon: "error",
                    });
                    console.error('Error in Generating Editable File request:', error);
                }
            });

        } catch (error) {
            thisEditor.unmask();

            console.error("Error in getting Permissions:", error);
        }

    },


    saveBeforeNavigate: async function () {
        if (!thisEditor.runCustom && isUserLoggedIn() && currentFileName && thisEditor.saveListener &&
            ((thisEditor.tinymce && thisEditor.tinymce[0] && thisEditor.tinymce[0].isDirty()))) {

            if (saveIntervalID) clearInterval(saveIntervalID);
            thisEditor.tinymce[0].isDirty(false);

            await thisEditor.tinymce[0].saveLocallyIndexedDB();

        }
    },

    saveLocalAndCloud: async function (restartInterval = false, callback) {
        if (!thisEditor.saveToServer) return;
        if (saveIntervalID) clearInterval(saveIntervalID);
        thisEditor.tinymce[0].isDirty(false);
        try {
            await thisEditor.tinymce[0].saveLocallyIndexedDB();
            await thisEditor.doSaveToCloud(restartInterval, callback); //if restart interval it means mask is true
        } catch (error) {
            console.error("Error in saveLocalAndCloudBeforeNavigate:", error);
        } finally {
            if (restartInterval && !thisEditor.readOnlyMode) {
                saveIntervalID = setInterval(() => {
                    thisEditor.tinymce[0].saveLocallyIndexedDB();
                }, 12000);
                console.log("Auto-save interval restarted.");
            }
        }
    },

    doSaveToCloud: async function (mask = true, callback) {
        if (!thisEditor.saveToServer) return;
        document.getElementById("save-design").classList.add("disabled");
        if (isUserLoggedIn()) {
            const file = getFileData(currentFileName);
            if (!file) return;
            // before save events
            thisEditor.runBeforeSaveEvents();

            // cleanup content before save
            thisEditor.cleanUpContent();
            //    thisEditor.additionalCleanupBeforeSave(); //remove the stylesheet references before save
            // save saveAchor
            thisEditor.saveAchor = thisEditor.currentRecordAchor;

            // get save content
            var content = await thisEditor.getContentForSave();
            const vendor = getVendorFromCookies();
            const folderUUID = getFolderIdFromCookies();
            const hostname = window.location.hostname;
            const userLocale = getLanguage();

            try {
                if (mask) {
                    thisEditor.mask(getI18n('saving'));
                }

                // add ddata
                var data = {};
                if (thisEditor.data != null) {
                    for (var key in thisEditor.data) {
                        if (thisEditor.data.hasOwnProperty(key)) {
                            var value = thisEditor.data[key];
                            data[key] = value; // Store additional data in an object

                        }
                    }
                }

                const encodedShortDescription = deflateAndEncode(file.shortDescription);
                const compressedDescripton = deflateAndEncode(file.inflatedDescription);
                const fileType = file.type;
                const metadatafilelink = file.metadatafilelink;
                const useThisFile = file.useThisFile;
                const fileName = file.fileName;

                // Send compressed data to createresume endpoint without decompression
                $.ajax({
                    url: getApiUrl('updateResumeOrCoverLetter', 'loginapi'),
                    type: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: JSON.stringify({
                        content: deflateAndEncode(content), vendor: vendor, folderUUID: folderUUID, hostname: hostname, description: compressedDescripton,
                        shortDescription: encodedShortDescription, locale: userLocale, type: fileType, fileName: fileName, useThisFile: useThisFile, metadatafilelink: metadatafilelink
                    }), // Send compressed data directly
                    success: function () {
                        thisEditor.saveToServer = false;
                        console.log("[File] File Saved to Cloud:", fileName);
                        if (mask) {
                            thisEditor.unmask();
                            thisEditor.notificationArea(getI18n('filesaved'));
                        }
                        if (typeof callback === "function") {
                            callback(); // Call the callback after user clicks "OK"
                        }
                    },
                    error: function (error, callback) {
                        unmakeAndRestoreSubmitButton();
                        Swal.fire({
                            title: getI18n('error_job'),
                            html: getI18n('error_occured_saving'),
                            icon: "error",
                        }).then(() => {
                            if (typeof callback === "function") {
                                callback(); // Call the callback after user clicks "OK"
                            }
                        });

                        console.error('Error in Saving request:', error);
                    }
                });

            } catch (error) {
                console.error("Error in getting Permissions:", error);
            }
        } else {
            if (typeof callback === "function") {
                callback(); // Call the callback after user clicks "OK"
            }
        }
    },

    generatePdfPreview: function () {
        if (isIOS()) {
            if (supportsPDFsOnMobile()) {
                //This mobile device should support PDFs
                thisEditor.doPreviewPdf();
            } else {
                //This iOS device (iPad/iPhone) might not support inline PDF viewing. You may want to trigger a download or open the PDF in a new tab.
                thisEditor.doExportPdf(true);
            }
        } else {
            //This is a desktop browser or non-iOS mobile device. PDF viewing should be supported.
            thisEditor.doPreviewPdf();
        }
    },

    doPreviewPdf: async function () {
        var thisEditor = this;

        // before save events
        thisEditor.runBeforeSaveEvents();

        // cleanup content before save
        thisEditor.cleanUpContent();

        if (typeof window.getDragAndDropIsEnabled === "function" && window.getDragAndDropIsEnabled()) {
            if (typeof window.externalCleanupDragState === "function") {
                // Wait for 100ms after calling the cleanup function
                window.externalCleanupDragState();
                thisEditor.tinymce[0].nodeChanged();
                await new Promise(resolve => setTimeout(resolve, 500));

            }
        }

        var content = '';
        content = await thisEditor.getContent();

        // Regular expression to match <script> tags with the specific identifier and their content
        var scriptTagRegex = /<script\b[^>]*data-identifier="pdf-remove-this"[^>]*>[\s\S]*?<\/script>/gi;

        // Replace the matched <script> blocks with an empty string


        const replacementLinks = `
            ${constants.GREEN_LEFT_TEMPLATE_CSS_LINK}
            ${constants.FONT_AWESOME_CSS_LINK}
            ${constants.FONT_AWESOME_STYLE_CSS_LINK}
            ${constants.FONT_AWESOME_STYLE_FREE_CSS_LINK}
        `;

        content = content.replace(scriptTagRegex, replacementLinks);

        // Replace the `#signature-canvas-top` div for cover letter
        content = content.replace(
            /<div id="signature-canvas-top">/g,
            '<div id="signature-canvas-top" style="display: none;">'
        );

        // Replace the `#signature-image` div
        content = content.replace(
            /<div id="signature-image" style="display: none;">/g,
            '<div id="signature-image">'
        );

        // Replace `.signature-container` div
        content = content.replace(
            /<div class="signature-container" style="margin-top: 10px;">/g,
            '<div class="signature-container">'
        );


        if (window.location.hostname.includes("sqlldap.com") || window.location.hostname.includes("localhost")) {
            content = content.replaceAll('<link href="/dist', '<link href="https://www.sqlldap.com/dist');
            content = content.replaceAll('<link rel="stylesheet" href="/dist', '<link rel="stylesheet" href="https://www.sqlldap.com/dist');

        } else {
            content = content.replaceAll('<link href="/dist', '<link href="https://www.resumeinminutes.com/dist');
            content = content.replaceAll('<link rel="stylesheet" href="/dist', '<link rel="stylesheet" href="https://www.resumeinminutes.com/dist');
        }


        // console.log ('content', content);

        // Prepare additional data
        var data = {};
        if (thisEditor.data != null) {
            for (var key in thisEditor.data) {
                if (thisEditor.data.hasOwnProperty(key)) {
                    var value = thisEditor.data[key];
                    data[key] = value; // Store additional data in an object
                }
            }
        }

        // Get the footer template and margins
        try {
            const footerTemplate = window.PDFConfigModule.generateFooterTemplate();
            const headerTemplate = window.PDFConfigModule.generateHeaderTemplate();
            const pageSize = window.PDFConfigModule.getPageSize();
            const marginBottom = window.PDFConfigModule.getBottomMargins();

            // console.log ('marginBottom', marginBottom);

            // Add footer and margins to the data payload
            data.footerTemplate = footerTemplate;
            data.headerTemplate = headerTemplate;
            data.pageSize = pageSize;
            data.marginBottom = marginBottom;
        } catch (error) {
            console.error('Error retrieving footer template or margins:', error);
        }

        // Compress the content and additional data
        const compressedData = pako.deflate(JSON.stringify({ content, ...data }), { to: 'uint8array' }); // Use 'uint8array'

        $('#exportForm').remove();
        var form = $(`
            <form id="exportForm" style="display:none" action="` + getApiUrl('pdf', 'api') + `" method="POST" target="_blank">
                <textarea name="content"></textarea>
            </form>`
        ).appendTo('body');

        // No need to set compressed data in the form, we're sending it directly
        thisEditor.mask(getI18n('generating_preview'));

        setCustomTimeout(function () {
            const startTime = performance.now(); // Record the start time

            // First, call to generate CSRF token and store it in session storage
            $.ajax({
                url: getApiUrl('csrf-token', 'api'),
                type: 'POST',
                success: function (response) {
                    const csrfToken = response.csrfToken; // Extract the CSRF token from the response
                    sessionStorage.setItem('csrfToken', csrfToken); // Store the token in session storage

                    // Proceed with the original PDF generation request
                    const storedCsrfToken = sessionStorage.getItem('csrfToken'); // Get the CSRF token from session storage

                    if (!storedCsrfToken) {
                        // If the CSRF token is not found, display an error
                        thisEditor.unmask();
                        Swal.fire({
                            title: getI18n('error_job'),
                            text: getI18n('csrf_token_not_found'),
                            icon: "error",
                        });
                        return;
                    }

                    // Now proceed to send the request to generate the PDF
                    $.ajax({
                        url: getApiUrl('pdf', 'api'),
                        type: 'POST',
                        headers: {
                            'X-CSRF-Token': storedCsrfToken, // Include the CSRF token in headers
                            ...thisEditor.header // Spread any additional headers
                        },
                        xhrFields: {
                            responseType: 'blob' // to avoid binary data being mangled on charset conversion
                        },
                        contentType: 'application/octet-stream', // Set the content type for compressed data
                        data: compressedData, // Send compressed data directly
                        processData: false, // Prevent jQuery from processing the data
                        success: function (data) {
                            thisEditor.unmask();
                            console.log(`AJAX request took ${performance.now() - startTime} milliseconds`); // Log duration
                            var blob = new Blob([data], { type: 'application/pdf' });
                            var pdfURL = window.URL.createObjectURL(blob);
                            var pdfURLCustom = pdfURL + "#zoom=100&toolbar=0&navpanes=0";
                            thisEditor.displayPDFInDiv(pdfURLCustom);
                            thisEditor.unmask();
                            thisEditor.showPreview('desktop');
                        },
                    }).fail(async function (jqXHR) {
                        thisEditor.unmask();
                        let title = getI18n('error_job');
                        let errorMessage = getI18n('unexpected_error'); // Default message for unexpected errors

                        // Check if the response is OK
                        if (!jqXHR.status || jqXHR.status < 200 || jqXHR.status >= 300) {
                            try {
                                if (jqXHR.status === 401) { // Unauthorized
                                    errorMessage = getI18n('unauthorized_access');
                                } else if (jqXHR.status === 403) { // Forbidden
                                    title = getI18n('forbidden_access');
                                    errorMessage = getI18n('validation_error');
                                } else if (jqXHR.status === 429) { // Too Many Requests
                                    title = getI18n('too_many_requests');
                                    errorMessage = getI18n('too_many_requests_message');
                                } else if (jqXHR.status === 404) { // Not found
                                    title = getI18n('not_found');
                                    errorMessage = getI18n('resource_not_found');
                                } else if (jqXHR.status >= 500) {
                                    errorMessage = getI18n('internal_server_error');
                                } else if (jqXHR.status >= 400) {
                                    errorMessage = getI18n('client_error');
                                }
                            } catch (err) {
                                console.error('Failed to read error response:', err);
                            }
                        }

                        Swal.fire({
                            title: title,
                            text: errorMessage,
                            icon: "error", // dnl: do not translate
                        });
                    });
                },
                error: function (jqXHR) {
                    thisEditor.unmask();
                    Swal.fire({
                        title: getI18n('error_job'),
                        text: getI18n('unable_to_generate_csrf'),
                        icon: "error", // dnl: do not translate
                    });
                }
            });

        }, 10);
    },
    doExportPdf: async function (exportforpreview = false) {
        var thisEditor = this;

        // before save events
        thisEditor.runBeforeSaveEvents();

        // cleanup content before save
        thisEditor.cleanUpContent();

        var content = '';
        content = await thisEditor.getContent();

        // Regular expression to match <script> tags with the specific identifier and their content
        var scriptTagRegex = /<script\b[^>]*data-identifier="pdf-remove-this"[^>]*>[\s\S]*?<\/script>/gi;

        // Replace the matched <script> blocks with an empty string


        const replacementLinks = `
            ${constants.GREEN_LEFT_TEMPLATE_CSS_LINK}
            ${constants.FONT_AWESOME_CSS_LINK}
            ${constants.FONT_AWESOME_STYLE_CSS_LINK}
            ${constants.FONT_AWESOME_STYLE_FREE_CSS_LINK}
        `;

        content = content.replace(scriptTagRegex, replacementLinks);

        // Replace the `#signature-canvas-top` div for cover letter
        content = content.replace(
            /<div id="signature-canvas-top">/g,
            '<div id="signature-canvas-top" style="display: none;">'
        );

        // Replace the `#signature-image` div
        content = content.replace(
            /<div id="signature-image" style="display: none;">/g,
            '<div id="signature-image">'
        );

        // Replace `.signature-container` div
        content = content.replace(
            /<div class="signature-container" style="margin-top: 10px;">/g,
            '<div class="signature-container">'
        );



        if (window.location.hostname.includes("sqlldap.com") || window.location.hostname.includes("localhost")) {
            content = content.replaceAll('<link href="/dist', '<link href="https://www.sqlldap.com/dist');
            content = content.replaceAll('<link rel="stylesheet" href="/dist', '<link rel="stylesheet" href="https://www.sqlldap.com/dist');

        } else {
            content = content.replaceAll('<link href="/dist', '<link href="https://www.resumeinminutes.com/dist');
            content = content.replaceAll('<link rel="stylesheet" href="/dist', '<link rel="stylesheet" href="https://www.resumeinminutes.com/dist');
        }

        // Prepare additional data
        var data = {};
        if (thisEditor.data != null) {
            for (var key in thisEditor.data) {
                if (thisEditor.data.hasOwnProperty(key)) {
                    var value = thisEditor.data[key];
                    data[key] = value; // Store additional data in an object
                }
            }
        }

        // Get the footer template and margins
        try {
            const footerTemplate = window.PDFConfigModule.generateFooterTemplate();
            const headerTemplate = window.PDFConfigModule.generateHeaderTemplate();
            const pageSize = window.PDFConfigModule.getPageSize();
            const marginBottom = window.PDFConfigModule.getBottomMargins();

            // Add footer and margins to the data payload
            data.footerTemplate = footerTemplate;
            data.headerTemplate = headerTemplate;
            data.pageSize = pageSize;
            data.marginBottom = marginBottom;
        } catch (error) {
            console.error('Error retrieving footer template or margins:', error);
        }

        // Compress the content and additional data
        const compressedData = pako.deflate(JSON.stringify({ content, ...data }), { to: 'uint8array' }); // Use 'uint8array'

        $('#exportForm').remove();
        var form = $(`
            <form id="exportForm" style="display:none" action="` + getApiUrl('pdf', 'api') + `" method="POST" target="_blank">
                <textarea name="content"></textarea>
            </form>`
        ).appendTo('body');

        // No need to set compressed data in the form, we're sending it directly
        if (exportforpreview)
            thisEditor.mask(getI18n('generating_preview'));
        else
            thisEditor.mask(getI18n('generating_pdf'));

        await thisEditor.doSaveToCloud(false);

        setCustomTimeout(function () {
            const startTime = performance.now(); // Record the start time

            // First, call to generate CSRF token and store it in session storage
            $.ajax({
                url: getApiUrl('csrf-token', 'api'),
                type: 'POST',
                success: function (response) {
                    const csrfToken = response.csrfToken; // Extract the CSRF token from the response
                    sessionStorage.setItem('csrfToken', csrfToken); // Store the token in session storage

                    // Proceed with the original PDF generation request
                    const storedCsrfToken = sessionStorage.getItem('csrfToken'); // Get the CSRF token from session storage

                    if (!storedCsrfToken) {
                        // If the CSRF token is not found, display an error
                        thisEditor.unmask();
                        Swal.fire({
                            title: getI18n('error_job'),
                            text: getI18n('csrf_token_not_found'),
                            icon: "error",
                        });
                        return;
                    }

                    // Now proceed to send the request to generate the PDF
                    $.ajax({
                        url: getApiUrl('pdf', 'api'),
                        type: 'POST',
                        headers: {
                            'X-CSRF-Token': storedCsrfToken, // Include the CSRF token in headers
                            ...thisEditor.header // Spread any additional headers
                        },
                        xhrFields: {
                            responseType: 'blob' // to avoid binary data being mangled on charset conversion
                        },
                        contentType: 'application/octet-stream', // Set the content type for compressed data
                        data: compressedData, // Send compressed data directly
                        processData: false, // Prevent jQuery from processing the data
                        success: function (data) {
                            thisEditor.unmask();
                            console.log(`AJAX request took ${performance.now() - startTime} milliseconds`); // Log duration
                            var blob = new Blob([data], { type: 'application/pdf' });
                            var blobURL = window.URL.createObjectURL(blob);
                            var link = document.createElement('a');
                            link.href = blobURL;
                            link.download = "resume.pdf";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            setCustomTimeout(() => {
                                window.URL.revokeObjectURL(blobURL);
                            }, 1000); // Give some time before revoking
                            blob = null;
                            data = null;


                        },
                    }).fail(async function (jqXHR) {
                        thisEditor.unmask();
                        let title = getI18n('error_job');
                        let errorMessage = getI18n('unexpected_error'); // Default message for unexpected errors

                        // Check if the response is OK
                        if (!jqXHR.status || jqXHR.status < 200 || jqXHR.status >= 300) {
                            try {
                                if (jqXHR.status === 401) { // Unauthorized
                                    errorMessage = getI18n('unauthorized_access');
                                } else if (jqXHR.status === 403) { // Forbidden
                                    title = getI18n('forbidden_access');
                                    errorMessage = getI18n('validation_error');
                                } else if (jqXHR.status === 429) { // Too Many Requests
                                    title = getI18n('too_many_requests');
                                    errorMessage = getI18n('too_many_requests_message');
                                } else if (jqXHR.status === 404) { // Not found
                                    title = getI18n('not_found');
                                    errorMessage = getI18n('resource_not_found');
                                } else if (jqXHR.status >= 500) {
                                    errorMessage = getI18n('internal_server_error');
                                } else if (jqXHR.status >= 400) {
                                    errorMessage = getI18n('client_error');
                                }
                            } catch (err) {
                                console.error('Failed to read error response:', err);
                            }
                        }

                        Swal.fire({
                            title: title,
                            text: errorMessage,
                            icon: "error", // dnl: do not translate
                        });
                    });
                },
                error: function (jqXHR) {
                    thisEditor.unmask();
                    Swal.fire({
                        title: getI18n('error_job'),
                        text: getI18n('unable_to_generate_csrf'),
                        icon: "error", // dnl: do not translate
                    });
                }
            });

        }, 10);
    },

    goback: function () {
        thisEditor.showLoginPopup();
    },

    loadEvents: function (htmlpages) {

        //IMPORTANT to add events you have to be discrete like $('a.preview-design-desktop')
        //to check for events add console.log(e.target); after this line  $('*:not(.menu-bar)').click(function (e) {



        var thisEditor = this;



        // $(document).on('click', 'a.bodytheme', function (t) {
        //     console.log('a.bodytheme clicked');
        //     const data = $(this).attr('data').split("|");
        //     $('.splide_a').removeClass('splide_is_active');
        //     $('.splide_a').removeClass('th_active_color');
        //     $('.fonttheme').removeClass('th_active_color');
        //     const className = data[0];
        //     const colorName = data[1];
        //     thisEditor.unselect();
        //     thisEditor.hideControls();
        //     thisEditor.updateTheme(className, colorName);
        // });





        // $('a.fonttheme').click(function (t) {
        //     t.stopImmediatePropagation();
        //     const fontSize = $(this).attr('data');
        //     $('.splide_a').removeClass('splide_is_active');
        //     $('.splide_a').removeClass('th_active_color');
        //     thisEditor.unselect();
        //     thisEditor.hideControls();
        //     thisEditor.updateThemeForFontSize(fontSize);
        // });





        $('#left-collapsable-templates-button').click(function (t) {
            if ($('#image-carousel-div').hasClass('left-collapsable-templates-light-visibledesktopnotvisiblemobile')) {
                $('#image-carousel-div').removeClass('left-collapsable-templates-light-visibledesktopnotvisiblemobile').addClass('left-collapsable-templates-light-notvisibledesktopbutvisiblemobile');
            } else {
                $('#image-carousel-div').removeClass('left-collapsable-templates-light-notvisibledesktopbutvisiblemobile').addClass('left-collapsable-templates-light-visibledesktopnotvisiblemobile');
            }
            thisEditor.changeNavText("#image-carousel-div", "#changethememl-text");
            thisEditor.changeNavText("#image-carousel-div", "#changetheme-text");
            thisEditor.changeNavText("#image-carousel-div", "#changethememl-menu-text");
        });



        $('#goback').click(function (t) {
            t.stopImmediatePropagation();
            thisEditor.showLoginPopup();
        });

        $('#rightdrawer-logout').click(async function (t) {
            t.stopImmediatePropagation();
            if ($('#rightdrawer').hasClass('open')) {
                console.log("Closing drawer in rightdrawer-logout");
                closeRightDrawer();
            }
            thisEditor.logout();

        });


        $('#rightdrawer-subscriptions').click(async function (t) {
            t.stopImmediatePropagation();
            const button = this;
            const stripeStatus = button.getAttribute('data-stripe-status') || 'free';

            if (stripeStatus === 'free') {
                navigate('/pricing');
                return;
            }
            if ($('#rightdrawer').hasClass('open')) {
                const spinner = document.getElementById('rightDrawerSpinner');
                if (spinner) {
                    spinner.style.display = 'flex';
                }
                await paymentDialog.startPayment(t, spinner);
                setGuaranteedTimeoutIndexHtml(() => {
                    closeRightDrawer();
                }, 300);

            }
        });





        $('#rightdrawer-page-setup').click(function (t) {
            t.preventDefault();
            closeRightDrawer();

            console.log('Page Setup Called');
            t.stopImmediatePropagation();
            window.PDFConfigModule.init();  // Initialize the module
            window.PDFConfigModule.openModal();  // Open the modal


        });

        $('#rightdrawer-open-browsefiles').click(function (t) {
            t.preventDefault();
            t.stopImmediatePropagation();
            closeRightDrawer();
            if (isUserLoggedIn())
                window.recaptchaVerification.recaptchaVerificationInit(openBrowseVerificationSuccess, getEmailPrefixWithVendorFromCookies());
            else {
                thisEditor.showLoginPopup(false, false, false, false, false, openBrowseVerificationSuccess,
                    function (data) { window.recaptchaVerification.recaptchaVerificationInit(openBrowseVerificationSuccess, getEmailPrefixWithVendorFromCookies()); }
                );
            }
        });


        $(document).on('click', '#changethemeclass, #changethememl, #mobile-styleIt', function (t) {
            t.stopImmediatePropagation();
            (async () => {
                if ($('#change-theme-tooltip').is(':visible')) {
                    $('#change-theme-tooltip').remove(); // Remove the tooltip
                    setLocalStorageItem('themeTooltipClosed', 'true'); // Set the flag in localStorage
                }
            })();

            if (!desktop)
                slidersetup.init(initHistoryState?.slidesfilter || null, thisEditor, null, thisEditor.iframe[0].contentWindow.document);

            thisEditor.changetheme();


        });

        $(document).on('click', '#hamburgermenu', function (e) {
            resumePageEvents.openSidebar();

        });





        $(document).on('click', '#signupform-button', function (t) {
            t.stopImmediatePropagation();
            console.log('Registration called');
            thisEditor.register();
        });

        $(document).on('click', '#resetpassword-button', function (t) {
            t.stopImmediatePropagation();
            console.log('Reset Password called');
            thisEditor.requestPasswordReset();
        });

        $(document).on('click', '#recreatepasswordform-button', function (t) {
            t.stopImmediatePropagation();
            console.log('Recreate Password called on document click');
            thisEditor.resetPassword();
        });


        $(document).on('click', '#new-sign-up', function (t) {
            t.stopImmediatePropagation();
            console.log('new-sign-up called');
            thisEditor.showLoginPopup(true, false, false);
            // $("#login-container").hide();
            // $("#sign-up-container").show();
        });

        $(document).on('click', '#forgot-password', function (t) {
            t.stopImmediatePropagation();
            console.log('Forgot Password Called');
            thisEditor.showLoginPopup(false, true, false);
            // $("#login-container").hide();
            // $("#sign-up-container").show();
        });

        $(document).on('click', '#resumeFromJobPosting', async function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            if ($('#dropdown-menu')) $('#dropdown-menu').hide();
            navigate(`/${getLanguage()}/generate-resume-from-job-posting`);
        });

        $(document).on('click', '#resumeFromCustomCriteria', async function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            if ($('#dropdown-menu')) $('#dropdown-menu').hide();
            navigate(`/${getLanguage()}/generate-resume-from-text`);
        });

        $(document).on('click', '#generateCoverLetter', async function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            if ($('#dropdown-menu')) $('#dropdown-menu').hide();
            navigate(`/${getLanguage()}/generate-coverletter`);
        });

        $(document).on('click', '#atsChecker', async function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            if ($('#dropdown-menu')) $('#dropdown-menu').hide();
            navigate(`/${getLanguage()}/resume-ats-checker`);
        });



        $(document).on('click', '#gotoHomePage', async function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            if ($('#dropdown-menu')) $('#dropdown-menu').hide();
            navigate(`/${getLanguage()}`);
        });

        $(document).on('click', '#contactusPage', async function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            if ($('#dropdown-menu')) $('#dropdown-menu').hide();
            navigate(`/${getLanguage()}/contactus`);
        });


        $(document).on('click', '#pricingPage, #pricingbtn', async function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            if ($('#dropdown-menu')) $('#dropdown-menu').hide();
            navigate(`/${getLanguage()}/pricing`);
        });







        $(document).on('click', '#resumetemplatelink', async function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            if ($('#dropdown-menu')) $('#dropdown-menu').hide();
            navigate(`/${getLanguage()}/resume/templates/${thisEditor.language}/template.html`);
        });

        $(document).on('click', '#coverlettertemplatelink', async function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            if ($('#dropdown-menu')) $('#dropdown-menu').hide();
            navigate(`/${getLanguage()}/coverletter/templates/${thisEditor.language}/coverletter.html`);
        });

        $(document).on('click', '#myresumes, #show-my-resumes', async function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            if ($('#dropdown-menu')) $('#dropdown-menu').hide();
            if (isUserLoggedIn()) {
                const folderUUID = getFolderIdFromCookies();
                const vendor = getVendorFromCookies();
                await fetchAndStoreDataOnLogin(folderUUID, vendor, false, false);
                window.browseFileEvents.init(folderUUID, vendor);  // Initialize the module
            }
            else {
                thisEditor.showLoginPopup(false, false, false, false, false, openBrowseVerificationSuccess,
                    function (data) { window.recaptchaVerification.recaptchaVerificationInit(openBrowseVerificationSuccess, getEmailPrefixWithVendorFromCookies()); }
                );
            }
        });

        // Click event handler without try-catch
        $(document).on('click', '#refresh-my-resumes', async function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            if ($('#refresh-my-resumes')) $('#refresh-my-resumes').hide();
            const folderUUID = getFolderIdFromCookies();
            const vendor = getVendorFromCookies();
            if ($('#resume-loadingSpinner')) $('#resume-loadingSpinner').show();

            await fetchAndStoreDataOnLogin(folderUUID, vendor, true, false)
                .then(() => {
                    setRefreshedCookie();
                    leftsidebarpopulate.init();
                    // Set the 'refreshed' cookie with value 'true' for 5 minutes
                })
                .catch((error) => {
                    if ($('#refresh-my-resumes')) $('#refresh-my-resumes').show();
                    Swal.fire({
                        title: getI18n('oops_something_wrong'),
                        text: getI18n('error_while_refreshing'),
                        icon: "error",
                    });
                })
                .finally(() => {
                    if ($('#resume-loadingSpinner')) $('#resume-loadingSpinner').hide();
                });
        });


        $(document).on('click', '#chatgptbox-icon-left', async function (t) {
            t.preventDefault();
            t.stopImmediatePropagation();
            closeRightDrawer();
            if (isUserLoggedIn())
                window.recaptchaVerification.recaptchaVerificationInit(openFileUploadVerificationSuccess, getEmailPrefixWithVendorFromCookies());
            else {
                thisEditor.showLoginPopup(false, false, false, false, false, openFileUploadVerificationSuccess,
                    function (data) { window.recaptchaVerification.recaptchaVerificationInit(openFileUploadVerificationSuccess, getEmailPrefixWithVendorFromCookies()); }
                );
            }
        });

        $(document).on('click', '#chatgptbox-icon-second-left', async function (t) {
            t.preventDefault();
            t.stopImmediatePropagation();
            closeRightDrawer();
            if (isUserLoggedIn())
                window.recaptchaVerification.recaptchaVerificationInit(openLinkedInVerificationSuccess, getEmailPrefixWithVendorFromCookies());
            else {
                thisEditor.showLoginPopup(false, false, false, false, false, openLinkedInVerificationSuccess,
                    function (data) { window.recaptchaVerification.recaptchaVerificationInit(openLinkedInVerificationSuccess, getEmailPrefixWithVendorFromCookies()); }
                );
            }
        });


        // Click event handler without try-catch
        $(document).on('click', '#browse-refreshBtn, #mobile-browse-refreshBtn', async function (t) {
            console.log('#browse-refreshBtn', 'browser refresh button is clicked');
            t.stopImmediatePropagation();
            t.preventDefault();
            if ($('#refresh-my-resumes')) $('#refresh-my-resumes').hide();
            if ($('#browse-refreshBtn')) $('#browse-refreshBtn').hide();
            if ($('#mobile-browse-refreshBtn')) $('#mobile-browse-refreshBtn').hide();
            if ($('#browse-loadingSpinner')) $('#browse-loadingSpinner').show();
            const folderUUID = getFolderIdFromCookies();
            const vendor = getVendorFromCookies();
            if ($('#resume-loadingSpinner')) $('#resume-loadingSpinner').show();

            await fetchAndStoreDataOnLogin(folderUUID, vendor, true, false)
                .then(() => {
                    setRefreshedCookie();
                    leftsidebarpopulate.init();
                    browseFileEvents.refreshFileTable();
                    // Set the 'refreshed' cookie with value 'true' for 5 minutes
                })
                .catch((error) => {
                    console.error("Error Refreshing:", error);
                    if ($('#refresh-my-resumes')) $('#refresh-my-resumes').show();
                    if ($('#browse-refreshBtn')) $('#browse-refreshBtn').show();
                    if ($('#mobile-browse-refreshBtn')) $('#mobile-browse-refreshBtn').show();
                    Swal.fire({
                        title: getI18n('oops_something_wrong'),
                        text: getI18n('error_while_refreshing'),
                        icon: "error",
                    });
                })
                .finally(() => {
                    if ($('#resume-loadingSpinner')) $('#resume-loadingSpinner').hide();
                    if ($('#browse-loadingSpinner')) $('#browse-loadingSpinner').hide();
                });
        });





        $(document).on('click', '#recent-resume', function (t) {
            t.stopImmediatePropagation();
            console.log('resume link Called');
            navigate(getRecentResumeUrl());
        });







        $(document).on('click', '#log-in-link', function (t) {
            t.stopImmediatePropagation();
            thisEditor.goback();
        });





        $(document).on('click', '#toggle-password, #toggle-new-password, #toggle-confirm-password', function (t) {
            t.stopImmediatePropagation();
            var $passwordInput = $($(this).data('target'));  // Selects the specific input based on data-target attribute
            //console.log('Password input target:', $passwordInput);  // Debugging

            var currentType = $passwordInput.attr('type');
            var newType = currentType === 'password' ? 'text' : 'password';

            //console.log('Current type:', currentType, 'New type:', newType);  // Debugging

            $passwordInput.attr('type', newType);  // Toggle the type attribute
            $(this).text(newType === 'password' ? getI18n('show') : getI18n('hide'));  // Update the label text
        });


        $(document).on('click', '.pr-desktop', function () {
            thisEditor.showPreview('desktop');
        });

        $(document).on('click', '.pr-mobile', function () {
            thisEditor.showPreview('mobile');
        });

        //js modal preview design builder desktop
        $(document).on('click', '.close-preview', function () {
            thisEditor.closePreview();
        });

        //js modal preview design builder desktop
        $(document).on('click', '.close-modal', function () {
            thisEditor.closePreview();
        });

        $(document).on('click', '.click-active-preview', function () {
            $('.click-active-preview').removeClass('active-preview');
            $(this).addClass('active-preview');
        });

        $('#btnClone').click(function () {
            thisEditor.duplicate();	// selected.clone()
        });


        $(document).on('click', '#page-setup', function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            window.PDFConfigModule.init();  // Initialize the module
            window.PDFConfigModule.openModal();  // Open the modal

        });

        $(document).on('click', '#save-as-design', function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            if (isUserLoggedIn())
                window.recaptchaVerification.recaptchaVerificationInit(saveAsVerificationSuccess, getEmailPrefixWithVendorFromCookies());
            else {
                thisEditor.showLoginPopup(false, false, false, false, false, saveAsVerificationSuccess,
                    function (data) { window.recaptchaVerification.recaptchaVerificationInit(saveAsVerificationSuccess, getEmailPrefixWithVendorFromCookies()); }
                );
            }

        });

        $(document).on('click', '#renamefile-menu', function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            if (isUserLoggedIn())
                window.recaptchaVerification.recaptchaVerificationInit(renameVerificationSuccess, getEmailPrefixWithVendorFromCookies());
            else {
                thisEditor.showLoginPopup(false, false, false, false, false, renameVerificationSuccess,
                    function (data) { window.recaptchaVerification.recaptchaVerificationInit(renameVerificationSuccess, getEmailPrefixWithVendorFromCookies()); }
                );
            }

        });


        $(document).on('click', '#open-browsefiles, #rightdrawer-open-browsefiles', function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            if (isUserLoggedIn())
                window.recaptchaVerification.recaptchaVerificationInit(openBrowseVerificationSuccess, getEmailPrefixWithVendorFromCookies());
            else {
                thisEditor.showLoginPopup(false, false, false, false, false, openBrowseVerificationSuccess,
                    function (data) { window.recaptchaVerification.recaptchaVerificationInit(openBrowseVerificationSuccess, getEmailPrefixWithVendorFromCookies()); }
                );
            }
        });

        $(document).on('click', '#pdfexportbuttonright, #pdfDownload-footer, .pdf-download-menu', function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            if (isUserLoggedIn())
                window.recaptchaVerification.recaptchaVerificationInit(pdfExportVerificationSuccess, getEmailPrefixWithVendorFromCookies());
            else {
                thisEditor.showLoginPopup(false, false, false, false, false, pdfExportVerificationSuccess,
                    function (data) { window.recaptchaVerification.recaptchaVerificationInit(pdfExportVerificationSuccess, getEmailPrefixWithVendorFromCookies()); }
                );
            }
        });

        $(document).on('click', '#save-design', function (t) {

            t.stopImmediatePropagation();
            t.preventDefault();
            if (isUserLoggedIn())
                window.recaptchaVerification.recaptchaVerificationInit(saveVerificationSuccess, getEmailPrefixWithVendorFromCookies());
            else {
                thisEditor.showLoginPopup(false, false, false, false, false, saveVerificationSuccess,
                    function (data) { window.recaptchaVerification.recaptchaVerificationInit(saveVerificationSuccess, getEmailPrefixWithVendorFromCookies()); }
                );
            }
        });


        $(document).on('click', '#save-as-design', function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            if (isUserLoggedIn())
                window.recaptchaVerification.recaptchaVerificationInit(saveAsVerificationSuccess, getEmailPrefixWithVendorFromCookies());
            else {
                thisEditor.showLoginPopup(false, false, false, false, false, saveAsVerificationSuccess,
                    function (data) { window.recaptchaVerification.recaptchaVerificationInit(saveAsVerificationSuccess, getEmailPrefixWithVendorFromCookies()); }
                );
            }
        });


        $(document).on('click', '#renamefile-menu', function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            if (isUserLoggedIn())
                window.recaptchaVerification.recaptchaVerificationInit(renameVerificationSuccess, getEmailPrefixWithVendorFromCookies());
            else {
                thisEditor.showLoginPopup(false, false, false, false, false, renameVerificationSuccess,
                    function (data) { window.recaptchaVerification.recaptchaVerificationInit(renameVerificationSuccess, getEmailPrefixWithVendorFromCookies()); }
                );
            }
        });

        $(document).on('click', '.chatgptbox-submit', async function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            const $button = $(this);
            const action = $button.data('action');
            let actionToTrigger = generateResumeVerificationSuccess;

            $('#generateresume-arrowimage').hide(); // Hide the arrow
            $('#generateresume-circlespinner').show(); // Show the spinner
            $('.chatgptbox-submit').prop('disabled', true); // Disable the button

            // Disable the button to prevent double clicks
            thisEditor.setChatBoxValueInLocalStorage();





            if (action && action === 'generate-coverletter') {
                actionToTrigger = generateCoverLetterVerificationSuccess;

            }

            if (isUserLoggedIn())
                window.recaptchaVerification.recaptchaVerificationInit(actionToTrigger, getEmailPrefixWithVendorFromCookies(), unmakeAndRestoreSubmitButton);
            else {
                thisEditor.showLoginPopup(false, false, false, false, false, actionToTrigger,
                    function (data) { window.recaptchaVerification.recaptchaVerificationInit(actionToTrigger, getEmailPrefixWithVendorFromCookies(), unmakeAndRestoreSubmitButton); }
                );
            }
        });

        $(document).on('click', '#proPlanCard, #starterPlanCard', function (event) {
            console.log('clicked on pro or started plan');
            event.preventDefault();
            event.stopImmediatePropagation();

            const clickedCardId = this.id; // 'starterPlanCard' or 'proPlanCard'
            const spinnerId = clickedCardId === 'starterPlanCard' ? 'starterPlanSpinner' : 'proPlanSpinner';
            const spinner = document.getElementById(spinnerId);
            if (spinner) {
                spinner.style.display = 'flex';
            }
            if (isUserLoggedIn()) {
                paymentDialog.startPayment(event, spinner);
            } else {
                if (spinner) spinner.style.display = 'none';
                thisEditor.showLoginPopup(
                    false, false, false, false, false,
                    checkoutPreviewDirectSuccess,
                    () => paymentDialog.startPayment(event)
                );
            }
        });




        //js click button preview design desktop
        $(document).on('click', '.preview-design-desktop,.preview-menu', function (t) {
            t.stopImmediatePropagation();
            if (isUserLoggedIn())
                window.recaptchaVerification.recaptchaVerificationInit(pdfPreviewVerificationSuccess, getEmailPrefixWithVendorFromCookies());
            else {
                thisEditor.showLoginPopup(false, false, false, false, false, pdfPreviewVerificationSuccess,
                    function (data) { window.recaptchaVerification.recaptchaVerificationInit(pdfPreviewVerificationSuccess, getEmailPrefixWithVendorFromCookies()); }
                );
            }
        });


        $('#account').on('click', function (t) {
            t.stopImmediatePropagation();
            thisEditor.showLoginPopup();
        });



        $('#account-loggedin, .close-drawer, #loggedin-right, .loggedin-right-class').on('click', function (t) {
            t.stopPropagation();
            toggleDrawer();

        });

        $('.donot-close-drawer').click(function (e) {
            e.stopPropagation(); // Prevent clicks inside the drawer from closing it
        });



        $('#resume-dark-mode').click(function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            $('html').toggleClass('dark-theme');
            let isDarkMode = $('html').hasClass('dark-theme');
            localStorage.setItem('dark-mode', isDarkMode);
            setLightDarkModeForEditor();
            adjustDarkLightModeButton();
        });


        $('#rightdrawer').click(function (e) {
            e.stopPropagation(); // Prevent clicks inside the drawer from closing it
        });


        $('#login-right').on('click', function (t) {
            t.stopImmediatePropagation();
            thisEditor.showLoginPopup();
        });

        $('#signup-right').on('click', function (t) {
            t.stopImmediatePropagation();
            thisEditor.showLoginPopup(true, false, false);
        });

        $('#wordexportbuttonright').on('click', function (t) {
            t.preventDefault();
            t.stopImmediatePropagation();
            thisEditor.doExportWord();
        });

        $('#savebuttonright').on('click', function (t) {
            t.stopImmediatePropagation();
            t.preventDefault();
            if (isUserLoggedIn())
                window.recaptchaVerification.recaptchaVerificationInit(saveVerificationSuccess, getEmailPrefixWithVendorFromCookies());
            else {
                thisEditor.showLoginPopup(false, false, false, false, false, saveVerificationSuccess,
                    function (data) { window.recaptchaVerification.recaptchaVerificationInit(saveVerificationSuccess, getEmailPrefixWithVendorFromCookies()); }
                );
            }
        });

        // $('#previewbuttonright').on('click', function (t) {
        //     if (isMobileOrTablet()) {
        //         if (supportsPDFsOnMobile()) {
        //             console.log('This mobile device should support PDFs.');
        //             t.stopImmediatePropagation();
        //             console.time('Preview PDF Execution Time');
        //             thisEditor.doPreviewPdf();
        //             console.timeEnd('Preview PDF Execution Time');
        //             thisEditor.showPreview('desktop');
        //         } else {
        //             console.log('This iOS device might not support inline PDF viewing. You may want to trigger a download or open the PDF in a new tab.');
        //             doExportPdf();
        //         }
        //     } else {
        //         //desktop browser
        //         t.stopImmediatePropagation();
        //         console.time('Preview PDF Execution Time');
        //         thisEditor.doPreviewPdf();
        //         console.timeEnd('Preview PDF Execution Time');
        //         thisEditor.showPreview('desktop');

        //     }

        //     t.stopImmediatePropagation();
        //     console.time('Preview PDF Execution Time');
        //     thisEditor.doPreviewPdf();
        //     console.timeEnd('Preview PDF Execution Time');
        //     thisEditor.showPreview('desktop');
        // });



        $(document).on("click", ".menu-bar-action.btn-export-word", function (t) {
            t.preventDefault();
            thisEditor.doExportWord();
        });

        $(document).on('click', 'a.save-design, .bp-save', function (e) {
            e.preventDefault();
            thisEditor.saveLocalAndCloud(true);
        });




        $(document).on('click', '.myfiles-footer', function (t) {
            t.preventDefault();
            t.stopImmediatePropagation();
            closeRightDrawer();
            if (isUserLoggedIn())
                window.recaptchaVerification.recaptchaVerificationInit(openBrowseVerificationSuccess, getEmailPrefixWithVendorFromCookies());
            else {
                thisEditor.showLoginPopup(false, false, false, false, false, openBrowseVerificationSuccess,
                    function (data) { window.recaptchaVerification.recaptchaVerificationInit(openBrowseVerificationSuccess, getEmailPrefixWithVendorFromCookies()); }
                );
            }
        });


        $(document).on('click', '.pdfSetup-footer', function (t) {
            t.preventDefault();
            closeRightDrawer();

            console.log('Page Setup Called');
            t.stopImmediatePropagation();
            window.PDFConfigModule.init();  // Initialize the module
            window.PDFConfigModule.openModal();  // Open the modal

        });



        $(document).on('click', '.menu-bar-action.btn-save-and-close', function (e) {
            e.preventDefault();

            thisEditor.save(function () {
                // check if builder has backCallback
                if (typeof (thisEditor.backCallback) !== 'undefined') {
                    thisEditor.backCallback();
                } else {
                    window.location.href = thisEditor.urlBack;
                }
            });
        });


        $(document).on('keydown', '#signupform-button, #recreatepasswordform-button, #resetpassword-button, #loginform-button', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault(); // Prevent scrolling when space is pressed
                $(this).click();
            }
        });




        //js click button preview design mobile
        $(document).on('click', '.preview-design-mobile', function () {
            thisEditor.showPreview('mobile');
        });

        //click button show on design
        $(document).on('click', '.view-mode-design', function () {
            thisEditor.viewDesign();
            return false;
        });

        //click button show on source
        $(document).on('click', '.view-mode-source, .bp-view-source', function () {
            thisEditor.viewSource();
            return false;
        });

        //js click change template
        $(document).on('click', '.hover-name-template', function (e) {
            e.preventDefault();

            var template_url = $(this).attr('template-url');
            thisEditor.changeTemplate(template_url);
        });

        //js click change template
        $(document).on('click', '.new-from-template-select', function (e) {
            e.preventDefault();

            var template_url = $(this).attr('href');
            thisEditor.changeTemplate(template_url);
        });

        $(document).on('click', 'img.img-template', function (e) {
            e.preventDefault();

            var template_url = $(this).attr('template-url');
            thisEditor.changeTemplate(template_url);
        });

        //js nut back in builder
        $(document).on('click', 'a.back', function (e) {
            e.preventDefault();

            thisEditor.back();
        });

        // click on close button in top menu bar
        $(document).on('click', '.menu-bar-action.btn-close, .bp-exit', function (e) {
            e.preventDefault();

            thisEditor.back();
        });

        //
        $(document).on('click', '.builder-duplicate-selected-button, .bp-duplicate', function () {
            console.log('duplice  button clicked');
            thisEditor.duplicate();
        });



        //
        $(document).on('click', '.builder-remove-selected-button', function () {
            thisEditor.remove();
        });

        $(document).on('click', '#htmlDemoClose', function () {
            const modal = document.getElementById('htmlDemoModal');
            modal.style.display = 'none';
        });






        $(document).on('click', '#show-more-examples', function (e) {
            e.stopImmediatePropagation();
            console.log('#show-more-examples clicked');
            const modal = document.getElementById('htmlDemoModal');
            const modalBody = document.getElementById('htmlDemoModalBody');
            const content = document.getElementById('more-examples');

            // Attach content to modal
            if (content) {
                modalBody.innerHTML = content.innerHTML;
            }
            // Display the modal
            if (modal.style.display !== 'flex') {
                modal.style.display = 'flex';
            }

        });

        $(document).on('click', '#show-more-criteria', function (e) {
            e.stopImmediatePropagation();

            const modal = document.getElementById('htmlDemoModal');
            const modalBody = document.getElementById('htmlDemoModalBody');
            const content = document.getElementById('more-criteria');

            // Attach content to modal
            if (content) {
                modalBody.innerHTML = content.innerHTML;
            }
            // Display the modal
            if (modal.style.display !== 'flex') {
                modal.style.display = 'flex';
            }

        });


        //click button hide on desktop
        $('#builder_sidebar').on('click', '.desktop', function () {
            thisEditor.hideOnDesktop();
        });

        //click button hide on mobile
        $('#builder_sidebar').on('click', '.mobile', function () {
            thisEditor.hideOnMobile();
        });

        //click button hide on desktop and mobile
        $('#builder_sidebar').on('click', '.icon-remove-two-screen', function () {
            thisEditor.removeHideOnTowScreen();
        });

        $('.chonfont').click(function () {
            $('div.language').toggleClass('bangchon');
            //$('.thongso').toggleClass('doimau');
            $('.arrows-button').toggleClass('doimau');
        });
        //hieu ung sidebar content di len
        $('.click-chon').click(function () {
            thisEditor.showControls();
        });

        $('a.move').click(function () {
            thisEditor.unselect();
            thisEditor.hideControls();

            return false;
        });



        //js click not button choose-sync
        $('*:not(.choose-sync)').click(function () {
            $('ul.action-sync').removeClass('show-action');
            return;
        });

        //js click not button choose-lang
        $('*:not(.choose-lang)').click(function () {
            $('ul.action-lang').removeClass('show-action');
            return;
        });



        //js choose template builder  debug click events by enabling console.log or uncomment
        $('*:not(.menu-bar)').click(function (e) {


            //console.log ('Target is: ', e.currentTarget);
            // console.log ('Target id is: ', e.currentTarget.id);

            if ($('.menu-bar').is(":visible") || $('.mobiletop').is(":visible")) {  //This is so that on main pages like home it's not called. UnComment this line to debug all events


                thisEditor.unselect();
                thisEditor.hideControls();




                //  console.log ('Target is: ', e.currentTarget);
                //console.log ('Target id is: ', e.currentTarget.id);




                if ($(e.target).closest('.action-preview, ul.display, .view-mode, ul.display-view-mode, .design-menu, ul.design, .action-choose-template, ul.display-template').length) {
                    $('div.template-thumbnail').hide();
                    return;
                }

                $('div.template-thumbnail').hide();


                if (
                    $('.action-choose-template').hasClass('add-background-choose') ||
                    $('ul.display-template').hasClass('display-choose-template') ||
                    $('.view-mode').hasClass('add-background-color') ||
                    $('ul.display-view-mode').hasClass('hienlen') ||
                    $('.design-menu').hasClass('add-background-design') ||
                    $('ul.design').hasClass('display-menu') ||
                    $('.preview-page').hasClass('add-background-color') ||
                    $('.preview-page').find('ul.display').hasClass('hienlen')
                ) {
                    $('.action-choose-template').removeClass('add-background-choose');
                    $('ul.display-template').removeClass('display-choose-template');
                    //remove view source
                    $('.view-mode').removeClass('add-background-color');
                    $('ul.display-view-mode').removeClass('hienlen');
                    //remove design
                    $('.design-menu').removeClass('add-background-design');
                    $('ul.design').removeClass('display-menu');

                    $('.preview-page').removeClass('add-background-color');
                    $('.preview-page').find('ul.display').removeClass('hienlen');
                    console.log('Builder hidding modal backdrop 1');
                    hideModalBackDrop();
                }

                // if (!$('#rightdrawer').hasClass('open') && !$('#resumeSidebar').hasClass('open') &&  !$('#builderModal').hasClass('show')) {
                //     console.log('hiding modal backdrop menubar');
                //     hideModalBackDrop();
                // }



                $('*:not(#account-loggedin, .close-drawer, #loggedin-right, #rightdrawer, .loggedin-right-class, .donot-close-drawer)').click(function (e) {
                    if ($('#rightdrawer').hasClass('open')) {
                        closeDrawer(e);
                    }
                });

                if ($('#resumeSidebar') && $('#resumeSidebar').hasClass('open')) {
                    resumePageEvents.handleOutsideClick(e);
                }


                if (e.currentTarget.id === 'main-logo') {
                    e.stopImmediatePropagation();
                    console.log('home link Called');
                    navigate(`/${getLanguage()}`);
                }
                else if (e.currentTarget.id === 'login-right') {
                    console.log("Called Login right");
                    e.stopImmediatePropagation();
                    thisEditor.showLoginPopup();
                }

                else if (e.currentTarget.id === 'wordexportbuttonright') {
                    e.stopImmediatePropagation();
                    thisEditor.doExportWord();
                }
                else if (e.currentTarget.id === 'savebuttonright') {
                    console.log('save button clicked menu');
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    thisEditor.saveLocalAndCloud(true);
                }
                else if (e.currentTarget.id === 'previewbuttonright') {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    thisEditor.showPreview('desktop');
                }
            }

        });


        //js nut chon design menu
        $('.design-menu').click(function () {
            $(this).toggleClass('add-background-design');


            $(this).find('ul.design').toggleClass('display-menu');

            // if ($(this).find('ul.design').hasClass('display-menu'))
            //     showModalBackDrop();

            //remove choose
            $('.action-choose-template').removeClass('add-background-choose');
            $('ul.display-template').removeClass('display-choose-template');

            //remove view source
            $('.view-mode').removeClass('add-background-color');
            $('ul.display-view-mode').removeClass('hienlen');

            //remove preview
            $('.action-preview').removeClass('add-background-color');
            $('ul.display').removeClass('hienlen');
        });

        //js nut chon action hien preview design
        $('.preview-page').click(function () {

            $(this).toggleClass('add-background-color');
            $(this).find('ul.display').toggleClass('hienlen');

            // if ($(this).find('ul.display').hasClass('hienlen'))
            //     showModalBackDrop();

            //remove choose
            $('.action-choose-template').removeClass('add-background-choose');
            $('ul.display-template').removeClass('display-choose-template');
            //remove view source
            $('.view-mode').removeClass('add-background-color');
            $('ul.display-view-mode').removeClass('hienlen');
            //remove design
            $('.design-menu').removeClass('add-background-design');
            $('ul.design').removeClass('display-menu');

        });

        //js nut chon action view mode design, source
        $('.view-mode').click(function () {
            $(this).toggleClass('add-background-color');
            $(this).find('ul.display-view-mode').toggleClass('hienlen');

            // if ($(this).find('ul.display-view-mode').hasClass('hienlen'))
            //     showModalBackDrop();

            //remove choose
            $('.action-choose-template').removeClass('add-background-choose');
            $('ul.display-template').removeClass('display-choose-template');
            //remove preview
            $('.action-preview').removeClass('add-background-color');
            $('ul.display').removeClass('hienlen');
            //remove design
            $('.design-menu').removeClass('add-background-design');
            $('ul.design').removeClass('display-menu');
        });

        //js choose template builder
        $('.action-choose-template').click(function () {
            $(this).toggleClass('add-background-choose');
            $(this).find('ul.display-template').toggleClass('display-choose-template');

            // if ($(this).find('ul.display-template').hasClass('display-choose-template'))
            //     showModalBackDrop();
            //remove preview
            $('.action-preview').removeClass('add-background-color');
            $('ul.display').removeClass('hienlen');
            //remove view source
            $('.view-mode').removeClass('add-background-color');
            $('ul.display-view-mode').removeClass('hienlen');
            //remove design
            $('.design-menu').removeClass('add-background-design');
            $('ul.design').removeClass('display-menu');

            $('div.template-thumbnail').hide();
        });

        //hover li template show image thumbnail
        $(document).on('mouseover', 'li.hover-name-template', function () {
            var thumbnail = $(this).attr('data-thumbnail');
            var url = $(this).attr('template-url');
            $('.template-thumbnail img.img-template').attr('template-url', url);
            $('.template-thumbnail img.img-template').attr('src', thumbnail);
            $('.template-thumbnail').show();
        });

        //js click action mode preview design
        $(document).on('click', 'li.device', function () {
            $('.icon-mode').css('color', 'rgb(150, 150, 150)');
            $(this).find('.icon-mode').css('color', 'white');
            $('.content-background').removeClass('mode-mobile');
            $('.content-background').removeClass('mode-tablet');
            $('.content-background').removeClass('mode-desktop');

            var mode = $(this).attr('data-mode');
            $('img.bg-image').attr('data-mode', mode);
            $('li.change-background').attr('data-mode', mode);
        });

        $(document).on('click', 'li.mode-mobile', function () {
            thisEditor.backgroundModeMobile();
        });

        $(document).on('click', 'li.box-mode-mobile', function () {
            thisEditor.backgroundModeMobile();
        });

        $(document).on('click', 'li.mode-tablet', function () {
            thisEditor.backgroundModeTablet();
        });

        $(document).on('click', 'li.box-mode-tablet', function () {
            thisEditor.backgroundModeTablet();
        });

        $(document).on('click', 'li.mode-desktop', function () {
            thisEditor.backgroundModeDesktop();
        });

        $(document).on('click', 'li.box-mode-desktop', function () {
            thisEditor.backgroundModeDesktop();
        });

        $(document).on('click', '.group-device li.device-screen', function () {
            $('.content-background').removeClass('mode-mobile-320 mode-mobile-360 mode-mobile-375 mode-mobile-414 mode-tablet-768 mode-tablet-1024 mode-desktop-1280 mode-desktop-1360 mode-desktop-1920 mode-mobile mode-tablet mode-desktop');

            if ($(this).hasClass('_320')) {
                $('.content-background').addClass('mode-mobile-320');
            } else if ($(this).hasClass('_360')) {
                $('.content-background').addClass('mode-mobile-360');
            } else if ($(this).hasClass('_375')) {
                $('.content-background').addClass('mode-mobile-375');
            } else if ($(this).hasClass('_414')) {
                $('.content-background').addClass('mode-mobile-414');
            } else if ($(this).hasClass('_768')) {
                $('.content-background').addClass('mode-tablet-768');
            } else if ($(this).hasClass('_1024')) {
                $('.content-background').addClass('mode-tablet-1024');
            } else if ($(this).hasClass('_1280')) {
                $('.content-background').addClass('mode-desktop-1280');
            } else if ($(this).hasClass('_1360')) {
                $('.content-background').addClass('mode-desktop-1360');
            } else if ($(this).hasClass('_1920')) {
                $('.content-background').addClass('mode-desktop-1920');
            }
        });

        $('span.padding-img').click(function () {
            $('.padding-img').toggleClass('hienlen');
            $('._1_minus-plus.img').toggleClass('andi');
        });

        //js click hien slide range detail img
        $(document).on('click', 'span.slider.disable', function () {
            $('input.myRanges').prop("disabled", true);
            $('label.check-disable').addClass('andi');
            $('label.check-enable').addClass('hienthi');
            $('input.color-default').addClass('color-blue');
        });

        $(document).on('click', 'span.slider.enable', function () {
            $('input.myRanges').prop("disabled", false);
            $('label.check-disable').removeClass('andi');
            $('label.check-enable').removeClass('hienthi');
            $('input.color-default').removeClass('color-blue');
        });

        //js click hien slide padding all
        $(document).on('click', 'span.slider.all-padding', function () {
            $('label.check-all-padding').addClass('andi');
            $('label.check-4-padding').addClass('hienthi');
            $('.all-padding-section').addClass('andi');
            $('.four-padding-section').addClass('hienlen');
        });

        $(document).on('click', 'span.slider._4-padding', function () {
            $('label.check-all-padding').removeClass('andi');
            $('label.check-4-padding').removeClass('hienthi');
            $('.all-padding-section').removeClass('andi');
            $('.four-padding-section').removeClass('hienlen');
        });

        //hieu ung dropdown-menu hien
        $('button.owp').click(function () {
            $('ul.down-menu').toggleClass('hienlen');
            $('.owp').toggleClass('change-background');
        });

        $('.spacing').click(function () {
            $('ul.select-down').toggleClass('hienlen');
            $('input.spacing').toggleClass('change-background');
        });

        $('._4icon').click(function () {
            $('.display-icon').toggleClass('box-icon-display');
        });

        //xu ly click thay doi trang thai active
        $(".thongso ul li span.icon-align").click(function () {
            $('span.icon-align').removeClass('active');
            $(this).addClass("active");
        });

        $("li img.icon-line-height").click(function () {
            $('.icon-line-height').removeClass('active');
            $(this).addClass("active");
        });

        $(document).on('click', 'span.dijitDialogCloseIcon', function () {
            $('.dijitDialogShow.dijitDialog').remove();
            $('.dijitDialogUnderlayWrapper').remove();
        });

        //js click nav-bar
        $(document).on('click', '#nav-home-tab', function () {
            $('.detail-content').removeClass('dilen');
            $('.tab-content').removeClass('hide-scroll-bar');

            thisEditor.unselect();
            thisEditor.hideControls();
        });

        $(document).on('click', '#nav-profile-tab, .bp-setting', function () {
            $("#builder_iframe").contents().find("[builder-element='PageElement']").click();
        });

        $(document).on('click', '#nav-contact-tab', function () {
            $('.tab-content').addClass('hide-scroll-bar');
        });

        //js action setting builder
        $(document).on('change', '#myRange', function () {
            var width = $(this).val();
            var content_builder = $('#builder_iframe').contents().find('body');
            content_builder.css('width', width);
            content_builder.css('margin', 'auto');
        });

        $(document).on('change', '#background-color', function () {
            var color = $(this).val();
            $('#text-bg-color').val(color);
            var content_body = $('#builder_iframe').contents().find('body');
            content_body.css('background-color', color);
        });

        $(document).on('change', '#content-background-color', function () {
            var color = $(this).val();
            $('#text-content-bg-color').val(color);
            var content_body = $('#builder_iframe').contents().find('body');
            var element = content_body.find('*');
            element.css('background-color', color);
        });

        $(document).on('click', 'a.font-family', function () {
            var font = $(this).attr('data-font');
            $('button.chonfont').html(font);
            var content_body = $('#builder_iframe').contents().find('body');
            content_body.css('font-family', font);
            $('.language').removeClass('bangchon');
        });

        $(document).on('change', '#link-color', function () {
            var color = $(this).val();
            $('#text-link-color').val(color);
            var content_body = $('#builder_iframe').contents().find('a');
            content_body.css('color', color);
        });

        //js action by modal change video builder
        $(document).on('click', '.action-tab', function () {
            $('.action-tab').removeClass('tab-active');
            $(this).addClass('tab-active');
            $('.tab-bg-active').removeClass('tab-bg-active');
        });

        $(document).on('click', '.video-container-modal li.tab-url', function () {
            $('.content-tab-url').show();
            $('.content-tab-upload').hide();
        });

        $(document).on('click', '.video-container-modal li.tab-upload', function () {
            $('.content-tab-url').hide();
            $('.content-tab-upload').show();
        });

        $(document).on('change', 'input.file-upload-url', function (e) {
            var fileName = e.target.files[0].name;
            $('span.des-upload-video').text(fileName);
        });

        // click new design
        $(document).on('click', '.design-new', function () {
            thisEditor.newDesign();
        });

        // click clear design
        $(document).on('click', '.design-clear', function () {
            thisEditor.clearDesign();
        });

        // click new from template
        $(document).on('click', '.design-from-template', function () {
            thisEditor.showTemplatePopup();
        });

        //copy url link image
        $(document).on('click', 'a.copy-url', function (e) {
            e.preventDefault();

            $(this).closest('.link-image').find('input.url-image')[0].select();
            document.execCommand('copy');


            thisEditor.notificationArea(getI18n('copy_url_success'));
        });


        // click undo
        $(document).on('click', '.undo-redo-action-undo, .action.undo', function () {
            thisEditor.undo();
        });

        // click redo
        $(document).on('click', '.undo-redo-action-redo, .action.redo', function () {
            thisEditor.redo();
        });


        //click help modal
        $(document).on('click', '.ask-help', function (e) {
            e.preventDefault();

            var Popup = new helpPopUp();
            var url = thisEditor.root + '../manual?v=4';
            Popup.load(url);
        });

        //click button change language
        $(document).on('click', '.choose-lang', function (e) {
            e.preventDefault();
            $('ul.action-lang').toggleClass('show-action');
        });

        //click button sync
        $(document).on('click', '.choose-sync', function (e) {
            e.preventDefault();
            $('ul.action-sync').toggleClass('show-action');
        });

        //click span action sync
        $(document).on('click', '.btn-sync', function (e) {
            e.preventDefault();
            thisEditor.saveLocalAndCloud(true);
        });

        //click action sync
        $(document).on('click', 'li.synchronization', function (e) {
            e.preventDefault();
            var sync = $(this).attr('data-title');
            thisEditor.synchronization($(this));
            thisEditor.notificationArea(getI18n('syn_with') + sync);
        });

        $(document).on('click', 'li.setting', function (e) {
            e.preventDefault();
            thisEditor.settingSync();
        });

        //load js action box right
        $(document).on('mouseover', '.box-popup-right', function () {
            $(this).addClass('box-over');
            $(this).removeClass('box-out');
        });

        $(document).on('mouseout', '.box-popup-right', function () {
            $(this).addClass('box-out');
            $(this).removeClass('box-over');
        });

        $(document).on('click', '.box-popup-right', function () {
            $('.right-box').toggleClass('show');
            $('i.icon-box').toggleClass('change-icon');
            $(this).toggleClass('distance-right');
            $('#builderModal').toggleClass('show-popup-right');

            if ($(this).hasClass('distance-right')) {
                $('.box-popup-right.distance-right').attr('title', 'Hide apps');
                $('.box-popup-right .icon').html('chevron_right');
            } else {
                $('.box-popup-right').attr('title', 'Show apps');
                $('.box-popup-right .icon').html('chevron_left');
            }

            var popup = new PopUp('', 'xright', 'right');
            popup.loadHtmlXright();
        });

        $("li#box-mode-mobile").hover(
            function () {
                $('ul.group-mobile').addClass('show');
            },
            function () {
                $('ul.group-mobile').removeClass('show');
            }
        );

        $("li#box-mode-tablet").hover(
            function () {
                $('ul.group-tablet').addClass('show');
            },
            function () {
                $('ul.group-tablet').removeClass('show');
            }
        );

        $("li#box-mode-desktop").hover(
            function () {
                $('ul.group-desktop').addClass('show');
            },
            function () {
                $('ul.group-desktop').removeClass('show');
            }
        );

        $("li#background-option").hover(
            function () {
                $('ul.group-background').addClass('show');
            },
            function () {
                $('ul.group-background').removeClass('show');
            }
        );

        $('li.box-device').hover(function () {
            $('li.box-device').removeClass('background-active');
            $(this).addClass('background-active');
        });

        $(document).on('click', 'li.box-device', function () {
            $('.box-device.active').removeClass('active');
            $(this).addClass('active');
        });

        //js change background
        $(document).on('click', 'li.device-bg img.bg-image', function (e) {
            e.preventDefault();

            var mode = $(this).attr('data-mode');
            var bg = $(this).attr('src');
            $('#editable').css('background-image', 'url(' + bg + ')');
            $('#editable').css('background-size', 'contain');
            $('#editable').css('background-position', 'inherit');
            $('.content-background').addClass(mode);
        });

        $(document).on('click', 'li.change-background', function () {
            var mode = $(this).attr('data-mode');
            $('.content-background').addClass(mode);
        });


        // click save edit html
        $(document).on('click', '.edit-html-save-button', function (e) {
            e.preventDefault();

            var cur = thisEditor.selected;

            var html = thisEditor.edit_html.getValue();

            var newObj = $(html);

            thisEditor.selected.obj.replaceWith(newObj);

            var element = thisEditor.elementFactory(newObj);
            if (element !== null) {
                thisEditor.select(element);
                thisEditor.handleSelect();
            }

            thisEditor.editHtmlPopup.hide();
        });

        // click outside grey background content
        $(".content-left, .themewp-content, .content-background").click(function () {
            thisEditor.unselect();
            thisEditor.hideControls();
        }).children().click(function (e) {
            return false;
        });
    },

    changeActiveDevice: function () {
        $('.box-mode-mobile').removeClass('active');
        $('.box-mode-tablet').removeClass('active');
        $('.box-mode-desktop').removeClass('active');
        $('.box-mode-mobile').removeClass('background-active');
        $('.box-mode-tablet').removeClass('background-active');
        $('.box-mode-desktop').removeClass('background-active');
    },

    backgroundModeMobile: function () {
        var thisEditor = this;
        $('.content-background').addClass('mode-mobile');
        $('.content-background').removeClass('mode-tablet mode-tablet-768 mode-tablet-1024');
        $('.content-background').removeClass('mode-desktop mode-desktop-1280 mode-desktop-1360 mode-desktop-1920');
        $('li.mode-mobile').find('i.icon-mode').css('color', 'white');
        $('li.mode-tablet').find('i.icon-mode').css('color', 'rgb(150, 150, 150)');
        $('li.mode-desktop').find('i.icon-mode').css('color', 'rgb(150, 150, 150)');

        thisEditor.changeActiveDevice();
        $('ul.box-mode li#box-mode-mobile').addClass('active');
        $('ul.box-mode li#box-mode-mobile').addClass('background-active');

        var my_frame = document.getElementById('builder_iframe');
        var width = $('.content-background.mode-mobile').width();
        my_frame.style.width = width + 'px';

        // body css
        $("#builder_iframe").contents().find("body").removeClass(function (index, className) {
            return (className.match(/(^|\s)builder-class-mode-\S+/g) || []).join(' ');
        });
        $("#builder_iframe").contents().find("body").addClass('builder-class-mode-mobile');

        setCustomTimeout(function () {
            thisEditor.adjustIframeSize();
        }, 500);
    },

    backgroundModeTablet: function () {
        var thisEditor = this;
        $('.content-background').addClass('mode-tablet');
        $('.content-background').removeClass('mode-mobile');
        $('.content-background').removeClass('mode-desktop mode-desktop-1280 mode-desktop-1360 mode-desktop-1920');
        $('li.mode-tablet').find('i.icon-mode').css('color', 'white');
        $('li.mode-mobile').find('i.icon-mode').css('color', 'rgb(150, 150, 150)');
        $('li.mode-desktop').find('i.icon-mode').css('color', 'rgb(150, 150, 150)');

        thisEditor.changeActiveDevice();
        $('ul.box-mode li#box-mode-tablet').addClass('active');
        $('ul.box-mode li#box-mode-tablet').addClass('background-active');

        var my_frame = document.getElementById('builder_iframe');
        var width = $('.content-background.mode-tablet').width();
        my_frame.style.width = width + 'px';

        // body css
        $("#builder_iframe").contents().find("body").removeClass(function (index, className) {
            return (className.match(/(^|\s)builder-class-mode-\S+/g) || []).join(' ');
        });
        $("#builder_iframe").contents().find("body").addClass('builder-class-mode-tablet');

        setCustomTimeout(function () {
            thisEditor.adjustIframeSize();
        }, 500);
    },

    backgroundModeDesktop: function () {
        var thisEditor = this;
        $('.content-background').addClass('mode-desktop');
        $('.content-background').removeClass('mode-mobile');
        $('.content-background').removeClass('mode-tablet');
        $('li.mode-desktop').find('i.icon-mode').css('color', 'white');
        $('li.mode-mobile').find('i.icon-mode').css('color', 'rgb(150, 150, 150)');
        $('li.mode-tablet').find('i.icon-mode').css('color', 'rgb(150, 150, 150)');

        thisEditor.changeActiveDevice();
        $('ul.box-mode li#box-mode-desktop').addClass('active');
        $('ul.box-mode li#box-mode-desktop').addClass('background-active');

        var my_frame = document.getElementById('builder_iframe');
        var width = $('.content-background.mode-desktop').width();
        my_frame.style.width = width + 'px';

        // body css
        $("#builder_iframe").contents().find("body").removeClass(function (index, className) {
            return (className.match(/(^|\s)builder-class-mode-\S+/g) || []).join(' ');
        });
        $("#builder_iframe").contents().find("body").addClass('builder-class-mode-desktop');

        setCustomTimeout(function () {
            thisEditor.adjustIframeSize();
        }, 500);
    },

    notificationArea: function (content, type = 'success') {
        bootstrapGrowl(content, {
            type: type,
            delay: 1500,
        });
    },

    newDesign: function () {
        var thisEditor = this;

        if (thisEditor.strict) {
            $("#builder_iframe").contents().find("[builder-element='PageElement']").html('');
            thisEditor.checkEmpty();
        }
    },

    clearDesign: function () {
        var thisEditor = this;

        Swal.fire({
            title: getI18n('are_you_sure'),
            text: getI18n('clear_while'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: getI18n('ok')
        }).then((result) => {
            if (result.value) {
                thisEditor.unselect();
                thisEditor.hideControls();

                Swal.fire({
                    title: getI18n('good_job'),
                    text: getI18n('clear_success'),
                    icon: "success",
                }).then((result) => {
                    // clear callback
                    if (thisEditor.clear) {
                        thisEditor.clear();
                        return;
                    }

                    if (thisEditor.strict) {
                        $("#builder_iframe").contents().find("[builder-element='PageElement']").html('');
                        thisEditor.checkEmpty();
                    }
                });
            }
        });
    },

    showTemplatePopup: function () {
        var templatePopup = new PopUp(getI18n('choose_template'));
        var contentPopup = '<div>' + $('#templateToolbox').html() + '</div>';

        templatePopup.loadHtml(contentPopup);
        $('.nav-content').removeClass('active');
        $('.nav-tab').removeClass('active');
        $('#home').addClass('active show');
    },

    loginInitialized: function () {
        if (!loginPopup)
            return false;
        else
            return true;

    },

    hideLoginPopup: function () {
        if (loginPopup) {
            loginPopup.hide();
            loginPopup = null;
        }
    },

    showContentBackgroundToolTip: function () {
        // Function to update the tooltip position
        const updateTooltipPosition = () => {
            const $iframe = $("#builder_iframe");
            if (!$iframe.length) return;

            const $iframeOffset = $iframe.offset();
            if (!$iframeOffset) return;

            // Get the content-left and content-background offsets
            const $contentBackground = $iframe.contents().find("body").find('.tox-edit-area').find('#PageElement_ifr');
            if (!$contentBackground.length) return;

            const contentOffset = $contentBackground.offset();
            if (!contentOffset) return;

            const selectedcontrols = $contentBackground.contents().find('html')[0];
            if (!selectedcontrols) return;

            // Extract the scale from the transform style (if it's already applied)
            const transformStyle = selectedcontrols.style.transform;
            let scale = 1; // Default scale

            if (transformStyle && transformStyle.includes('scale')) {
                // Extract the scale value using regex
                const scaleMatch = transformStyle.match(/scale\(([^)]+)\)/);
                if (scaleMatch) {
                    scale = parseFloat(scaleMatch[1]); // Parse the scale value
                }
            }

            var leftPosition = 0;

            if (window.innerWidth > 720) {
                leftPosition = $iframeOffset.left + contentOffset.left + $contentBackground.outerWidth() * scale - $('#content-tooltip').outerWidth() - 20;
                if (contentOffset.left < 0) {
                    leftPosition = window.innerWidth - $('#content-tooltip').outerWidth() - 20;
                }
            } else {
                leftPosition = window.innerWidth / 2 - $('#content-tooltip').outerWidth() / 2;
            }

            // Update the tooltip's position if the tooltip exists
            const $tooltip = $('#content-tooltip');
            if ($tooltip.length) {
                $tooltip.css({
                    position: 'absolute',
                    top: '40px', // Center vertically - before - top:$iframeOffset.top + mobileTop + 'px',
                    left: `${leftPosition}px`, // Adjust left
                    display: 'block', // Show the tooltip
                    zIndex: 1000
                });
            }
        };

        // Check if the tooltip has already been closed
        const tooltipClosed = getLocalStorageItem('contentBackgroundTooltipClosed');

        if (!tooltipClosed || tooltipClosed !== 'true') {
            // Check window width to conditionally show the "More tips" link
            const moreTipsLink = window.innerWidth < 720 ? `<a href="#" id="show-more-tooltips">${getI18n('hint_more_tips')}</a>` : '';

            // Create the tooltip dynamically
            const tooltipHtml = `
                <div class="content-tooltip" id="content-tooltip">
                    <button class="content-close-tooltip">&times;</button>
                    <p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="40" fill="currentColor" class="bi bi-lightbulb" viewBox="0 0 16 16">
                            <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13a.5.5 0 0 1 0 1 .5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1 0-1 .5.5 0 0 1 0-1 .5.5 0 0 1-.46-.302l-.761-1.77a2 2 0 0 0-.453-.618A5.98 5.98 0 0 1 2 6m6-5a5 5 0 0 0-3.479 8.592c.263.254.514.564.676.941L5.83 12h4.342l.632-1.467c.162-.377.413-.687.676-.941A5 5 0 0 0 8 1"/>
                        </svg>
                         <span style='font-size:16px'>${geBackgroundtHintText()}</span>
                    </p>
                    <div class="tooltip-links">
                        <label class="custom-checkbox">
                        <span id="custom-checkbox" class="checkbox-icon"></span>
                        <span class="checkbox-label">${getI18n('dont_show_again')}</span>
                         </label>
                        <a href="#" id="see-demo">${getI18n('see_demo')}</a>
                    </div>
                </div>
            `;

            // Append the tooltip to the content-background div if it exists
            const $contentBackgroundContainer = $('.content-background');
            if ($contentBackgroundContainer.length) {
                $contentBackgroundContainer.append(tooltipHtml);
            }

            // Initially set the tooltip's position
            updateTooltipPosition();

            // Add event listener for window resize to adjust tooltip position
            thisEditor.addEventListener($(window), 'resize', updateTooltipPosition);

            // Handle closing of the tooltip
            $('.content-close-tooltip').on('click', function () {
                const $tooltip = $('#content-tooltip');
                if ($tooltip.is(':visible')) {
                    $tooltip.remove(); // Remove the tooltip
                    // Remove the resize event listener when the tooltip is closed
                    thisEditor.removeSpecificEventListener($(window), 'resize', updateTooltipPosition);
                }
            });

            $('#custom-checkbox').on('click', function () {
                const $checkboxIcon = $('#custom-checkbox');

                // Toggle the 'checked' class
                $checkboxIcon.toggleClass('checked');

                // Check if the checkbox is checked and update localStorage accordingly
                const isChecked = $checkboxIcon.hasClass('checked');

                if (isChecked) {
                    setLocalStorageItem('contentBackgroundTooltipClosed', 'true'); // Store true if checked
                } else {
                    setLocalStorageItem('contentBackgroundTooltipClosed', 'false'); // Store false if unchecked
                }
            });

            // Add onclick event for "See demo" link
            $('#see-demo').on('click', function (e) {
                e.preventDefault();
                alert('See demo clicked');
            });
        }
    },



    recreatePassword: function (init, anyArray, token) {

        if (token) {
            var responsePayload = parseJwt(token);
            let compositeEmail = responsePayload.sub;
            const email = removeDomainFromCompositeEmail(compositeEmail);

            if (email != null) {
                console.log("Recreate Password", email);
                if (!thisEditor.loginInitialized()) {
                    setCustomTimeout(() => {
                        thisEditor.showLoginPopup(false, false, false, true, false);
                        $('#recreate-password-email').val(email);
                        $('#recreate-password-token').val(token);
                        $('#recreate-password-email').addClass('has-content');
                    }, 200);
                } else {
                    thisEditor.showLoginPopup(false, false, false, true, false);
                    $('#recreate-password-email').val(email);
                    $('#recreate-password-token').val(token);
                    $('#recreate-password-email').addClass('has-content');
                }
            }
        }
    },

    logginginregistrationorpasswordresetcomplete: function (init, credentialsArray) {
        try {
            if (credentialsArray) {
                let email = undefined;
                let password = undefined;
                let message = undefined;
                let submessage = undefined;


                // Iterate through the array to find username and password
                credentialsArray.forEach((item) => {
                    if (item.type === "email") {
                        email = item.value;
                    } else if (item.type === "password") {
                        password = item.value;
                    } else if (item.type === "message") {
                        message = item.value;
                    } else if (item.type === "submessage") {
                        submessage = item.value;
                    }
                });



                console.log('logginginregistrationorpasswordresetcomplete - email', email);
                if (!thisEditor.loginInitialized()) {
                    setCustomTimeout(() => {
                        console.log("message", message);
                        $('#builderModal.modal.show #logging-in-after-heading').text(message);
                        $('#builderModal.modal.show #logging-in-sub-heading').text(submessage);
                        console.log('logging after heading', $('#builderModal.modal.show #logging-in-after-heading'));
                        $('#logging-in-svg').css('display', 'block');
                        thisEditor.showLoginPopup(false, false, false, false, true);
                        $('#passwordresetcomplete-email').val(email);
                        $('#passwordresetcomplete-password').val(password);
                        setCustomTimeout(() => {
                            thisEditor.loginafterregistrationorpasswordreset();
                        }, 1000);
                    }, 200);
                } else {

                    console.log("message", message);
                    $('#builderModal.modal.show #logging-in-after-heading').text(message);
                    $('#builderModal.modal.show #logging-in-sub-heading').text(submessage);
                    console.log('#builderModal.modal.show #logging-in-after-heading', $('#builderModal.modal.show #logging-in-after-heading'));
                    $('#logging-in-svg').css('display', 'block');
                    thisEditor.showLoginPopup(false, false, false, false, true);
                    $('#builderModal.modal.show #passwordresetcomplete-email').val(email);
                    $('#builderModal.modal.show #passwordresetcomplete-password').val(password);
                    setCustomTimeout(() => {
                        thisEditor.loginafterregistrationorpasswordreset();
                    }, 1000);
                }
            }
        } catch (error) {
            console.log(error);
        }
    },

    showLoginPopup: function (signup, forgotpassword, checkyourinbox, recreatePassword, passwordresetcomplete, verficationSuccessName, successCallback) {
        closeDrawer();
        //console.log ('showLoginPopup');
        if (checkJwtTokenCookieExists() && !recreatePassword) {
            // console.log ('recreatePassword', recreatePassword);
            //do nothing
            //thisEditor.notificationArea(getI18n('already_loggedin'));
        }

        else {
            if (true) { //if loginPopup is not initialized before if (!loginPopup) {
                console.log("Initializing loginpopup");
                // loginPopup = new PopUp('', 'fit', 'default', 'Login'); //donot translate
                // var contentPopup = '<div>' + $('#loginModal').html() + '</div>';
                // loginPopup.loadHtml(contentPopup);

                loginPopup = new PopUp('', 'fit', 'default', 'Login', '#loginModal'); // don't translate

                // Move the content from #loginModal to the popup content area
                loginPopup.attachContent('#loginModal');

                // Show the popup with the attached content
                loginPopup.show();

                $('.nav-content').removeClass('active');
                $('.nav-tab').removeClass('active');

                const inputs = document.querySelectorAll('.loginform-input');

                const debouncedValidation = debounce(validateInput, 300); // 300 ms delay


                inputs.forEach(input => {
                    thisEditor.addEventListener(input, 'input', () => {
                        if (!input.dataset.interacted) {
                            input.dataset.interacted = 'true';
                        }
                        debouncedValidation(input);
                    });

                    thisEditor.addEventListener(input, 'focusout', () => {
                        input.dataset.interacted = 'true';
                        setCustomTimeout(() => validateInput(input), 100);
                    });



                });


                // Handle autofill case by checking input values on page load
                inputs.forEach(function (input) {
                    if (input.value) {
                        const originalValue = input.value;

                        // Change the value slightly to force style reset
                        input.value = originalValue.slice(1);

                        // Use requestAnimationFrame or setTimeout to restore the value
                        requestAnimationFrame(() => {
                            input.value = originalValue;
                        });
                        // input.value=temp;
                        input.classList.add('has-content');
                    }

                    // Add focus and blur event listeners to simulate user interaction
                    thisEditor.addEventListener(input, 'focus', () => {
                        input.classList.add('has-content');
                    });
                    thisEditor.addEventListener(input, 'blur', () => {
                        if (!input.value) {
                            input.classList.remove('has-content');
                        }
                    });
                });

                const labels = document.querySelectorAll('.loginform-label');

                labels.forEach(function (label) {
                    thisEditor.addEventListener(label, 'click', function () {
                        var input = document.querySelector('#' + this.getAttribute('for'));
                        if (input) {
                            input.focus();
                            if (input.value) {
                                input.classList.add('has-content');
                            }
                        }
                    });
                });


                // If script is already loaded, just initialize
                waitForGoogleSignIn(() => {
                    initializeGoogleSignIn();
                });


            }

            if (signup) {
                loginPopup.show();
                $("#email-input").val('');
                $("#login-container").hide();
                $("#forgot-password-container").hide();
                $("#check-your-inbox-container").hide();
                $("#sign-up-container").show();
                $("#recreate-password-container").hide();
                $("#logging-in-reset-password-complete").hide();


                $('#goback').show();
                $('#popupclosebutton').addClass('popupclosebutton');





                const signUpform = document.getElementById('SignupForm');
                const registerButton = document.getElementById('signupform-button');
                // console.log ("RegisterButton", registerButton);

                if (signUpform.checkValidity()) {
                    $(registerButton).prop('disabled', false).removeClass('loginbutton-disabled');
                } else {
                    $(registerButton).prop('disabled', true).addClass('loginbutton-disabled');
                }

                // Enable the register button if all inputs are valid
                thisEditor.addEventListener(signUpform, 'input', function () {
                    if (signUpform.checkValidity()) {
                        $(registerButton).prop('disabled', false).removeClass('loginbutton-disabled');
                    } else {
                        $(registerButton).prop('disabled', true).addClass('loginbutton-disabled');
                    }
                });
            }
            else if (forgotpassword) {
                loginPopup.show();
                $("#login-container").hide();
                $("#sign-up-container").hide();
                $("#forgot-password-container").show();
                $("#check-your-inbox-container").hide();
                $("#recreate-password-container").hide();
                $("#logging-in-reset-password-complete").hide();


                $('#goback').show();
                $('#popupclosebutton').addClass('popupclosebutton');



                const forgotPasswordForm = document.getElementById('ForgotPasswordForm');
                const resetPasswordButton = document.getElementById('resetpassword-button');
                // console.log ("RegisterButton", registerButton);

                if (forgotPasswordForm.checkValidity()) {
                    $(resetPasswordButton).prop('disabled', false).removeClass('loginbutton-disabled');
                } else {
                    $(resetPasswordButton).prop('disabled', true).addClass('loginbutton-disabled');
                }

                // Enable the register button if all inputs are valid
                thisEditor.addEventListener(forgotPasswordForm, 'input', function () {
                    if (forgotPasswordForm.checkValidity()) {
                        $(resetPasswordButton).prop('disabled', false).removeClass('loginbutton-disabled');
                    } else {
                        $(resetPasswordButton).prop('disabled', true).addClass('loginbutton-disabled');
                    }
                });

            }
            else if (checkyourinbox) {
                loginPopup.show();
                $("#login-container").hide();
                $("#sign-up-container").hide();
                $("#forgot-password-container").hide();
                $("#recreate-password-container").hide();
                $("#check-your-inbox-container").show();
                $("#logging-in-reset-password-complete").hide();


                $('#goback').show();
                $('#popupclosebutton').addClass('popupclosebutton');



                const forgotPasswordForm = document.getElementById('ForgotPasswordForm');
                const resetPasswordButton = document.getElementById('resetpassword-button');
                // console.log ("RegisterButton", registerButton);

                if (forgotPasswordForm.checkValidity()) {
                    $(resetPasswordButton).prop('disabled', false).removeClass('loginbutton-disabled');

                } else {
                    $(resetPasswordButton).prop('disabled', true).addClass('loginbutton-disabled');
                }

                // Enable the register button if all inputs are valid
                thisEditor.addEventListener(forgotPasswordForm, 'input', function () {
                    if (forgotPasswordForm.checkValidity()) {
                        $(resetPasswordButton).prop('disabled', false).removeClass('loginbutton-disabled');
                    } else {
                        $(resetPasswordButton).prop('disabled', true).addClass('loginbutton-disabled');
                    }
                });

            }
            else if (passwordresetcomplete) { //This is logging in after password reset
                loginPopup.show();
                $("#login-container").hide();
                $("#sign-up-container").hide();
                $("#forgot-password-container").hide();
                $("#recreate-password-container").hide();
                $("#check-your-inbox-container").hide();
                $("#logging-in-reset-password-complete").show();


                $('#goback').hide();
                $('#popupclosebutton').addClass('popupclosebutton');






            }
            else if (recreatePassword) { //Clicking on Email link get to this
                loginPopup.show();
                $("#login-container").hide();
                $("#sign-up-container").hide();
                $("#forgot-password-container").hide();
                $("#check-your-inbox-container").hide();
                $("#recreate-password-container").show();
                $("#logging-in-reset-password-complete").hide();


                $('#goback').hide();
                $('#popupclosebutton').addClass('popupclosebutton');



                const recreatePasswordForm = document.getElementById('RecreatePasswordForm');
                const recreatePasswordButton = document.getElementById('recreatepasswordform-button');
                // console.log ("RegisterButton", registerButton);

                const passwordsMatch = document.getElementById('recreate-password-new').value === document.getElementById('recreate-password-confirm').value;
                if (recreatePasswordForm.checkValidity() && passwordsMatch) {
                    $(recreatePasswordButton).prop('disabled', false).removeClass('loginbutton-disabled');
                } else {
                    $(recreatePasswordButton).prop('disabled', true).addClass('loginbutton-disabled');
                }

                // Enable the register button if all inputs are valid
                thisEditor.addEventListener(recreatePasswordForm, 'input', function () {
                    const passwordsMatch = document.getElementById('recreate-password-new').value === document.getElementById('recreate-password-confirm').value;
                    if (recreatePasswordForm.checkValidity() && passwordsMatch) {
                        $(recreatePasswordButton).prop('disabled', false).removeClass('loginbutton-disabled');
                    } else {
                        $(recreatePasswordButton).prop('disabled', true).addClass('loginbutton-disabled');
                    }
                });
            }
            else {
                $(document).off('click', '#loginform-button');
                loginPopup.show();
                $("#login-container").show();
                $("#forgot-password-container").hide();
                $("#sign-up-container").hide();
                $("#check-your-inbox-container").hide();
                $("#recreate-password-container").hide();
                $("#logging-in-reset-password-complete").hide();

                if (verficationSuccessName) {
                    if (verficationSuccessName === generateResumeVerificationSuccess) {
                        $('#beforecreateresume').show();
                        $('#beforegeneratepdf').hide();
                        $('#beforegeneratepreview').hide();
                        $('#accessFiles').hide();
                        $('#defaultFunctions').hide();
                        $('#beforecreatecoverletter').hide();
                        $('#uploadFiles').hide();
                        $('#beforesaving').hide();
                        $('#beforesavingAs').hide();
                        $('#renameFileAs').hide();
                        $('#beforecreatingfromtemplate').hide();
                        $('#loginbeforecheckout').hide();
                    }
                    else if (verficationSuccessName === pdfExportVerificationSuccess) {
                        $('#beforecreateresume').hide();
                        $('#beforegeneratepdf').show();
                        $('#beforegeneratepreview').hide();
                        $('#accessFiles').hide();
                        $('#defaultFunctions').hide();
                        $('#beforecreatecoverletter').hide();
                        $('#uploadFiles').hide();
                        $('#beforesaving').hide();
                        $('#beforesavingAs').hide();
                        $('#renameFileAs').hide();
                        $('#beforecreatingfromtemplate').hide();
                        $('#loginbeforecheckout').hide();
                    }

                    else if (verficationSuccessName === pdfPreviewVerificationSuccess) {
                        $('#beforecreateresume').hide();
                        $('#beforegeneratepdf').hide();
                        $('#beforegeneratepreview').show();
                        $('#accessFiles').hide();
                        $('#defaultFunctions').hide();
                        $('#beforecreatecoverletter').hide();
                        $('#uploadFiles').hide();
                        $('#beforesaving').hide();
                        $('#beforesavingAs').hide();
                        $('#renameFileAs').hide();
                        $('#beforecreatingfromtemplate').hide();
                        $('#loginbeforecheckout').hide();
                    }
                    else if (verficationSuccessName === openBrowseVerificationSuccess) {
                        $('#beforecreateresume').hide();
                        $('#beforegeneratepdf').hide();
                        $('#beforegeneratepreview').hide();
                        $('#accessFiles').show();
                        $('#defaultFunctions').hide();
                        $('#beforecreatecoverletter').hide();
                        $('#uploadFiles').hide();
                        $('#beforesaving').hide();
                        $('#beforesavingAs').hide();
                        $('#renameFileAs').hide();
                        $('#beforecreatingfromtemplate').hide();
                        $('#loginbeforecheckout').hide();

                    }
                    else if (verficationSuccessName === userTemplateAccessSuccess) {
                        $('#beforecreateresume').hide();
                        $('#beforegeneratepdf').hide();
                        $('#beforegeneratepreview').hide();
                        $('#accessFiles').show();
                        $('#defaultFunctions').hide();
                        $('#beforecreatecoverletter').hide();
                        $('#uploadFiles').hide();
                        $('#beforesaving').hide();
                        $('#beforesavingAs').hide();
                        $('#renameFileAs').hide();
                        $('#beforecreatingfromtemplate').hide();
                        $('#loginbeforecheckout').hide();

                    }
                    else if (verficationSuccessName === defaultFunctionsAccessSuccess) {
                        $('#beforecreateresume').hide();
                        $('#beforegeneratepdf').hide();
                        $('#beforegeneratepreview').hide();
                        $('#accessFiles').hide();
                        $('#defaultFunctions').show();
                        $('#beforecreatecoverletter').hide();
                        $('#uploadFiles').hide();
                        $('#beforesaving').hide();
                        $('#beforesavingAs').hide();
                        $('#renameFileAs').hide();
                        $('#beforecreatingfromtemplate').hide();
                        $('#loginbeforecheckout').hide();

                    }
                    else if (verficationSuccessName === generateCoverLetterVerificationSuccess) {
                        $('#beforecreateresume').hide();
                        $('#beforegeneratepdf').hide();
                        $('#beforegeneratepreview').hide();
                        $('#accessFiles').hide();
                        $('#defaultFunctions').hide();
                        $('#beforecreatecoverletter').show();
                        $('#uploadFiles').hide();
                        $('#beforesaving').hide();
                        $('#beforesavingAs').hide();
                        $('#renameFileAs').hide();
                        $('#beforecreatingfromtemplate').hide();
                        $('#loginbeforecheckout').hide();
                    }
                    else if (verficationSuccessName === openFileUploadVerificationSuccess) {
                        $('#beforecreateresume').hide();
                        $('#beforegeneratepdf').hide();
                        $('#beforegeneratepreview').hide();
                        $('#accessFiles').hide();
                        $('#defaultFunctions').hide();
                        $('#beforecreatecoverletter').hide();
                        $('#uploadFiles').show();
                        $('#beforesaving').hide();
                        $('#beforesavingAs').hide();
                        $('#renameFileAs').hide();
                        $('#beforecreatingfromtemplate').hide();
                        $('#loginbeforecheckout').hide();

                    }
                    else if (verficationSuccessName === openLinkedInVerificationSuccess) {
                        $('#beforecreateresume').hide();
                        $('#beforegeneratepdf').hide();
                        $('#beforegeneratepreview').hide();
                        $('#accessFiles').hide();
                        $('#defaultFunctions').hide();
                        $('#beforecreatecoverletter').hide();
                        $('#uploadFiles').show();
                        $('#beforesaving').hide();
                        $('#beforesavingAs').hide();
                        $('#renameFileAs').hide();
                        $('#beforecreatingfromtemplate').hide();
                        $('#loginbeforecheckout').hide();

                    }
                    else if (verficationSuccessName === saveVerificationSuccess || verficationSuccessName === saveVerificationSuccessGoBack) {
                        $('#beforecreateresume').hide();
                        $('#beforegeneratepdf').hide();
                        $('#beforegeneratepreview').hide();
                        $('#accessFiles').hide();
                        $('#defaultFunctions').hide();
                        $('#beforecreatecoverletter').hide();
                        $('#uploadFiles').hide();
                        $('#beforesaving').show();
                        $('#beforesavingAs').hide();
                        $('#renameFileAs').hide();
                        $('#beforecreatingfromtemplate').hide();
                        $('#loginbeforecheckout').hide();
                    }
                    else if (verficationSuccessName === saveAsVerificationSuccess) {
                        $('#beforecreateresume').hide();
                        $('#beforegeneratepdf').hide();
                        $('#beforegeneratepreview').hide();
                        $('#accessFiles').hide();
                        $('#defaultFunctions').hide();
                        $('#beforecreatecoverletter').hide();
                        $('#uploadFiles').hide();
                        $('#beforesaving').hide();
                        $('#beforesavingAs').show();
                        $('#renameFileAs').hide();
                        $('#beforecreatingfromtemplate').hide();
                        $('#loginbeforecheckout').hide();

                    }
                    else if (verficationSuccessName === renameVerificationSuccess) {
                        $('#beforecreateresume').hide();
                        $('#beforegeneratepdf').hide();
                        $('#beforegeneratepreview').hide();
                        $('#accessFiles').hide();
                        $('#defaultFunctions').hide();
                        $('#beforecreatecoverletter').hide();
                        $('#uploadFiles').hide();
                        $('#beforesaving').hide();
                        $('#beforesavingAs').hide();
                        $('#renameFileAs').show();
                        $('#beforecreatingfromtemplate').hide();
                        $('#loginbeforecheckout').hide();
                    }
                    if (verficationSuccessName === generateFromTemplateVerificationSuccess) {
                        $('#beforecreateresume').hide();
                        $('#beforegeneratepdf').hide();
                        $('#beforegeneratepreview').hide();
                        $('#accessFiles').hide();
                        $('#defaultFunctions').hide();
                        $('#beforecreatecoverletter').hide();
                        $('#uploadFiles').hide();
                        $('#beforesaving').hide();
                        $('#beforesavingAs').hide();
                        $('#renameFileAs').hide();
                        $('#beforecreatingfromtemplate').show();
                        $('#loginbeforecheckout').hide();
                    }
                    if (verficationSuccessName === checkoutPreviewDirectSuccess) {
                        $('#beforecreateresume').hide();
                        $('#beforegeneratepdf').hide();
                        $('#beforegeneratepreview').hide();
                        $('#accessFiles').hide();
                        $('#defaultFunctions').hide();
                        $('#beforecreatecoverletter').hide();
                        $('#uploadFiles').hide();
                        $('#beforesaving').hide();
                        $('#beforesavingAs').hide();
                        $('#renameFileAs').hide();
                        $('#beforecreatingfromtemplate').hide();
                        $('#loginbeforecheckout').show();
                    }

                } else {
                    $('#beforecreateresume').hide();
                    $('#beforegeneratepdf').hide();
                    $('#beforegeneratepreview').hide();
                    $('#accessFiles').hide();
                    $('#defaultFunctions').hide();
                    $('#beforecreatecoverletter').hide();
                    $('#uploadFiles').hide();
                    $('#beforesaving').hide();
                    $('#beforesavingAs').hide();
                    $('#renameFileAs').hide();
                    $('#beforecreatingfromtemplate').hide();
                }

                $('#popupclosebutton').removeClass('popupclosebutton');
                $('#goback').hide();




                if (successCallback) actionInProgress = successCallback; //setting the function to execute in case of google click or for signup
               // console.log ('Settingup actionInProgress', actionInProgress);




                const loginForm = document.getElementById('loginForm');
                const loginButton = document.getElementById('loginform-button');
                // console.log ("RegisterButton", registerButton);

                if (loginForm.checkValidity()) {
                    $(loginButton).prop('disabled', false).removeClass('loginbutton-disabled');
                } else {
                    $(loginButton).prop('disabled', true).addClass('loginbutton-disabled');
                }

                // Enable the register button if all inputs are valid
                thisEditor.addEventListener(loginForm, 'input', function () {
                    if (loginForm.checkValidity()) {
                        $(loginButton).prop('disabled', false).removeClass('loginbutton-disabled');
                    } else {
                        $(loginButton).prop('disabled', true).addClass('loginbutton-disabled');
                    }
                });

                // Set up login button to execute login and pass the successCallback
                $(document).on('click', '#loginform-button', function (event) {
                    event.stopImmediatePropagation();
                    // console.log ('successCallback in showpopup', successCallback);
                    thisEditor.login();
                });
            }
        }
    },

    viewSource: function () {
        var thisEditor = this;
        thisEditor.editing = false;

        // bee pro
        $('body').addClass('bp-source-mode');
        hideMainMenuDropdown();

        $('.content-left').removeClass('col-md-8');
        $('.content-left').addClass('col-md-6');
        $('#show-mode').html(getI18n('mode_source'));
        $('.content-right').hide();
        $('.view-source').show();

        var content = $("#builder_iframe").contents().find("body").html();

        //set editor with ace js
        var source_code = ace.edit("editor");
        source_code.setTheme("ace/theme/monokai");
        source_code.session.setMode("ace/mode/html");
        source_code.session.setTabSize(4);
        source_code.setValue(content);

        if (thisEditor.editing == false) {
            thisEditor.editing = true;

            source_code.session.on('change', function () {
                thisEditor.editing = false;
                setCustomTimeout(function () { thisEditor.updateFromSource('source'); }, 5000);
            });
        }

        thisEditor.cleanUpContent();
        thisEditor.adjustIframeSize();
    },

    initializeSliders: function () {
        $("#builder_iframe").contents().find('.RatingSlider').each(function (idx, elm) {
            //console.log("Element:", $("#builder_iframe").contents().find('.RatingSlider'));
            $(this).slider({
                value: $(this).parent().find('.SliderText').val(),
                min: 0,
                max: 5,
                step: .5,
                slide: function (event, ui) {
                    $(this).parent().find('.SliderText').val(ui.value);
                }
            });
        });
    },


    updateFromSource: function (mode = 'design') {
        if (mode == 'source') {
            var source_code = ace.edit("editor");
            var content = source_code.getValue();
            $('iframe#builder_iframe').contents().find('body').html(content);
        } else {
            //return;
            $('.tab-content').removeClass('hide-scroll-bar');
            $('.content-left').addClass('animation');
            setCustomTimeout(function () {
                $('.content-left').removeClass('animation');
            }, 100);
        }
    },

    viewDesign: function () {
        var thisEditor = this;

        $('body').removeClass('bp-source-mode');

        thisEditor.updateFromSource('design');

        $('.detail-content.dilen').removeClass('dilen');
        $('.content-left').removeClass('col-md-6');
        $('.content-left').addClass('col-md-8');
        $('#show-mode').html(getI18n('mode_design'));
        $('.content-right').show();
        $('.view-source').hide();

        thisEditor.adjustIframeSize();
    },

    showControls: function () {
        //console.log("showing controls");
        $('.detail-content').addClass('dilen');
        $('#nav-home-tab').removeClass('active');
    },

    toogleChooseTemplateMenu: function () {
        var thisEditor = this;

        if (typeof (thisEditor.templates) == 'undefined' || thisEditor.templates == '' || thisEditor.templates.length == 0) {
            $('.choose-template-menu').remove();
        }
    },

    displayPDFInDiv: function (pdfURL) {
        const pdfViewer = document.getElementById('pdfViewer');

        // Clear any previous content in the div
        pdfViewer.innerHTML = '';

        // Create an iframe to display the PDF
        const iframe = document.createElement('iframe');
        iframe.src = pdfURL;
        iframe.width = '100%';
        iframe.style.border = 'none';
        iframe.style.overflow = 'auto';


        thisEditor.setIframeHeight(iframe);

        // Adjust iframe height on window resize
        const resizeHandler = () => thisEditor.setIframeHeight(iframe);
        window.addEventListener('resize', resizeHandler);

        // Store the resize handler for cleanup
        thisEditor.resizeHandler = resizeHandler;

        // Append the iframe to the div
        pdfViewer.appendChild(iframe);
    },

    showPreview: function (device = 'desktop') {
        // show popup
        var thisBuilder = this;
        // //clean element hieu ung
        // thisBuilder.runBeforeSaveEvents();
        // thisBuilder.cleanUpContent();
        // var latestContent = $('#builder_iframe').contents().find('html').html();

        // latestContent = cleanupTinymceMess(latestContent);

        // //console.log(latestContent);

        $('div.showPreview').show("fast", function () {
            thisBuilder.hideControls();
            // load iframe

            $('#modal-preview-desktop .modal-body-preview').show("fast", function () {
                $('.pr-desktop').addClass('active-preview');

                thisBuilder.setAdjustFrame('desktop');
            });


        });
    },
    // Method to attach event listeners and track them
    addGenerateResumeListeners: function () {
        if (typeof this.generateResumeListener === "function") {
            $(window).off(generateResumeVerificationSuccess, this.generateResumeListener);

            // console.log("Adding " + generateResumeVerificationSuccess + " listener...");
            // Now add the listener
            $(window).on(generateResumeVerificationSuccess, this.generateResumeListener);

        } else {
            console.log("Listener is NOT defined, skipping event listener setup.");
        }
    },

    // Method to attach event listeners and track them
    addGenerateTemplateListeners: function () {
        if (typeof this.generateTemplateListener === "function") {
            $(window).off(generateFromTemplateVerificationSuccess, this.generateTemplateListener);

            // console.log("Adding " + generateResumeVerificationSuccess + " listener...");
            // Now add the listener
            $(window).on(generateFromTemplateVerificationSuccess, this.generateTemplateListener);

        } else {
            console.log("Listener is NOT defined, skipping event listener setup.");
        }
    },

    addGenerateCoverLetterListeners: function () {
        if (typeof this.generateCoverLetterListener === "function") {
            $(window).off(generateCoverLetterVerificationSuccess, this.generateCoverLetterListener);

            // console.log("Adding " + generateResumeVerificationSuccess + " listener...");
            // Now add the listener
            $(window).on(generateCoverLetterVerificationSuccess, this.generateCoverLetterListener);

        } else {
            console.log("Listener is NOT defined, skipping event listener setup.");
        }
    },

    // Method to attach event listeners and track them
    addDefaultFunctionsListeners: function () {
        if (typeof this.defaultFunctionsListener === "function") {
            $(window).off(defaultFunctionsAccessSuccess, this.defaultFunctionsListener);

            // console.log("Adding " + this.defaultFunctionsListener + " listener...");
            // Now add the listener
            $(window).on(defaultFunctionsAccessSuccess, this.defaultFunctionsListener);

        } else {
            console.log("Listener is NOT defined, skipping event listener setup.");
        }
    },

    // Method to attach event listeners and track them
    openBrowseListeners: function () {
        if (typeof this.openBrowseListener === "function") {
            $(window).off(openBrowseVerificationSuccess, this.openBrowseListener);

            // console.log("Adding " + openBrowseVerificationSuccess + " listener...");
            // Now add the listener
            $(window).on(openBrowseVerificationSuccess, this.openBrowseListener);

        } else {
            console.log("Listener is NOT defined, skipping event listener setup.");
        }
    },

    // Method to attach event listeners and track them
    openFileUploadListeners: function () {
        if (typeof this.openFileUploadListener === "function") {
            $(window).off(openFileUploadVerificationSuccess, this.openFileUploadListener);

            // console.log("Adding " + openBrowseVerificationSuccess + " listener...");
            // Now add the listener
            $(window).on(openFileUploadVerificationSuccess, this.openFileUploadListener);

        } else {
            console.log("Listener is NOT defined, skipping event listener setup.");
        }
    },

    // Method to attach event listeners and track them
    openLinkedInListeners: function () {
        if (typeof this.openLinkedInListener === "function") {
            $(window).off(openLinkedInVerificationSuccess, this.openLinkedInListener);

            // console.log("Adding " + openBrowseVerificationSuccess + " listener...");
            // Now add the listener
            $(window).on(openLinkedInVerificationSuccess, this.openLinkedInListener);

        } else {
            console.log("Listener is NOT defined, skipping event listener setup.");
        }
    },

    // Method to attach event listeners and track them
    addPreviewPdfListeners: function () {
        if (typeof this.previewPdfListener === "function") {
            $(window).off(pdfPreviewVerificationSuccess, this.previewPdfListener);

            //console.log("Adding " + pdfPreviewVerificationSuccess + " listener...");
            // Now add the listener
            $(window).on(pdfPreviewVerificationSuccess, this.previewPdfListener);

        } else {
            console.log("Listener is NOT defined, skipping event listener setup.");
        }
    },

    // Method to attach event listeners and track them
    addPdfExportListeners: function () {
        if (typeof this.exportPdfListener === "function") {
            $(window).off(pdfExportVerificationSuccess, this.exportPdfListener);

            // console.log("Adding " + pdfExportVerificationSuccess + " listener...");
            // Now add the listener
            $(window).on(pdfExportVerificationSuccess, this.exportPdfListener);

        } else {
            console.log("Listener is NOT defined, skipping event listener setup.");
        }
    },

    // Method to attach event listeners and track them
    addSaveListeners: function () {
        if (typeof this.saveListener === "function") {
            $(window).off(saveVerificationSuccess, this.saveListener);

            $(window).on(saveVerificationSuccess, this.saveListener);

        } else {
            console.log("Listener is NOT defined, skipping event listener setup.");
        }
    },

    // Method to attach event listeners and track them
    addSaveListenersGoBack: function () {
        if (typeof this.saveListener === "function") {
            $(window).off(saveVerificationSuccessGoBack, this.saveListenerGoBack);

            $(window).on(saveVerificationSuccessGoBack, this.saveListenerGoBack);

        } else {
            console.log("Listener is NOT defined, skipping event listener setup.");
        }
    },

    // Method to attach event listeners and track them
    addSaveAsListeners: function () {
        if (typeof this.saveListener === "function") {
            $(window).off(saveAsVerificationSuccess, this.saveAsListener);

            $(window).on(saveAsVerificationSuccess, this.saveAsListener);

        } else {
            console.log("Listener is NOT defined, skipping event listener setup.");
        }
    },

    // Method to attach event listeners and track them
    addRenameFileListeners: function () {
        if (typeof this.saveListener === "function") {
            $(window).off(renameVerificationSuccess, this.renameFileListener);

            $(window).on(renameVerificationSuccess, this.renameFileListener);

        } else {
            console.log("Listener is NOT defined, skipping event listener setup.");
        }
    },

    cleanupEverything: function () {


        removeAllEventListeners(100);

        if (thisEditor.mainResizeListener) {
            window.removeEventListener('resize', thisEditor.mainResizeListener);
            thisEditor.mainResizeListener = null; // Remove reference
            console.log("Resize listener removed.");
        }


        // Remove window-level listeners
        if (this.generateResumeListener) {
            $(window).off(generateResumeVerificationSuccess, this.generateResumeListener);
        } else {
            console.log("No listener found to remove.");
        }

        // Remove window-level listeners
        if (this.generateTemplateListener) {
            $(window).off(generateFromTemplateVerificationSuccess, this.generateTemplateListener);
        } else {
            console.log("No listener found to remove.");
        }

        if (this.generateCoverLetterListener) {
            $(window).off(generateCoverLetterVerificationSuccess, this.generateCoverLetterListener);
        } else {
            console.log("No listener found to remove.");
        }

        if (this.defaultFunctionsListener) {
            // console.log("Removing " + defaultFunctionsAccessSuccess + " listener...");
            $(window).off(defaultFunctionsAccessSuccess, this.defaultFunctionsListener);
        } else {
            console.log("No listener found to remove.");
        }

        if (this.openBrowseListener) {
            $(window).off(openBrowseVerificationSuccess, this.openBrowseListener);
        } else {
            console.log("No listener found to remove.");
        }

        if (this.openFileUploadListener) {
            $(window).off(openFileUploadVerificationSuccess, this.openFileUploadListener);
        } else {
            console.log("No listener found to remove.");
        }

        if (this.openLinkedInListener) {
            $(window).off(openLinkedInVerificationSuccess, this.openLinkedInListener);
        } else {
            console.log("No listener found to remove.");
        }

        if (this.previewPdfListener) {
            //console.log("Removing " + pdfPreviewVerificationSuccess + " listener...");
            $(window).off(pdfPreviewVerificationSuccess, this.previewPdfListener);
        } else {
            console.log("No listener found to remove.");
        }

        if (this.exportPdfListener) {
            // console.log("Removing " + pdfExportVerificationSuccess + " listener...");
            $(window).off(pdfExportVerificationSuccess, this.exportPdfListener);
        } else {
            console.log("No listener found to remove.");
        }

        if (this.saveListener) {
            $(window).off(saveVerificationSuccess, this.saveListener);
        } else {
            console.log("No listener found to remove.");
        }

        if (this.saveListenerGoBack) {
            $(window).off(saveVerificationSuccessGoBack, this.saveListenerGoBack);
        } else {
            console.log("No listener found to remove.");
        }

        if (this.saveAsListener) {
            $(window).off(saveAsVerificationSuccess, this.saveAsListener);
        } else {
            console.log("No listener found to remove.");
        }

        if (this.renameFileListener) {
            $(window).off(renameVerificationSuccess, this.renameFileListener);
        } else {
            console.log("No listener found to remove.");
        }



        // Remove all document-level listeners
        $(document).off('click');
        $(document).off('change');
        $(document).off('keydown');
        $(document).off('keyup');



        // Remove listeners inside the iframe
        $("#builder_iframe").contents().find("body").off("click");
        $("#builder_iframe").contents().find("body").off("mouseup");
        $("#builder_iframe").contents().find("body").off("mousemove");



        // Clean up Ace Editor instances
        if (this.edit_html) {
            this.edit_html.destroy();
            this.edit_html = null;
        }

        // Destroy any active popups
        if (this.editHtmlPopup) {
            this.editHtmlPopup.close();
            this.editHtmlPopup = null;
        }


        // TinyMCE cleanup if applicable
        if (typeof tinymce !== 'undefined') {
            tinymce.remove();
        }

        // Additional editor-specific cleanup
        this.unselect();
        this.removeInlineEdit();


        // Remove document-level listeners
        document.removeEventListener("mousemove", this.mouseMoveHandler);
        document.removeEventListener("mouseup", this.mouseUpHandler);
        document.removeEventListener("AppleIDSignInOnSuccess", this.appleSignInSuccessHandler);
        document.removeEventListener("AppleIDSignInOnFailure", this.appleSignInFailureHandler);
        document.removeEventListener("touchstart", this.touchStartHandler);

        // Remove dynamically added jQuery event listeners
        $(document).off('click', 'a.preview-design-desktop');
        $(document).off('click', 'a.preview-menu');
        $(document).off('click', '#top-collapsable-templates-button');
        $(document).off('click', '.font-family');
        $(document).off('click', 'a.bodytheme');
        $(document).off('click', 'a.fonttheme');

        // Remove iFrame content listeners
        const iframeContent = $("#builder_iframe").contents();
        iframeContent.find("body").off("mousemove");
        iframeContent.find("html").off("mouseup");
        iframeContent.find("body").off("mouseout");
        iframeContent.find(".tick-slider-input").off("input");
        //  iframeContent.find(".RatingSlider").slider("destroy");

        // // Remove TinyMCE editor listeners
        // if (this.editorInstance) {
        //     this.editorInstance.off("click change keyup input init cut paste");
        // }


        if (iframeDoc) {
            const htmlElement = iframeDoc.find('html').get(0);
            htmlElement.innerHTML = '';
            iframeDoc = null;
        }


        // Remove custom tooltips and interactions
        $("#zoom-container").off("mouseenter mouseleave");
        $("#zoom-container").find("button").off("click");
        if (typeof $.fn.tooltip === 'function') {
            $('.tooltip').tooltip('dispose');
        }

        highlightModule.unload();
        invoiceDetailsModule.unload();
        thisEditor.removeAllEditorEventListeners();
        cleanupCustomCaretListeners();
        clearInterval(saveIntervalID);
        thisEditor.unloadTinyMceEditor();
        thisEditor.closePreview();



        pricingEvents.unload();
        subscriptionMiscModule.unload();

        faqsEvents.unload();

        slidersetup.unload();
        horizontalslidersetup.unload();
        resumePageEvents.unload();
        mainPageEvents.unload();
        homePageEvents.unload();
        localeEvents.unload();
        // jobSearchEvents.unload();
        loadmainimages.unload();
        fileUploadEvents.unloadAll();
        chatgptButtonLayoutAdjuster.unload();
        renameAsEvents.unload();

        youtubeDialogModule.unload();
        cleanupOrientationChangeListener();
        cleanupMobileUndoRedoListeners();
        cleanupContextBarListeners();
        cleanupDefaultContextMenuListeners();
        window.externalCleanupDragState = null;
        window.externalEnableDragAndDrop = null;


        // console.log('iframedoc', iframeDoc);


        if (thisEditor.iframe) {
            thisEditor.iframe.off('load');  // Remove event listeners
            thisEditor.iframe.attr('src', 'about:blank');  // Clear iframe src
            thisEditor.iframe.remove();  // Optionally remove from DOM
            thisEditor.iframe = null;  // Nullify reference for GC
            console.log('Iframe successfully unloaded and cleaned.');
        }




        // Reset editor-related properties and state
        this.beforeSaveEvents = [];
        this.saveAchor = 0;
        this.dragShadow = null;
        this.editHtmlPopup = null;
        this.header = {};
        this.url = null;

        initHistoryState = null;
        actionInProgress = null;
        secondsElapsed = 0;
        timerInterval = null;
        initHistoryState = null;

        gscale = null;
        mainContentScrollTop = null;
        mainContentScrollLeft = null;
        loginPopup = null;

        initialScrollPosition = null;
        lastScrollPosition = null;
        previousWidth = null;
        lastBreakpoint = null;

        initialScale = null;
        lastState = null;
        defaultScaleFactor = null;
        adjustedScaleFactor = null;
        lastZoomLevel = null;
        currentScale = null;

        touchX = null;
        touchY = null;







        const iframeBody = $("#builder_iframe").contents().find("body");
        iframeBody.off();


        $(document).off();


        removeAllChildrenAndStyles(document.body);

        clearAllTimeouts();

        if (typeof $ !== 'undefined') {
            $(window).off(); // Remove all jQuery event listeners
        }

        // Remove references from DOM
        if (thisEditor.iframe) {
            thisEditor.iframe.remove();
            thisEditor.iframe = null;
        }

        // Ensure all object properties are nullified
        for (let key in thisEditor) {
            if (thisEditor.hasOwnProperty(key)) {
                thisEditor[key] = null;
            }
        }



        // Set references to null
        window.resumeSidebar = null;
        window.leftSidebarScrollableDiv = null;
        window.rightDrawer = null;
        window.wrapper = null;
        messageId = 0;
        caretListeners.length = 0;  // Previously an array
        caretMarker = null;
        orientationChangeListener = null;
        customCaretImplementation = null;
        cachedCaretPosition = { x: 0, y: 0 };
        selectedMainElement = null;
        defaultContextMenuListener.length = 0;
        initialCaretPosition = null;
        currentFileName = null;
        saveIntervalID = null;
        themeChanged = null;

        onLoadTriggered = false;
        isDrawing = false;
        longPressTimer = null;
        isScrolling = false;
        iframeDoc = null;
        ctxIsCollapsed = false;
        lastPosition = { left: 0, top: 0 };





        if (thisEditor) {
            // Nullify DOM-related objects
            thisEditor.iframe = null;
            thisEditor.tinymce = null;
            thisEditor.url = null;
            thisEditor.logoText = null;
            thisEditor.saveUrl = null;
            thisEditor.header = null;
            thisEditor.hostname = null;
            thisEditor.iconStyle = null;
            thisEditor.inlineEditor = null;
            thisEditor.logo = null;
            thisEditor.root = null;
            thisEditor.urlBack = null;
            thisEditor.urlParams = null;

            // Nullify editor functionality & export-related settings
            thisEditor.export = null;
            thisEditor.reg = null;
            thisEditor.backgrounds = null;

            // Reset arrays to avoid memory leaks
            thisEditor.beforeSaveEvents = [];
            thisEditor.editorListeners = [];
            thisEditor.tinymceEventListeners = [];

            // Nullify language-related properties
            thisEditor.language = null;
            thisEditor.saveMethod = null;
            thisEditor.I18n = null;

            // Reset numbers and booleans
            thisEditor.loading = 0;
            thisEditor.saveAchor = 0;
            thisEditor.isInitialized = false;
            thisEditor.runCustom = false;
            thisEditor.saveToServer = false;
            thisEditor.showHelp = false;
            thisEditor.strict = false;
            thisEditor.uses12HourClock = false;
            thisEditor.readOnlyMode = false;
            thisEditor.contentSaved = false;


            // Final nullification for garbage collection
            thisEditor = null;
            window.currentEditor = null;
        }

        Editor = null;


    },




    setAdjustFrame: function (mode = 'desktop') {
        if (mode == 'mobile') {
            var my_frameM = document.getElementById('previewIframeMobile');
            var content_heightM = my_frameM.contentWindow.document.body.scrollHeight;
            my_frameM.style.height = content_heightM + 'px';
        } else {
            this.adjustPreviewIframeSize();
        }
    },

    loadTags: function () {
        var thisEditor = this;

        if (typeof (thisEditor.tags) != 'undefined') {
            thisEditor.tags.forEach(function (tag) {
                if (tag.type == 'label') {
                    $('ul.tags-value').append('<li class="tags" title="' + tag.tag + '">' +
                        '<div class="float-left">' +
                        '<div class="tag">' +
                        '<input class="copy-tags builder-tag-text" value="' + tag.tag + '" data-value="" style="outline: none;border: none;background-color: #f5f5f5;"/>' +
                        '</div>' +
                        '</div>' +
                        '<div class="float-right insert">' +
                        '<button class="btn btn-tag-copy" data-clipboard-target=".copy-tags" style="cursor: pointer;padding: 5px 20px;color: #241c15;background-color: #fff;">Copy</button>' +
                        '</div>' +
                        '</li>');

                    // bee pro tags
                    $('.tags-container').append(`
                        <div class="tag-item ml-2 mb-2" title="`+ tag.tag + `">
                            <span class="tag-icon">
                                <i style="height: 23px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16"><g fill="#626262"><path fill-rule="evenodd" d="M5 2a.5.5 0 0 1 .5-.5c.862 0 1.573.287 2.06.566c.174.099.321.198.44.286c.119-.088.266-.187.44-.286A4.165 4.165 0 0 1 10.5 1.5a.5.5 0 0 1 0 1c-.638 0-1.177.213-1.564.434a3.49 3.49 0 0 0-.436.294V7.5H9a.5.5 0 0 1 0 1h-.5v4.272c.1.08.248.187.436.294c.387.221.926.434 1.564.434a.5.5 0 0 1 0 1a4.165 4.165 0 0 1-2.06-.566A4.561 4.561 0 0 1 8 13.65a4.561 4.561 0 0 1-.44.285a4.165 4.165 0 0 1-2.06.566a.5.5 0 0 1 0-1c.638 0 1.177-.213 1.564-.434c.188-.107.335-.214.436-.294V8.5H7a.5.5 0 0 1 0-1h.5V3.228a3.49 3.49 0 0 0-.436-.294A3.166 3.166 0 0 0 5.5 2.5A.5.5 0 0 1 5 2zm3.352 1.355zm-.704 9.29z"/><path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/></g></svg>
                                </i>
                            </span>
                            <span class="tag-title">
                                <input value="`+ tag.tag + `" type="text" style=""/>
                            </span>
                        </div>
                    `);
                }
            });
        }
    },

    listTemplate: function () {
        var thisEditor = this;

        if (typeof (thisEditor.templates) !== 'undefined') {
            thisEditor.templates.forEach(function (template) {
                $('.show-list-template ul.display-template').append('<li class="hover-name-template" data-thumbnail="' + template.thumbnail + '" template-url="' + template.url + '">' +
                    '<a class="template-change" href="#"> ' + template.name + ' </a>' +
                    '</li>');

                $('ul.list-new-template').append('<li class="c-templateSelection_item c-choiceCard c-choiceCard--thick pb-4">' +
                    '<div class="c-choiceCard_innerContainer">' +
                    '<a aria-label="button" title="' + getI18n('selected_template') + '" style="background-position: center;background-size: 151px;background-repeat: no-repeat;background-image: url(' + template.thumbnail + ');" href="' + template.url + '" class="newTemplate new-from-template-select c-choiceCard_label overflow--visible background-size--cover background-position--center-top border-gray border-radius--lv1 v-aspectRatio--square margin-bottom--lv1"></a>' +
                    '<p title="' + template.name + '" class="text-align--center margin-bottom--lv0 font-weight--bold ">' + template.name + '</p>' +

                    '</div>' +
                    '</li>');

                // bee pro
                $('.templates-container').append('<li class="c-templateSelection_item c-choiceCard c-choiceCard--thick pb-4">' +
                    '<div class="c-choiceCard_innerContainer">' +
                    '<a aria-label="button" title="' + getI18n('selected_template') + '" style="background-position: center;background-size: 151px;background-repeat: no-repeat;background-image: url(' + template.thumbnail + ');" href="' + template.url + '" class="newTemplate new-from-template-select c-choiceCard_label overflow--visible background-size--cover background-position--center-top border-gray border-radius--lv1 v-aspectRatio--square margin-bottom--lv1"></a>' +
                    '<p title="' + template.name + '" class="text-align--center margin-bottom--lv0 font-weight--bold ">' + template.name + '</p>' +

                    '</div>' +
                    '</li>');
            });
        }
    },



    setLogo: function () {
        //console.log('this.logo', this.logo);
        // logo
        this.logo = '/dist/images/resumebuilderlogosmall.svg';
        this.logoText = getLogoTextImage();
        if (typeof (this.logo) !== 'undefined') {
            $('.logo .logo-img').attr('src', this.logo);
            $('.logo .logo-img-text').attr('src', this.logoText);
        }
    },

    setData: function () {
        //console.log('this.logo', this.logo);
        // logo
        this.data = {
            S3Key: 'resume.pdf',
            test: 'false',
        };
    },

    init: function (htmlfilename, resumeUrl, historyState, readyState, urlParams) {

        const domains = [
            "cmVzdW1lYnVpbGRlcmdwdC5jb20=", // resumebuildergpt.com
            "cmVzdW1lYnVpbGRlcmdwdC5haQ==", // resumebuildergpt.ai
            "cmVzdW1laW5taW51dGVzLmNvbQ==", // resumeinminutes.com
            "c3FsbGRhcC5jb20=",             // sqlldap.com
            "Y3Zpbm1pbnV0ZXMuY29t"           // cvinminutes.com
        ];

        if (domains.some(encodedDomain => window.location.hostname.includes(atob(encodedDomain)))) {
            var thisEditor = this;
            // if (resumeUrl) {
            //     thisEditor.url = resumeUrl.replace(/^\/resume/, '');

            // }
            if (resumeUrl) {
                thisEditor.url = resumeUrl.replace(/^\/(resume|coverletter)/, '');
            }


            if (htmlfilename) {
                thisEditor.runcustom(htmlfilename, readyState, urlParams);
            } else {
                thisEditor.run(historyState, readyState);
            }



            return thisEditor;
        }
        return null;
    },

    setLanguage: function () {
        var thisEditor = this;
        thisEditor.I18n = window.LANGUAGE[this.language];
        // console.log ('thisEditor.I18n', thisEditor.I18n);


        // // merge custom language
        // if (thisEditor.lang) {
        //     thisEditor.I18n = $.extend(thisEditor.I18n, thisEditor.lang);
        //     console.log ('(thisEditor.lang', thisEditor.lang);
        // }

        window.getI18n = function (phrase) {
            try {
                // Check if the phrase exists in the selected language
                if (typeof thisEditor.I18n[phrase] !== 'undefined') {
                    return thisEditor.I18n[phrase];
                }

                // Fallback to 'en-US' if phrase is not found in the current language
                if (typeof LANGUAGE['en-US'][phrase] !== 'undefined') {
                    return LANGUAGE['en-US'][phrase];
                }
                // Return the original phrase if not found in both
                return phrase;
            } catch (error) {
                // In case of error, fallback to 'en-US'
                if (typeof LANGUAGE['en-US'][phrase] !== 'undefined') {
                    return LANGUAGE['en-US'][phrase];
                }
                // If not found in 'en-US' either, return the phrase itself
                return phrase;
            }
        };
    },

    runcustom: async function (htmlfilename, readyState, urlParams) {
        var thisEditor = this;

        thisEditor.setLanguage(htmlfilename);

        seoMetaManager.init(htmlfilename);

        // Attach the event listener by calling the method
        this.addGenerateResumeListeners();
        this.addGenerateTemplateListeners();
        this.addGenerateCoverLetterListeners();
        this.addDefaultFunctionsListeners();
        this.openFileUploadListeners();
        this.openLinkedInListeners();

        thisEditor.runCustom = true;

        thisEditor.urlParams = urlParams;

        // prepair HTML
        thisEditor.prepairHtml(htmlfilename, this.language);

        // prepair body html
        thisEditor.build();

        thisEditor.setLogo();

        thisEditor.setData();



        // load event listensers
        thisEditor.loadEvents(true);

        if (readyState && isUserLoggedIn()) {
            const vendor = getVendorFromCookies();
            const folderUUID = getFolderIdFromCookies();
            if (folderUUID) {
                await fetchAndStoreDataOnLogin(folderUUID, vendor, true, false);
            }
        }
        thisEditor.checkIfLoggedIn();

        highlightModule.init();


    },

    run: async function (historyState, readyState) {
        var thisEditor = this;
        thisEditor.setLanguage();


        initHistoryState = historyState;

        this.addPreviewPdfListeners();
        this.addPdfExportListeners();
        this.addSaveListeners();
        this.addSaveListenersGoBack();
        this.addSaveAsListeners();
        this.addRenameFileListeners();
        this.openBrowseListeners();
        this.addDefaultFunctionsListeners();
        this.addGenerateTemplateListeners();


        thisEditor.runCustom = false;
        thisEditor.prepairHtml('default', this.language);

        // prepair body html
        thisEditor.build();



        // init vars
        thisEditor.iframe = $('#builder_iframe');
        thisEditor.content = this.iframe.contents().find('body');
        thisEditor.window = this.iframe.contents().find("html");
        thisEditor.selected = null;

        //
        thisEditor.initIframe(historyState);

        // load tags buttons


        // load event listensers
        thisEditor.loadEvents(false);

        // check if change template enu available
        thisEditor.toogleChooseTemplateMenu();

        // list template
        thisEditor.listTemplate();

        // set logo
        thisEditor.setLogo();

        thisEditor.setData();



        console.log('Iframe base Path is: ', constants.IFRAME_BASE_PATH + '/tinymce/tinymce.min.js');

        // load tinymce
        thisEditor.loadPageJs([constants.IFRAME_BASE_PATH + '/tinymce/tinymce.min.js'])
            .catch((error) => {
                console.error("Error loading scripts:", error);
            });
        // strict layout fix
        thisEditor.checkStrict();

        // check export button
        if (thisEditor.export == null) {
            $('.export-button').remove();
        }

        // iframe no makeup
        if (thisEditor.frameBoxStyle && thisEditor.frameBoxStyle == 'none') {
            thisEditor.iframe.addClass('no_style');
        }

        // hide help button
        if (!thisEditor.showHelp) {
            $('li.ask-help').remove();
        }

        // disable features
        thisEditor.checkDisableFeatures();

        // file manager
        if (!thisEditor.filemanager) {
            $('.filemanager-item').remove();
        }

        if (!isTouchScreen()) {
            // Initialize tooltips with hover trigger if not on a touch screen
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover'
            });
        } else {
            // Dispose of tooltips on mobile or touch screen devices
            if (typeof $.fn.tooltip === 'function') {
                $('[data-toggle="tooltip"]').tooltip('dispose');
            }
        }





        adjustDarkLightModeButton();

        // if (historyState) renderFromHistoryState(historyState);
        // else
        //     updateAndReplaceState();


        if (readyState && isUserLoggedIn()) {
            const vendor = getVendorFromCookies();
            const folderUUID = getFolderIdFromCookies();
            if (folderUUID) {
                await fetchAndStoreDataOnLogin(folderUUID, vendor, true, false);
            }
        }

        // updateTooltipsBasedOnWidth();

        // if (window.innerWidth < 720) {
        //     showZoomSliderToolTip();
        // }


    },

    checkDisableFeatures: function () {
        var thisEditor = this;

        if (thisEditor.disableFeatures == null) {
            return;
        }
        // disable change template
        if (thisEditor.disableFeatures.includes('change_template')) {
            $('.choose-template-menu').hide();
        }

        // disable export
        if (thisEditor.disableFeatures.includes('export')) {
            $('.export-button').hide();
        }

        // disable save & close
        if (thisEditor.disableFeatures.includes('save_close')) {
            $('.btn-save-and-close').remove();
        }

        // disable footer exit
        if (thisEditor.disableFeatures.includes('footer_exit')) {
            $('.footer-exit-without-save').remove();
        }

        // disable help
        if (thisEditor.disableFeatures.includes('help')) {
            $('.ask-help').remove();
        }
    },

    checkStrict: function () {
        var thisEditor = this;

        if (!thisEditor.strict) {
            $('#nav-profile-tab').remove();
            $('.design .design-new').parent().hide();
            $('.design .design-clear').parent().hide();
            if (!thisEditor.strict) {
                $('#nav-layouts-tab').show();
            } else {
                $('.content-right nav #nav-tab a').css('width', '50%');
            }
        }

        // close
        $('.build-mode-warning-close').on('click', function () {
            $('body').removeClass('build-mode-disabled');
            $('.build-mode-warning').remove();
        });
    },


    // Select outline
    selectOutline: function () {
        // console.log("select outling called");
        return $("#builder_iframe").contents().find("body").find('.builder-select-outline');
    },

    //fix loi
    select: function (element, removeAiTooltip = true) {
        const isTopLevel = $(element.obj[0])?.attr("istoplevel") === "true" || false;

        //console.log("Selected")
        if (!element.equals(this.selected)) {
            this.unselect(removeAiTooltip);

            this.selected = element;
            this.selected.select(defaultScaleFactor, isTopLevel);

            // editor
            //this.inlineEdit($("#builder_iframe")[0].contentWindow.$(element.obj[0]));
        }

        // js auto height iframe
        this.adjustIframeSize();

        // is warpper, hightlight settings tab
        if (element.isWrapper()) {
            $('#nav-profile-tab').addClass('active');
        }
    },

    unselect: function (removeAiTooltip = true) {

        //  console.log ('calling unselect');

        if (removeAiTooltip)
            $("#builder_iframe").contents().find("body").find('.custom-tooltip').remove();


        if (this.selected != null) {
            this.selected.unselect();


            // editor
            this.removeInlineEdit(this.selected.obj);
        }
        this.selected = null;

        // js auto height iframe
        this.adjustIframeSize();

        // is warpper, unhightlight settings tab
        $('#nav-profile-tab').removeClass('active');
    },

    duplicate: function () {
        var thisEditor = this;

        // bee pro
        if (!thisEditor.selected) {
            beeAlert('Duplicate', 'Please choose a field from your form design first!');
            return;
        }

        var obj = this.selected.obj;
        this.unselect();
        var html = obj.clone();

        var new_item = $(html);

        obj.after(new_item);
        new_item.css('display', 'none');
        setCtxSliderClicked(true);
        new_item.fadeIn(200, function () {
            // select new element
            var element = thisEditor.elementFactory(new_item);
            if (element !== null) {
                thisEditor.select(element);
                thisEditor.handleSelect();
            }

            // js auto height iframe
            thisEditor.adjustIframeSize();

        });
    },

    remove: function () {
        var thisEditor = this;
        // bee pro
        if (!thisEditor.selected) {
            beeAlert('Remove', 'Please choose a field from your form design first!');
            return;
        }
        var obj = this.selected.obj;
        var removed = this.selected;
        this.unselect();

        obj.fadeOut(200, function () {
            // find empty parent element
            var parents = obj.parents('[builder-element]');

            obj.remove();

            // check parent if empty then remove
            if (parents.length &&
                !parents.first().find('[builder-element]').length &&
                !parents.first().is("[builder-element='PageElement']") &&
                !parents.first().is("[builder-element='CellElement']")
            ) {
                parents.first().remove();
            }

            // js auto height iframe
            thisEditor.adjustIframeSize();



            // check empty
            thisEditor.checkEmpty();
        });

        // hide controls
        this.hideControls();
    },

    showAiBox: function (event) {
        const existingTooltip = $("#builder_iframe").contents().find(".custom-tooltip");
        var leftOffset = 90;
        var mobileTop = 0;

        if (window.innerWidth < 720) {
            leftOffset = 80;
            mobileTop = 5;
        }

        if (existingTooltip.length) {
            existingTooltip.remove();
        }

        var obj = this.selected.obj;


        // Get the selectedcontrols element
        const selectedcontrols = $('.builder-tool.builder-outline-selected-controls')[0];

        // Extract the scale from the transform style (if it's already applied)
        const transformStyle = selectedcontrols.style.transform;
        let scale = 1; // Default scale

        if (transformStyle && transformStyle.includes('scale')) {
            // Extract the scale value using regex
            const scaleMatch = transformStyle.match(/scale\(([^)]+)\)/);
            if (scaleMatch) {
                scale = parseFloat(scaleMatch[1]); // Parse the scale value
            }
        }


        // Create the tooltip HTML and apply the scale to everything
        const $tooltip = $(`
        <div class="custom-tooltip tooltip-class" style="transform: scale(${scale});">
            <button class="close-tooltip" tabindex="0">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path
                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                </svg>
            </button>
            <div class="tooltip-content tooltip-class">
                <textarea class="editable-text tooltip-class" rows="10" cols="40" placeholder="${getI18n('regnerate_text')}" style="width: 100%;" tabindex="0"></textarea>
            </div>
            <button tabindex="0" class="tooltip-submit-btn ai-button-disabled" disabled>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" class="icon-2xl">
                    <circle cx="16" cy="16" r="15"/>
                    <path fill-rule="evenodd" fill="white" stroke="white" stroke-width="1.2"
                        d="M15.192 8.906a1.143 1.143 0 0 1 1.616 0l5.143 5.143a1.143 1.143 0 0 1-1.616 1.616l-3.192-3.192v9.813a1.143 1.143 0 0 1-2.286 0v-9.813l-3.192 3.192a1.143 1.143 0 1 1-1.616-1.616z"
                        clip-rule="evenodd"></path>
                </svg>
            </button>
        </div>
        `);

        // Append tooltip to the iframe body
        $("#builder_iframe").contents().find("body").append($tooltip);

        // Find the #selectedborder element and #maincontent-body-html
        const $selectedBorder = $("#builder_iframe").contents().find('#maincontent-body-html').find('#selectedborder');
        const $mainContent = $("#builder_iframe").contents().find('#maincontent-body-html');

        const $tableContent = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table');


        // Get the top offset relative to the document for both elements
        const selectedBorderOffset = $selectedBorder.offset().left;
        const mainContentOffset = $mainContent.offset().left;

        // Calculate the relative top position of #selectedborder to #maincontent-body-html
        const relativeTop = selectedBorderOffset - mainContentOffset;

        console.log('SelectedBorder Offset Top:', selectedBorderOffset);
        console.log('MainContent Offset Top:', mainContentOffset);
        console.log('Relative Top Position:', relativeTop); // This is the top relative to #maincontent-body-html


        // console.log ('outlineblue2Offset', outlineblue2Offset);
        // console.log ('outlineblue2Offset outer width', outlineblue2Offset.outerWidth());
        // console.log ('outlineblue2Offset outer height', outlineblue2Offset.outerHeight());


        const mainContent = $("#builder_iframe").contents().find('#maincontent-body-html')[0];

        // Get button and tooltip positions
        const buttonOffset = $(event.target).closest('.builder-ai-selected-button').offset();
        const buttonWidth = $(event.target).closest('.builder-ai-selected-button').outerWidth(); // Apply scale to button width
        const buttonHeight = $(event.target).closest('.builder-ai-selected-button').outerHeight() // Apply scale to button height
        const tooltipWidth = $tooltip.outerWidth() * scale; // Apply scale to tooltip width
        const tooltipHeight = $tooltip.outerHeight() * scale; // Apply scale to tooltip height

        const scrollTop = mainContent.scrollTop; // Get scrollable document height
        const windowHeight = $(window).height(); // Get the window height
        const windowWidth = $tableContent.width() * scale;

        console.log("window width: " + windowWidth);


        // Calculate available space above and below the button
        const spaceAbove = buttonOffset.top - scrollTop;

        // Decide whether to place the tooltip above or below the button
        let top, isTooltipAbove;
        let resultScale = (1 - scale === 0) ? 1 : (1 - scale) * 10;
        let leftScale = (scale === 1) ? 1 : (1 / scale) * 10;

        if (spaceAbove >= tooltipHeight + 10) {
            // Place above the button if there is enough space
            top = buttonOffset.top - tooltipHeight - 10 * resultScale - mobileTop;
            isTooltipAbove = true;
        } else {
            // Otherwise, place below the button
            if (window.innerWidth < 720)
                top = buttonOffset.top - 10 * resultScale - mobileTop + 20;
            else
                top = buttonOffset.top + buttonHeight + 10;
            isTooltipAbove = false;
        }

        // If too far to the right, adjust to the left
        let left = buttonOffset.left - leftOffset - leftScale; // Offset tooltip to the left of the button, apply scale
        // if (left + tooltipWidth > windowWidth) {
        //      left = windowWidth - tooltipWidth - 10; // Ensure the tooltip stays inside the window
        //  }
        if (left < 10) {
            left = 10; // Prevent tooltip from going off the left side
        }

        console.log('top', top);
        console.log('left', top);
        // Set tooltip position
        $tooltip.css({
            top: top + 'px',
            left: left + 'px'
        });

        // Adjust the arrow direction based on the tooltip's position
        if (isTooltipAbove) {
            $tooltip.addClass('tooltip-above').removeClass('tooltip-below');
        } else {
            $tooltip.addClass('tooltip-below').removeClass('tooltip-above');
        }

        // Close tooltip when the close button is clicked
        $tooltip.find('.close-tooltip').on('click', function () {
            $tooltip.remove();
        });

        // Enable/disable the submit button based on textarea input
        $tooltip.find('.editable-text').on('input', function () {
            const text = $(this).val().trim();
            const $submitButton = $tooltip.find('.tooltip-submit-btn');

            if (text.length > 0) {
                $submitButton.prop('disabled', false)
                    .css('cursor', 'pointer')
                    .removeClass('ai-button-disabled')
                    .addClass('ai-button-enabled');
            } else {
                $submitButton.prop('disabled', true)
                    .css('cursor', 'not-allowed')
                    .removeClass('ai-button-enabled')
                    .addClass('ai-button-disabled');
            }
        });


    },


    hideOnDesktop: function () {
        var obj = this.selected.obj;
        obj.addClass('Hide-on-desktop');
        obj.removeClass('Hide-on-mobile');
        $('.icon-remove-two-screen').removeClass('hide');
    },

    hideOnMobile: function () {
        var obj = this.selected.obj;
        obj.addClass('Hide-on-mobile');
        obj.removeClass('Hide-on-desktop');
        $('.icon-remove-two-screen').removeClass('hide');
    },

    removeHideOnTowScreen: function () {
        var obj = this.selected.obj;
        obj.removeClass('Hide-on-mobile');
        obj.removeClass('Hide-on-desktop');
        $('.icon-remove-two-screen').addClass('hide');
        $('.hide-all.desktop').removeClass('change-bgcolor');
        $('.hide-all.mobile').removeClass('change-bgcolor');
    },



    elementFactory: function (obj) {

        // console.log ('Inside Element Factory obj', obj);
        var element = null;

        // check if obj is null
        if (typeof (obj) == 'undefined') {
            return null;
        }

        // STRICT MODE
        if (this.strict) {
            // if obj is OR is inside element
            if (obj.closest('[builder-element]').length) {
                obj = obj.closest('[builder-element]');
            } else {
                return null;
            }

            // Get element by builder-element value
            if (typeof (obj.attr('builder-element')) != 'undefined' && obj.attr('builder-element') != '') {
                element = eval('new ' + obj.attr('builder-element') + '(obj)');
            }





            return element;

            // NOT STRICT MODE
        } else {
            // check if inside helper
            if (this.isHelperTarget(obj)) {
                return null;
            }

            // check if is not element
            if (this.isNotElement(obj)) {
                return null;
            }


        }


    },

    handleSelect: function (callback) {
        var thisEditor = this;

        setCustomTimeout(function () {
            thisEditor.loadControls();

            if (typeof (callback) !== 'undefined') {
                callback();
            }
        }, 100);
    },

    setControlsBarTitle: function (name) {
        $('.properties-pannel-title h4').html(name);
    },

    loadControls: function () {
        var thisEditor = this;


        // if no selected
        if (this.selected == null) {
            return;
        }

        // set sidebar title
        this.setControlsBarTitle(this.selected.name());

        // top delete button toggle
        if (!this.selected.canDelete()) {
            $('.builder-remove-selected-button').hide();
        } else {
            $('.builder-remove-selected-button').show();
        }

        // top duplicate button toggle
        if (!this.selected.canDuplicate()) {
            $('.builder-duplicate-selected-button').hide();
        } else {
            $('.builder-duplicate-selected-button').show();
        }


        // go to third page
        //  goToThirdPage();
    },

    hideControls: function () {
        var thisEditor = this;

        // Load element controls bar
        var element_bar = $('#builder_sidebar').find('.detail-content');
        element_bar.removeClass('dilen');
        // element_bar.find('.properties-pannel-content').html('');
        $('#builder_sidebar').find('.tab-content').removeClass('hide-scroll-bar');

        $('#nav-home-tab').addClass('active');

        // themewp go back
        // goToMainPage();
    },

    updateThemeForFontSize: function (fontNameWithTheme) {

        // console.log ('fontNameWithTheme', fontNameWithTheme);
        const target = $("#builder_iframe").contents().find('#maincontent-body-html')[0];
        const data = target.getAttribute('data').split("|");
        const className = data[0];
        var colorName = data[1];

        if (fontNameWithTheme) {
            const fontTemp = fontNameWithTheme.split("|");
            const newestTheme = fontTemp[0];
            const newestFontName = fontTemp[1];

            if (newestTheme != className) {
                colorName = 'default'
            }
            thisEditor.updateTheme(newestTheme, colorName, newestFontName);
        }

    },

    updateTheme: async function (themeName, themecolor, themeFont) {
        const target = $("#builder_iframe").contents().find('#maincontent-body-html')[0];
        //  console.log ('data values', target.getAttribute('data'));
        const data = target.getAttribute('data').split("|");
        const className = data[0];
        const colorName = data[1];
        const fontName = data[2];
        const orderSequence = data[3] || "professional";
        const classification = data[4] || "Tech";
        const org = data[5] || "NonFang";

        if (!themecolor)
            themecolor = colorName;

        if (!themeFont)
            themeFont = fontName;

        // console.log(`Theme Name: ${themeName}, Theme Color: ${themecolor}, Theme Font: ${themeFont}`);


        if (themeName) {
            //console.log ("Theme Name is: ", themeName);
            target.setAttribute('data', themeName + "|" + themecolor + "|" + themeFont + "|" + orderSequence + "|" + classification + "|" + org);
            const $mainContentBody = $("#builder_iframe").contents().find('#maincontent-body');
            const hasDarkTheme = $mainContentBody.hasClass('dark-theme');


            $mainContentBody.attr("class", "");

            const $tinymce = $("#builder_iframe").contents().find("body").find(".tox-edit-area").find("#PageElement_ifr").contents().find("#tinymce");
            if ($tinymce.length) {
                // Determine the base class and check for dark-mce-theme
                let baseClass = $tinymce.hasClass("mce-content-body") ? "mce-content-body" : "";
                const hasDarkTheme = $tinymce.hasClass("dark-mce-theme");

                // Set the base class
                $tinymce.attr("class", baseClass);

                // Re-add dark-mce-theme if it was present
                if (hasDarkTheme) {
                    $tinymce.addClass("dark-mce-theme");
                }
            }

            $tinymce.addClass(themeName);
            $mainContentBody.addClass(themeName);

            $tinymce.addClass(themecolor);
            $mainContentBody.addClass(themecolor);

            $tinymce.addClass(themeFont);
            $mainContentBody.addClass(themeFont);

            $tinymce.addClass(orderSequence);
            $mainContentBody.addClass(orderSequence);

            $tinymce.addClass(classification);
            $mainContentBody.addClass(classification);

            $tinymce.addClass(org);
            $mainContentBody.addClass(org);



            if (hasDarkTheme) {
                $mainContentBody.addClass('dark-theme');
            }

            themeChanged = true;
            if (Array.isArray(thisEditor.tinymce) && thisEditor.tinymce.length > 0) {
                const editorInstance = thisEditor.tinymce[0];
                const tinymceEditor = editorInstance;
                utilsEvents.toggleLayout(themeName, iframeDoc, tinymceEditor);
                utilsEvents.toggleDateAlignment(themeName, iframeDoc, tinymceEditor);
            }


            slidersetup.applyClassesToVariation(themeName, themecolor, themeFont, className, colorName, fontName);
        } else {
            //This runs at the first load

            $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('#tinymce').addClass(className);
            $("#builder_iframe").contents().find('#maincontent-body').addClass(className);

            $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('#tinymce').addClass(colorName);
            $("#builder_iframe").contents().find('#maincontent-body').addClass(colorName);

            $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('#tinymce').addClass(fontName);
            $("#builder_iframe").contents().find('#maincontent-body').addClass(fontName);

            $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('#tinymce').addClass(orderSequence);
            $("#builder_iframe").contents().find('#maincontent-body').addClass(orderSequence);

            $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('#tinymce').addClass(classification);
            $("#builder_iframe").contents().find('#maincontent-body').addClass(classification);

            $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('#tinymce').addClass(org);
            $("#builder_iframe").contents().find('#maincontent-body').addClass(org);


            if (Array.isArray(thisEditor.tinymce) && thisEditor.tinymce.length > 0) {
                const editorInstance = thisEditor.tinymce[0];
                const tinymceEditor = editorInstance;
                utilsEvents.toggleLayout(themeName, iframeDoc, tinymceEditor);
                utilsEvents.toggleDateAlignment(themeName, iframeDoc, tinymceEditor);
            }


        }


        window.PDFConfigModule.getMargins();
        //const mainTable = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table').find('tbody');
        //if (mainTable) mainTable.click();
    },
    getPinchDistance: function (event) {
        var touches = event.originalEvent.touches;
        if (touches.length >= 2) {
            var dx = touches[0].pageX - touches[1].pageX;
            var dy = touches[0].pageY - touches[1].pageY;
            return Math.sqrt(dx * dx + dy * dy);
        }
        return 0;
    },

    adjustScale: function (scaleFactor) {
        // Adjust your scale factor accordingly, for example:
        // $('#content-left').css('transform', 'scale(' + scaleFactor + ')');
        console.log('Current scale factor: ' + scaleFactor);
    },

    showSelectedSlide: function (className) {
        //   console.log ('show selected slides');
        slidersetup.mainsliderScrollToSlide(className);

    },

    /* Initial scaling for zoom */
    ctxUpdateScale: function () {
        const ctxContextBars = $("#builder_iframe").contents().find("body").find('.builder-outline-selected-controls');
        if (ctxContextBars.length > 0) { // Ensure at least one element exists
            const ctxContextBar = ctxContextBars[0]; // Access the first element
            if (!vp) return;
            const barScale = 1 / (vp.scale || 1);
            ctxContextBar.style.transform = `scale(${barScale})`;
        }
    },

    changetheme: async function (init) {

        let wasVisible = false;
        let isVisible = false;

        const desktop = window.innerWidth > 1260;

        if (desktop) {
            if ($('#image-carousel-div').hasClass('left-collapsable-templates-light-visibledesktopnotvisiblemobile'))
                wasVisible = true;
        }
        else {
            if ($('#image-carousel-div').hasClass('left-collapsable-templates-light-notvisibledesktopbutvisiblemobile'))
                wasVisible = true;
        }

        if ($('#image-carousel-div').hasClass('left-collapsable-templates-light-visibledesktopnotvisiblemobile')) {
            $('#image-carousel-div').removeClass('left-collapsable-templates-light-visibledesktopnotvisiblemobile').addClass('left-collapsable-templates-light-notvisibledesktopbutvisiblemobile');
        } else {
            $('#image-carousel-div').removeClass('left-collapsable-templates-light-notvisibledesktopbutvisiblemobile').addClass('left-collapsable-templates-light-visibledesktopnotvisiblemobile');
        }


        if (desktop) {
            if ($('#image-carousel-div').hasClass('left-collapsable-templates-light-visibledesktopnotvisiblemobile'))
                isVisible = true;
        }
        else {
            if ($('#image-carousel-div').hasClass('left-collapsable-templates-light-notvisibledesktopbutvisiblemobile'))
                isVisible = true;
        }

        (async () => {
            thisEditor.changeNavText("#image-carousel-div", "#changetheme-text");
            thisEditor.changeNavText("#image-carousel-div", "#changethememl-text");
            thisEditor.changeNavText("#image-carousel-div", "#changethememl-menu-text");
        })();


        // If the previous state was not visible and now it's visible, call updateTheme()
        if (!wasVisible && isVisible) {
            thisEditor.updateTheme();
        }


        if (window.innerWidth < 1260) {
            if (!init && isVisible) {
                setCustomTimeout(() => {
                    thisEditor.scrollToTopForThemeChanges();
                }, 300);
            }
            else {
                setCustomTimeout(() => {
                    const mainContent = $("#builder_iframe").contents().find('#maincontent-body-html')[0];
                    mainContent.scrollTop = mainContentScrollTop;
                    mainContent.scrollLeft = mainContentScrollLeft;
                }, 500);

            }
        }

        //  updateAndReplaceState();

    },

    changeNavText: function (selector, id) {
        const desktop = window.innerWidth > 1260;
        let isVisible = false;

        if (desktop) {
            if ($('#image-carousel-div').hasClass('left-collapsable-templates-light-visibledesktopnotvisiblemobile'))
                isVisible = true;
        }
        else {
            if ($('#image-carousel-div').hasClass('left-collapsable-templates-light-notvisibledesktopbutvisiblemobile'))
                isVisible = true;
        }

        if (isVisible) {
            $(id).text(getI18n('hidethemes'));
        } else {
            $(id).text(getI18n('menubar.items.changetheme'));
        }
    },





    scrollToTopForThemeChanges: function (timeout = 100, behavior = 'smooth') {
        if ($("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table').find('.topleftblackline').is(":hidden")) {
            $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table').find('#toprightblackline1px')[0].scrollIntoView({ behavior: behavior, block: 'nearest', inline: 'end' });
        }
        else {
            $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table').find('.topleftblackline')[0].scrollIntoView({ behavior: behavior, block: 'nearest', inline: 'end' });
        }
        // Scroll to the scaled position
        setCustomTimeout(() => {
            this.unselect();
            this.hideControls();
        }, timeout);

        this.adjustIframeSize();

    },

    adjustDialogSize: function (editor) {
        const dialog = editor.windowManager.getWindows()[0];
        if (dialog) {
            const viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            const viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
            const maxWidth = viewportWidth * 0.9; // Adjust as needed
            const maxHeight = viewportHeight * 0.9; // Adjust as needed
            const width = Math.min(dialog.width(), maxWidth);
            const height = Math.min(dialog.height(), maxHeight);
            dialog.resizeTo(width, height);
        }
    },

    getPercentage: function (sliderValue) {
        switch (sliderValue) {
            case '0': return '0%';
            case '1': return '20%';
            case '2': return '40%';
            case '3': return '60%';
            case '4': return '80%';
            default: return '100%';
        }
    },

    scaleToSize: function (newScale) {
        // console.log ('scaling editor to size', newScale);
        const mceContentBody = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('.mce-content-body')[0];
        const mainTableDiv = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html').find('#main-table')[0];
        const bodyhtml = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr').contents().find('html')[0];
        const pageElementIfr = $("#builder_iframe").contents().find("body").find('.tox-edit-area').find('#PageElement_ifr')[0];
        const toxEditArea = $("#builder_iframe").contents().find("body").find('.tox-edit-area')[0];
        const builderIframe = $("#builder_iframe")[0];
        const contenBackground = $('.content-left .content-background')[0];
        const movehook = $('.builder-tool.builder-outline-move-hook')[0];
        const selectedcontrols = $('.builder-tool.builder-outline-selected-controls')[0];
        const outlineblue = $("#builder_iframe").contents().find('#maincontent-body-html').find('#selectedborder')[0];
        const outlineblue2 = $('.builder-outline-blue')[0];

        if (contenBackground) {
            contenBackground.style.transform = 'scale(' + 1 + ')';
        }

        if (builderIframe) {
            builderIframe.style.transform = 'scale(' + 1 + ')';
        }

        if (toxEditArea) {
            toxEditArea.style.transform = 'scale(' + 1 + ')';
        }

        if (pageElementIfr) {
            pageElementIfr.style.transform = 'scale(' + 1 + ')';
        }

        if (bodyhtml) {
            bodyhtml.style.transform = 'scale(' + newScale + ')';
        }

        if (mceContentBody) {
            mceContentBody.style.transform = 'scale(' + 1 + ')';
        }

        if (mainTableDiv) {
            mainTableDiv.style.transform = 'scale(' + 1 + ')';
        }

        if (outlineblue) {
            outlineblue.style.transform = 'scale(' + newScale + ')';
        }

        if (outlineblue2) {
            outlineblue2.style.transform = 'scale(' + newScale + ')';
        }

        if (selectedcontrols) {

            if (isHoverable) {

                const selectedScale = newScale < minimumMobileCtxBarScale ? minimumMobileCtxBarScale : newScale;
                selectedcontrols.style.transform = 'scale(' + selectedScale + ')';

            } else {
                selectedcontrols.style.transform = 'scale(' + 1 + ')';
            }
        }

        if (newScale === 1) {
            if (mainTableDiv) {
                mainTableDiv.classList.remove('margintablemarginscale');
            }
            if (bodyhtml) {
                bodyhtml.classList.remove('disable-pan-x');
            }
        } else {
            if (mainTableDiv) {
                mainTableDiv.classList.add('margintablemarginscale');
            }
            if (bodyhtml) {
                bodyhtml.classList.add('disable-pan-x');
            }
        }

        // Scroll to the scaled position
        setCustomTimeout(() => {
            this.unselect();
            this.hideControls();
        }, 100);
    },

};


function initTinyMCEWithDragAndDrop(editor) {
    let draggedElement = null;
    let nextToDraggedElement = null;
    let isDragging = false;
    const eventListeners = []; // Track event listeners for cleanup
    let cancelButton = null;


    const DRAG_INDICATOR_CLASS = "drag-indicator";
    const DROP_INDICATOR_CLASS = "drop-indicator";
    const HIGHLIGHT_CLASS = "highlight";
    const DRAGGABLE_CLASS = "draggable";
    const DROP_HIGHLIGHT_CLASS = "drop-highlight";
    const INVALID_DROP_CLASS = "invalid-drop";


    let ctxEditableArea = null;

    // Allow external cleanup
    window.externalCleanupDragState = cleanupDragState;
    window.externalEnableDragAndDrop = enableDragAndDrop;

    editor.on("init", () => {
        ctxEditableArea = editor.getBody();
    });

    const findSelectedElement = (selectedMainElement, ctxEditableArea) => {
        // Define a helper function to find the nearest draggable element
        const findNearest = (startElement) => {
            let current = startElement;

            // Traverse upwards to find the nearest matching ancestor
            while (current) {
                if (current.matches('[builder-element="BlockElement"][istoplevel="true"]')) {
                    return current; // Found a matching ancestor
                }
                current = current.parentElement; // Move to the parent element
            }

            // Traverse siblings and descendants to find the nearest match
            current = startElement;
            while (current) {
                const siblingOrChild = current.querySelector('[builder-element="BlockElement"][istoplevel="true"]');
                if (siblingOrChild) {
                    return siblingOrChild; // Found a matching sibling or child
                }
                current = current.nextElementSibling; // Move to the next sibling
            }

            // As a fallback, search the entire editable area
            return ctxEditableArea.querySelector('[builder-element="BlockElement"][istoplevel="true"]');
        };

        // Start from `selectedMainElement.obj[0]` if available
        let selectedElement = null;
        if (selectedMainElement && selectedMainElement.obj) {
            selectedElement = selectedMainElement.obj[0];
        }

        // If the starting element doesn't match the criteria, find the nearest one
        if (!selectedElement || !selectedElement.matches('[builder-element="BlockElement"][istoplevel="true"]')) {
            selectedElement = findNearest(selectedElement || ctxEditableArea);
            console.log("selectedElement in find nearest", selectedElement);
        }

        return selectedElement; // Return the found element or null
    };



    function enableDragAndDrop() {
        if (!ctxEditableArea) return;
        setDragAndDropEnable(true)

        const elements = ctxEditableArea.querySelectorAll('[builder-element="BlockElement"][istoplevel="true"]');
        const previouslyDraggable = ctxEditableArea.querySelectorAll('[builder-element="BlockElement"][draggable="true"]');
        previouslyDraggable.forEach((el) => {
            el.removeAttribute("draggable");
            el.classList.remove(DRAGGABLE_CLASS);
        });

        let selectedElement = findSelectedElement(selectedMainElement, ctxEditableArea);
        if (!selectedElement) {
            return;
        }

        draggedElement = selectedElement;
        draggedElement.classList.add(DRAGGABLE_CLASS);
        draggedElement.setAttribute("draggable", "true");


        const builderIframe = $("#builder_iframe")[0];
        const $iframeContents = $(builderIframe).contents().find("body");
        const $toxEditArea = $iframeContents.find('.tox-edit-area');
        const $htmlContainer = $("#builder_iframe").contents().find("html");


        // Include scroll offsets
        const toxEditAreaLeftOffset = ($toxEditArea.offset().left || 0) - ($toxEditArea.scrollLeft() || 0);
        const toxEditAreaTopOffset = ($toxEditArea.offset().top || 0) - ($toxEditArea.scrollTop() || 0) - Math.abs(($htmlContainer.scrollTop() || 0));

        addBar(draggedElement, "Drag this", DRAG_INDICATOR_CLASS, "rgba(40, 167, 69, 0.2)", "#28a745", toxEditAreaLeftOffset, toxEditAreaTopOffset, "drag");

        elements.forEach((element) => {
            if (element !== draggedElement) {
                // Check if the current element is directly below the dragged element
                const draggedRect = draggedElement.getBoundingClientRect();
                const elementRect = element.getBoundingClientRect();

                const variance = 20;

                const isDirectlyBelow =
                    Math.abs(draggedRect.bottom - elementRect.top) < 40 && // Vertical alignment tolerance
                    Math.abs(draggedRect.left - elementRect.left) <= variance && // Allow variance for left alignment
                    Math.abs(draggedRect.right - elementRect.right) <= variance; // Allow variance for right alignment

                if (isDirectlyBelow) {
                    // Skip this element as it is directly below the dragged element
                    nextToDraggedElement = element;
                    return;
                }


                // Otherwise, add the drop indicator
                element.classList.add(HIGHLIGHT_CLASS);
                addBar(element, "Drop here", DROP_INDICATOR_CLASS, "rgba(0, 123, 255, 0.2)", "#007bff", toxEditAreaLeftOffset, toxEditAreaTopOffset, "drop");
            }
        });


        addTouchAndDragListeners();
    }

    function addTouchAndDragListeners() {
        if (!ctxEditableArea) return;

        const onDragStart = (e) => {
            isDragging = true;
            if (e.target === draggedElement || e.target.closest(`.${DRAG_INDICATOR_CLASS}`)) {
                e.dataTransfer.setData("text/plain", "dragging");
            }
        };

        const onDragEnd = () => {
            cleanupDragState();
            updateDropZones();
        };

        const onDragOver = (e) => {
            if (!isDragging) return;
            e.preventDefault();

            const target = e.target.closest('[builder-element="BlockElement"][istoplevel="true"]');
            if (target && target !== draggedElement && target !== nextToDraggedElement) {
                highlightDropTarget(target);
            } else {
                clearDropHighlights();
            }
        };

        const onDrop = (e) => {
            if (!isDragging) return;
            e.preventDefault();

            const target = e.target.closest('[builder-element="BlockElement"][istoplevel="true"]');
            if (!target || target === draggedElement || target === nextToDraggedElement) {
                showInvalidDropFeedback(draggedElement);
                cleanupDragState();
                return;
            }

            // Calculate whether to insert before or after the target
            const targetRect = target.getBoundingClientRect();
            const insertAfter = e.clientY > targetRect.top + targetRect.height / 2;

            // Remove draggedElement from its current position
            draggedElement.parentNode.removeChild(draggedElement);

            //thisEditor.transformHtml(draggableItem.dropHtml()); -- check if we need to do this

            // Move the draggedElement to the new position
            if (insertAfter) {
                target.parentNode.insertBefore(draggedElement, target.nextSibling); // Insert after
            } else {
                target.parentNode.insertBefore(draggedElement, target); // Insert before
            }

            cleanupDragState();
            editor.nodeChanged();
        };

        addEventListener(ctxEditableArea, "dragstart", onDragStart);
        addEventListener(ctxEditableArea, "dragend", onDragEnd);
        addEventListener(ctxEditableArea, "dragover", onDragOver);
        addEventListener(ctxEditableArea, "drop", onDrop);


    }

    function addBar(element, text, className, backgroundColor, textColor, toxEditAreaLeftOffset, toxEditAreaTopOffset, indicator = "drag") {
        const rect = element.getBoundingClientRect();
        const iframeRect = editor.iframeElement.getBoundingClientRect();
        const bar = document.createElement("div");
        bar.classList.add(className);

        const scale = defaultScaleFactor < 1 ? defaultScaleFactor : 1;

        // Positioning for the bar
        // console.log('defaultScaleFactor in addBar', scale);
        const barX = rect.left / scale - iframeRect.left / scale + toxEditAreaLeftOffset / scale;
        const barY = rect.top / scale - iframeRect.top / scale - 3 + toxEditAreaTopOffset / scale;

        // Log the values for debugging
        // console.log("rect.left:", rect.left);
        // console.log("iframeRect.left:", iframeRect.left);
        // console.log("toxEditAreaLeftOffset:", toxEditAreaLeftOffset);
        // console.log("Calculated barX:", barX);

        // console.log("rect.top:", rect.top);
        // console.log("iframeRect.top:", iframeRect.top);
        // console.log("toxEditAreaTopOffset:", toxEditAreaTopOffset);
        // console.log("Calculated barY:", barY);

        if (barX === 0) {
            console.log(`Skipping bar for element due to barX being 0:`, element);
            return;
        }

        bar.setAttribute("draggable", "true"); // Make the bar draggable

        bar.style.position = "absolute";
        bar.style.left = `${barX}px`;
        bar.style.top = `${barY}px`;
        bar.style.width = `${rect.width / scale}px`;
        bar.style.height = "20px";
        bar.style.lineHeight = "20px";
        bar.style.textAlign = "left";
        bar.style.background = backgroundColor;
        bar.style.color = textColor;
        bar.style.borderRadius = "4px";
        bar.style.pointerEvents = "none"; // Enable pointer events for the cancel button
        bar.style.zIndex = "1400";

        bar.style.display = "flex";
        bar.style.alignItems = "center";
        bar.style.padding = "0 5px";
        bar.style.cursor = "move";


        // Add text (e.g., "Drag this" or "Drop here")
        const barText = document.createElement("span");
        barText.textContent = text;
        barText.style.flex = "1";
        barText.style.pointerEvents = "none"; // Prevent interaction with text
        bar.appendChild(barText);

        // Add cancel button if the indicator is "drag"
        if (indicator === "drag") {
            const cancelButton = document.createElement("button");
            cancelButton.textContent = "Cancel";
            cancelButton.style.marginLeft = "5px";
            cancelButton.style.background = "rgba(255, 69, 58, 0.9)";
            cancelButton.style.color = "#fff";
            cancelButton.style.border = "none";
            cancelButton.style.borderRadius = "3px";
            cancelButton.style.pointerEvents = "auto";
            cancelButton.style.cursor = "pointer";
            cancelButton.style.fontSize = "12px";
            cancelButton.style.padding = "2px 5px";

            cancelButton.addEventListener("click", (e) => {
                e.stopPropagation(); // Prevent click propagation
                cleanupDragState();
            });
            bar.appendChild(cancelButton);
        }

        // Append the bar to the editable area
        ctxEditableArea.appendChild(bar);
    }

    function addEventListener(target, type, listener) {
        target.addEventListener(type, listener);
        eventListeners.push({ target, type, listener });
    }

    function removeEventListeners() {
        eventListeners.forEach(({ target, type, listener }) => {
            target.removeEventListener(type, listener);
        });
        eventListeners.length = 0; // Clear the array
    }

    function cleanupDragState() {
        setDragAndDropEnable(false);
        if (draggedElement) {
            draggedElement.removeAttribute("draggable");
            draggedElement.classList.remove(DRAGGABLE_CLASS);
        }
        draggedElement = null;
        isDragging = false;
        clearDropHighlights();
        removeBars(DRAG_INDICATOR_CLASS);
        removeBars(DROP_INDICATOR_CLASS);
        if (cancelButton) {
            cancelButton.removeEventListener("click", cleanupDragState);
            cancelButton.remove();
            cancelButton = null; // Reset the global cancelButton
        }
        removeBars("cancel-button");
        removeEventListeners();

    }


    function clearDropHighlights() {
        const highlighted = ctxEditableArea.querySelectorAll(`.${DROP_HIGHLIGHT_CLASS}`);
        highlighted.forEach((el) => el.classList.remove(DROP_HIGHLIGHT_CLASS));
    }

    function removeBars(className) {
        const bars = ctxEditableArea.querySelectorAll(`.${className}`);
        bars.forEach((bar) => bar.remove());
    }

    function highlightDropTarget(target) {
        clearDropHighlights();

        target.classList.add(DROP_HIGHLIGHT_CLASS);
    }



    function showInvalidDropFeedback(element) {
        element.classList.add(INVALID_DROP_CLASS);
        setTimeout(() => {
            element.classList.remove(INVALID_DROP_CLASS);
        }, 500);
    }

    function updateDropZones() {
        const elements = ctxEditableArea.querySelectorAll('[builder-element="BlockElement"][istoplevel="true"]');
        elements.forEach((element) => {
            if (element !== draggedElement) {
                element.classList.add(HIGHLIGHT_CLASS);
            } else {
                element.classList.remove(HIGHLIGHT_CLASS);
            }
        });
    }
}


// Attach default context menu listeners
function listenForDefaultContextMenu() {
    if (!iframeDoc || !iframeDoc[0]) {
        console.error("Invalid iframe document provided.");
        return;
    }
    // Long touch handlers
    function longTouchStartHandler(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        isScrolling = false;

        longPressTimer = setTimeout(() => {
            if (!isScrolling) {
                thisEditor.unselect();
                console.log("Long press detected inside TinyMCE editor iframe.");
            }
        }, 300); // Long-press duration
    }

    function longTouchMoveHandler(e) {
        const touchMoveX = e.touches[0].clientX;
        const touchMoveY = e.touches[0].clientY;

        const deltaX = Math.abs(touchMoveX - touchStartX);
        const deltaY = Math.abs(touchMoveY - touchStartY);

        if (deltaX > 10 || deltaY > 10) {
            isScrolling = true;
            clearTimeout(longPressTimer); // Cancel long press if scrolling is detected
        }
    }

    function longTouchEndHandler() {
        clearTimeout(longPressTimer); // Cancel the timer when touch ends
    }

    // Double-click (double-tap) handler
    function doubleClickHandler(e) {
        thisEditor.unselect(); // Perform desired action
    }

    // Attach listeners
    iframeDoc[0]?.addEventListener("touchstart", longTouchStartHandler, { passive: true });
    iframeDoc[0]?.addEventListener("touchmove", longTouchMoveHandler, { passive: true });
    iframeDoc[0]?.addEventListener("touchend", longTouchEndHandler);
    iframeDoc[0]?.addEventListener("dblclick", doubleClickHandler);

    // Store listener references for cleanup
    defaultContextMenuListener.push(
        { target: iframeDoc[0], event: "touchstart", handler: longTouchStartHandler },
        { target: iframeDoc[0], event: "touchmove", handler: longTouchMoveHandler },
        { target: iframeDoc[0], event: "touchend", handler: longTouchEndHandler },
        { target: iframeDoc[0], event: "dblclick", handler: doubleClickHandler }
    );
}

function cleanupDefaultContextMenuListeners() {
    // Ensure defaultContextMenuListener is an array before proceeding
    if (!Array.isArray(defaultContextMenuListener) || defaultContextMenuListener.length === 0) {
        return;
    }

    // Iterate over the stored listeners and remove them safely
    for (let i = 0; i < defaultContextMenuListener.length; i++) {
        const listener = defaultContextMenuListener[i];

        // Ensure listener is valid before accessing properties
        if (!listener || typeof listener !== "object") {
            continue;
        }

        const { target, event, handler } = listener;

        // Ensure target, event, and handler exist before attempting removal
        if (!target || !event || !handler) {
            continue;
        }

        try {
            target.removeEventListener(event, handler);
        } catch (e) {
            // Fail silently to prevent script errors
        }
    }

    // Clear the listener array
    defaultContextMenuListener.length = 0;
}




function integrateCustomCaret() {
    const builderIframe = $("#builder_iframe")[0];
    const $iframeContents = $(builderIframe).contents().find("body");
    const $toxEditArea = $iframeContents.find('.tox-edit-area');
    const $mainTableDiv = iframeDoc.find('#main-table');
    const $mceContentBody = iframeDoc.find('.mce-content-body');

    if ($mainTableDiv.length === 0) {
        console.error('Main table (#main-table) not found!');
        return;
    }

    const createCaretMarker = () => {
        const existingCaretMarker = iframeDoc[0].querySelector('#caretMarker');
        if (existingCaretMarker) {
            //console.log('Removing existing caretMarker:', existingCaretMarker);
            existingCaretMarker.parentNode.removeChild(existingCaretMarker);
        }

        caretMarker = document.createElement('div');
        caretMarker.className = 'caretMarker'; // Adds the class
        caretMarker.id = 'caretMarker';       // Sets the id
        //document.addEventListener('focusin', handleFocusIn);
        $mceContentBody[0].appendChild(caretMarker);
    };

    createCaretMarker();

    const toggleCaretVisibility = (useCustomCaret, range) => {
        if (useCustomCaret) {
            const containerElement = range.startContainer.nodeType === Node.TEXT_NODE
                ? range.startContainer.parentNode
                : range.startContainer;
            const computedStyle = window.getComputedStyle(containerElement);
            const fontSize = parseFloat(computedStyle.fontSize) || 16; // Default to 16px if font-size is not available
            caretMarker.style.height = `${fontSize + 4}px`; // Set height to font-size
            caretMarker.style.display = 'block';
            caretMarker.style.backgroundColor = updateCaretColor(range);
            setCustomTimeout(() => {
                $mceContentBody.css('caret-color', 'transparent'); // Show default caret
            }, 50);
        } else {
            setCustomTimeout(() => {
                caretMarker.style.display = 'none';
                $mceContentBody.css('caret-color', updateCaretColor(range)); // Show default caret
            }, 50);
        }
    };

    const updateCaretColor = (range) => {
        if (!range) return;
        const containerElement = range.startContainer.parentNode;
        if (containerElement) {
            const computedStyle = window.getComputedStyle(containerElement);
            const textColor = computedStyle.color || 'red'; // Fallback to red if no color is found
            return textColor;
        }
    };

    const updateCaretPosition = debounce((event, isEnterPressed = false) => {
        event?.preventDefault();
        event?.stopImmediatePropagation();
        event?.stopPropagation();
        const selection = iframeDoc[0].getSelection();

        if (selection && selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);


            if (isEnterPressed) {
                toggleCaretVisibility(false, range);
                return;
            }
            if (!selection.rangeCount) {
                console.log('Selection Not in range');
                return;
            }

            const rect = range.getBoundingClientRect();

            if (rect) {
                // console.log(`[${Date.now()}] Rect Position:`, {
                //     left: rect.left,
                //     top: rect.top,
                //     x: rect.x,
                //     y: rect.y
                // });
                if (rect.x === 0 || rect.y === 0) {
                    toggleCaretVisibility(false, range);
                    return;
                }
                const toxEditAreaLeft = $toxEditArea.offset().left || 0;

                const caretX = defaultScaleFactor < 1.0
                    ? rect.left / defaultScaleFactor + toxEditAreaLeft + 12
                    : rect.left / defaultScaleFactor;
                const caretY = rect.top / defaultScaleFactor;

                cachedCaretPosition = { x: caretX, y: caretY };

                // Query the caretMarker by ID to ensure we have the correct reference
                // const currentCaretMarker = iframeDoc[0].getElementById('caretMarker');
                // if (!currentCaretMarker) {
                //     console.error('Caret marker not found in DOM. Recreating it.');
                //     createCaretMarker();
                // }

                const containerElement = range.startContainer.parentNode;
                const containerStyles = iframeDoc[0].defaultView.getComputedStyle(containerElement);
                const lineHeight = parseFloat(containerStyles.lineHeight) || containerElement.offsetHeight;

                Object.assign(caretMarker.style, {
                    left: `${caretX}px`,
                    top: `${caretY}px`,
                    height: `${lineHeight}px`,
                });
                toggleCaretVisibility(defaultScaleFactor < 1.0, range);
            } else {
                console.log('No rectange');
            }
        } else {
            thisEditor.hideCustomCaret();
            thisEditor.unselect();
        }
    }, 30); // Debounce delay set to 30ms


    const handleKeyDown = (event) => {
        updateCaretPosition(event, false);
    };

    const maintainCaret = () => {
        // toggleCaretVisibility(defaultScaleFactor < 1.0);
    };

    const onOrientationChange = () => {
        console.log('Orientation changed.');
        thisEditor.scrollToTopRecursively(iframeDoc[0]);

        const selection = iframeDoc[0].getSelection();
        let cachedCaretX = 0;
        let cachedCaretY = 0;

        if (selection.rangeCount) {
            const range = selection.getRangeAt(0);
            const rect = range.getBoundingClientRect();
            cachedCaretX = rect.left;
            cachedCaretY = rect.top;
        } else {
            console.warn('No selection range available to cache position.');
        }

        defaultScaleFactor = window.innerWidth / 1021;
        const previousScaleFactor = defaultScaleFactor;

        setCustomTimeout(() => {
            const zoomLevel = window.visualViewport ? window.visualViewport.scale : window.devicePixelRatio || 1;
            const newScaleFactor = window.innerWidth / 1021 * zoomLevel;

            defaultScaleFactor = newScaleFactor;
            thisEditor.scaleToSize(newScaleFactor);

            if (cachedCaretX && cachedCaretY) {
                const scaleRatio = newScaleFactor / previousScaleFactor;
                let adjustedCaretX = cachedCaretX * scaleRatio;
                let adjustedCaretY = cachedCaretY * scaleRatio;

                const editorOffset = $toxEditArea.offset();
                if (editorOffset) {
                    adjustedCaretX += editorOffset.left;
                    adjustedCaretY += editorOffset.top;
                }

                Object.assign(caretMarker.style, {
                    left: `${adjustedCaretX}px`,
                    top: `${adjustedCaretY}px`,
                });
            }
        }, 300);
    };

    const resetCaretPosition = () => {
        caretMarker = iframeDoc[0].getElementById('caretMarker');
    };


    const debouncedUpdateCaretPosition = debounce(updateCaretPosition, 30); // Adjust
    const debouncedMaintainCaret = debounce(maintainCaret, 30);
    const debouncedOrientationChange = debounce(onOrientationChange, 100);
    const activeEvents = new Set(); // To track currently active events
    const eventCooldownTime = 100; // Adjust cooldown time as needed (in ms)

    // Filter event wrapper
    const filterEvent = (handler, eventName) => {
        return (event) => {
            if (activeEvents.has(eventName)) {
                // Event is already being handled, skip
                return;
            }
            activeEvents.add(eventName); // Mark event as active
            try {
                handler(event); // Call the actual event handler
            } finally {
                setCustomTimeout(() => {
                    activeEvents.delete(eventName); // Remove event from active set after cooldown
                }, eventCooldownTime);
            }
        };
    };

    caretListeners.push(
        { target: iframeDoc, events: 'selectionchange input mouseup touchend touchstart', handler: filterEvent(debouncedUpdateCaretPosition, 'caret-update') },
        { target: $mceContentBody, events: 'focus', handler: filterEvent(debouncedUpdateCaretPosition, 'caret-focus') },
        { target: $mainTableDiv, events: 'scroll', handler: filterEvent(debouncedUpdateCaretPosition, 'caret-scroll') },
        // { target: iframeDoc, events: 'touchstart', handler: filterEvent(debouncedMaintainCaret, 'caret-touchstart') },
        //  { target: iframeDoc, events: 'mousedown', handler: filterEvent(debouncedMaintainCaret, 'caret-mousedown') },
        { target: iframeDoc[0], events: 'keydown', handler: filterEvent(handleKeyDown, 'caret-keydown') },
        { target: window, events: 'orientationchange', handler: filterEvent(debouncedOrientationChange, 'caret-orientationchange') }
    );


    caretListeners.forEach(({ target, events, handler }) => {
        if (typeof target.on === 'function') {
            target.on(events, handler);
        } else if (typeof target.addEventListener === 'function') {
            events.split(' ').forEach(event => target.addEventListener(event, handler));
        }
    });

    return { updateCaretPosition };
}

const handleFocusIn = (e) => {
    if (e.target.isContentEditable) {
        e.preventDefault();
    }
};


function cleanupCustomCaretListeners() {
    if (caretListeners) {
        caretListeners.forEach(listener => {
            if (typeof listener.target.off === 'function') {
                listener.target.off(listener.events, listener.handler);
                //console.log(`Removed listener from ${listener.target} for events: ${listener.events}`);
            } else if (typeof listener.target.removeEventListener === 'function') {
                listener.events.split(' ').forEach(event => {
                    listener.target.removeEventListener(event, listener.handler);
                    //console.log(`Removed listener for event: ${event} on target:`, listener.target);
                });
            }
        });
    }

    // Clear the caret marker if it exists
    if (caretMarker && caretMarker.parentNode) {
        caretMarker.parentNode.removeChild(caretMarker);
        //console.log("Caret marker removed.");
    }

    // Remove global `focusin` event listener
    // document.removeEventListener('focusin', handleFocusIn);
    //console.log("Global `focusin` event listener removed.");

    // Clear the caretListeners array to prevent memory leaks
    caretListeners = [];
    document.removeEventListener('focusin', handleFocusIn);
    // console.log("Global `focusin` event listener removed.");

    // Nullify references for potential garbage collection
    caretMarker = null;
    cachedCaretPosition = null;
}


//Un comment this function to check for all the event listners attached
(function () {
    window.eventListeners = new Map(); // Attach to window for global access

    // Store original methods
    const originalAddEventListener = EventTarget.prototype.addEventListener;
    const originalRemoveEventListener = EventTarget.prototype.removeEventListener;

    EventTarget.prototype.addEventListener = function (type, listener, options) {
        if (!window.eventListeners.has(this)) window.eventListeners.set(this, []);
        window.eventListeners.get(this).push({ type, listener, options });
        originalAddEventListener.call(this, type, listener, options);
    };

    EventTarget.prototype.removeEventListener = function (type, listener, options) {
        if (window.eventListeners.has(this)) {
            window.eventListeners.set(this, window.eventListeners.get(this).filter(l => l.listener !== listener));
        }
        originalRemoveEventListener.call(this, type, listener, options);
    };

    window.getAllEventListeners = function () {
        console.log("📋 All event listeners:", window.eventListeners);
        return window.eventListeners;
    };

})();


function removeAllEventListeners(batchSize = 100) {
    if (!window.eventListeners || !(window.eventListeners instanceof Map)) {
        return;
    }

    const entries = Array.from(window.eventListeners.entries()); // Convert Map to array
    let totalRemoved = 0;

    for (let i = 0; i < entries.length; i += batchSize) {
        for (let j = i; j < Math.min(i + batchSize, entries.length); j++) {
            const entry = entries[j];

            if (!entry || entry.length < 2) {
                continue; // Skip null or malformed entries
            }

            const [element, listeners] = entry;

            // Skip if `element` is missing or `listeners` is not an array
            if (!element || !listeners || !Array.isArray(listeners) || listeners.length === 0) {
                continue;
            }

            // Ensure the element is still valid (in DOM or a global object)
            if (!(element instanceof Element || element instanceof Document || element instanceof Window)) {
                continue;
            }

            const groupedListeners = new Map(); // Group listeners by event type
            for (let k = 0; k < listeners.length; k++) {
                const listenerObj = listeners[k];

                // Ensure listenerObj is a valid object with type & listener properties
                if (!listenerObj || typeof listenerObj !== "object" || !listenerObj.type || !listenerObj.listener) {
                    continue;
                }

                const { type, listener, options } = listenerObj;
                if (!groupedListeners.has(type)) {
                    groupedListeners.set(type, []);
                }
                groupedListeners.get(type).push({ listener, options });
            }

            // Remove all listeners for each event type
            groupedListeners.forEach((listenerArray, type) => {
                for (let k = 0; k < listenerArray.length; k++) {
                    try {
                        element.removeEventListener(type, listenerArray[k].listener, listenerArray[k].options);
                        totalRemoved++;
                    } catch (e) {
                        // Fail silently if event listener removal fails
                    }
                }
            });
        }
    }

    window.eventListeners.clear(); // Clear the Map after removal
    console.log(`✅ Listeners removed. Total: ${totalRemoved}`);
}






export {
    createElementFromHTML,
    makeid,
    Editor,
    simulateClick
};

